import {
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Switch,
  Button,
  FormControl,
  Select,
  Typography,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  TextareaAutosize,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { v4 as uuidv4 } from "uuid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LocalizationProvider, DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import { loadServices } from "../../../../../../Redux/Actions/CountriesActions";
import {
  loadAddsOn,
  loadUtility,
  getPanleModels,
  getRoofTypsAction,
  getColorRoofing,
} from "../../../../../../Redux/Actions/servicesAction";
import { TotalArea } from "../../../../../../Redux/Actions/solutionsActions";
import { useLocation, useNavigate } from "react-router-dom";
import { singleLeadAction } from "../../../../../../Redux/Actions/singleLeadAction";
import { addSolarAction } from "../../../../../../Redux/Actions/addSolarAction";
import Calc from "../../../../../../components/Calc/Calc";
import { loadSunLightCalc } from "../../../../../../Redux/Actions/CalculatorActions";
import {
  AccountCircle,
  AttachMoney,
  Calculate,
  CheckCircle,
  Email,
  Language,
  LocalPhone,
  LocationOn,
  Map,
  MyLocation,
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Loading from "../../../../../../components/loading/Loading";
import LoadingSoultion from "../../../../../../components/loading/loadingSolution";
import CostEstemation from "./CostEstemation";
import SystemDesign from "../../../../../../components/SystemDesign/SystemDesign";
import CalcGoodLeadp from "../../../../../../components/Calc/CalcGoodLeap";
import { goodLeapCalc } from "../../../../../../Redux/Actions/goodLeapAction";
/*----------------google-Geocoding---------------*/
import Geocode from "react-geocode";
import swal from "sweetalert";
import {
  DivFrame,
  ShowFrameBtn,
  Table,
  TableContainer,
} from "./SolarFormStyle";
import { getInstallerAdderById } from "../../../../../../Redux/Actions/AddersAction";
import Mosiac from "../../../../../../components/Calc/Mosiac";
import Concert from "../../../../../../components/Calc/Concert";
import {
  GetAllInstallers,
  GetSingleInstallerData,
} from "../../../../../../Redux/Actions/addInstallerAction";
import InstallerMaps from "./InstallerMaps";
import FakeCalc from "../../../../../../components/Calc/fakeCalc";
import { formatPhoneNumber } from "../../../../../newProposal/components/userData/func";
import enfinImg from "../../../../../../assets/enfin.png";
import Enfin from "../../../../../../components/Calc/enfin";
import { useGetSalesAddersQuery } from "../../../../../../Redux/toolKit/salesAdders";
import { useGetTemplatesQuery } from "../../../../../../Redux/toolKit/template";
import {
  FormConatiner,
  SolarHeading,
  UserData,
  ClacButton,
  ButtonContainer,
  LoadingContainer,
  PrettoSlider,
  ColorRoofing,
  CalcSunLightData,
  ModelConatiner,
} from "./style";
import LeadData from "../../../../../../pages/newProposal/components/userData";
/* --------- start outside drop list ----------- */

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "1rem",
  boxShadow: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: 4,
};
const styleHvac = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflow: "scroll",
  // height: "90%",
  display: "block",
};

const installationTypes = [
  { name: "New System", value: "new_system" },
  { name: "Upgrade Existing System", value: "upgrade_existing_system" },
];

const roofMaterials = [
  { name: "Choose Roof Materials", value: "none" },
  { name: "Shingle", value: "shingle" },
  { name: "Spanish Tile", value: "spanish_tile" },
  { name: "Concrete Flat", value: "concrete_flat" },
  { name: "Flat Torch Down", value: "flat_torch_down" },
  { name: "Standing Seam Metal", value: "standing_seam_metal" },
  { name: "Presidential", value: "presidential" },
  { name: "Flat Tile", value: "flat_tile" },
  { name: "Foam", value: "foam" },
];

const shadings = [
  { name: "No Shade", value: "no_shades" },
  { name: "Partial Shade", value: "partial_shade" },
  { name: "Lots of Shade", value: "lots_of_shade" },
];
const jobTypes = [
  { name: "Roof Mount", value: "roof_mount" },
  { name: "Ground Mount", value: "ground_mount" },
  { name: "Car Port", value: "car_port" },
  { name: "Detached Garage", value: "detached_garage" },
];
const inverterTypes = [
  { name: "Solaredge", value: "solar_edge" },
  { name: "Enphase iq7", value: "enphase_iq7" },
  { name: "Enphase iq8", value: "enphase_iq8" },
  { name: "SPS inverter", value: "sps_inverter" },
];
const panelWattages = [
  { name: "365", value: "365" },
  { name: "380", value: "380" },
  { name: "400", value: "400" },
];

const panelModals = [
  { name: "FAM_E7G-BB / 120 cells", value: "FAM_E7G-BB / 120 cells " },
  { name: "Silfab NU Series SIL-400 NU", value: "Silfab NU Series SIL-400 NU" },
  { name: "Q-peak  Duo BLKML-G10", value: "Q-peak  Duo BLKML-G10" },
];
const electricalPanels = [
  { name: "50A", value: "50" },
  { name: "75A", value: "75" },
  { name: "100A", value: "100" },
  { name: "125A", value: "125" },
  { name: "175A", value: "175" },
  { name: "200A", value: "200" },
];
const UpgradPanles = [
  { name: "No Upgrade Needed", value: "0" },
  { name: "100A", value: 100 },
  { name: "125A", value: 125 },
  { name: "175A", value: 175 },
  { name: "200A", value: 200 },
];

const AirVents = [
  { name: "Exchange", value: "exchange" },
  { name: "New", value: "new" },
];
const hvacLocations = [
  { name: "Same Location", value: "same_location" },
  { name: "New Location Electrical", value: "new_location_electrical" },
  { name: "New Location Plumbing", value: "new_location_plumbing" },
  { name: "Roof Unit", value: "roof_unit" },
];

const hvacHorsePower = [
  { name: "2 TON ", value: "2_ton" },
  { name: "3 TON", value: "3_ton" },
  { name: "4 TON", value: "4_ton" },
  { name: "4 TON Split", value: "4_ton_split" },
  { name: "5 TON", value: "5_ton" },
];
const betteryPower = [
  // { name: "3KwH", value: "3KwH" },
  { name: "10KwH", value: "10KwH" },
];
const generatorPower = [
  { name: "BLUETTI 5KwH", value: "5KwH" },
  { name: "BLUETTI 10KwH", value: "10KwH" },
];
const Warranties = [
  { name: "Standard", value: "standard" },
  { name: "Premium", value: "premium" },
];

const SolarFormProposals = ({ id }) => {
  const { data: salesAdders, isLoading: salesAddersLoading } =
    useGetSalesAddersQuery("");
  const { data: salesTemplates, isLoading: salesTemplatesLoading } =
    useGetTemplatesQuery("");
  // console.log("salesTemplates", salesTemplates);
  const location = useLocation();
  const leadId = Number(location.pathname.split("/")[3]);
  const serviceID = Number(location.pathname.split("/")[4]);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { singlead, isSingleLeadLoading } = useSelector((state) => state.leads);
  const { productMethods, createOffer, concertPayments, concertAllData } =
    useSelector((state) => state.Concert);
  // console.log("concertPayments", concertPayments);
  const { calculator, info } = useSelector((state) => state.calc);
  console.log("INfooooooooooooooooooooooo", info);
  const { enfinData } = useSelector((state) => state.myFormData);
  // console.log("infoinfoinfoinfo", info);
  const adders = useSelector((state) => state.Adders);
  const allAdders = adders?.adders?.data?.adders;
  // console.log("allAdders Soalr Form", allAdders);
  const dataAarea = useSelector((state) => state.proposal.totalArea);
  const { isLoading, isSuccess, isError, screenShot } = useSelector(
    (state) => state.proposal
  );
  const { allOffers, payments, allMosiacData } = useSelector(
    (state) => state.Mosiac
  );

  const theOfferMosiac = allOffers?.find(
    (e) => e.id == allMosiacData?.finance_product_id
  );
  const {
    utilities,
    isUtility,
    Panels,
    isPanle,
    isRoof,
    roofTyps,
    isColor,
    colors,
  } = useSelector((state) => state.services);
  // console.log("roofTyps", roofTyps);
  const { all_roofing } = useSelector((state) => state.proposal);
  const { all_Adders } = useSelector((state) => state.proposal);
  const defaultPanel = Panels.find((e) => e.is_default === 1);
  // Main State
  const [value, setValue] = useState({
    lead_id: leadId,
    service_type_id: serviceID,
    opportunity_date_time: new Date(),
    is_any_non_permitted_structures: false,
    sub_service_id: "1",
    installation_type: "new_system",
    utility_provider_id: "",
    annual_kwh_usage: "",
    avg_monthly_bill: "0",
    avg_annual_bill: "",
    monthly_cost: "",
    roof_materials: "none",
    shading: "no_shades",
    panels: "",
    panel_wattage: "",
    // panel_price: "",
    add_on_id: "0",
    is_add_on: false,
    number_of_solar_arrays: "0",
    number_of_conduit_arrays: "0",
    job_type: "roof_mount",
    is_reverse_tilt: false,
    is_north_faced: false,
    two_story_home: false,
    inverter_type: "",
    royalties: "",
    is_online_monitoring: true,
    no_of_ft_from_main_service: "0",
    how_many_ft_trench_dirt: 1,
    how_many_ft_trench_concrete: "0",
    slope_degree: "0",
    digging_slope: false,
    is_separate_electrical_meter: false,
    is_electric_work_currently_on_garage: false,
    is_sub_panel_on_detached_garage: false,
    is_finance: false,
    is_attic: false,
    is_standalone_roof_mount: false,
    existing_electrical_panel: "100",
    upgrade_electrical_panel: "0",
    is_stucco: false,
    is_de_rate: false,
    is_mpu_relocation: false,
    is_more_than_3ft: true,
    number_of_mpu_relocation_foot: "0",
    is_sub_panel: false,
    is_meter_socket: false,
    is_ev_charger: false,
    is_ev_mlo: false,
    is_roof_overlay: false,
    is_re_roofing: false,
    is_roof_relay: false,
    is_re_roof_shingle: false,
    is_re_roof_tear_off: false,
    is_re_roof_presidential: false,
    is_re_roof_spanish_tiles: false,
    is_re_roof_flat_tiles: false,
    is_re_roof_re_decking: false,
    is_re_roof_fascia_board: false,
    is_air_vent: false,
    is_rafter_exchange: false,
    air_vent: "0",
    number_of_vents: "0",
    is_steep_roof: false,
    is_double_hand: false,
    is_smoke_detectors: false,
    is_warranty_extend: false,
    is_hvac: false,
    hvac_location: "0",
    hvac_horse_power: "0",
    is_ducting: false,
    number_of_ducting_run: "0",
    number_hvac_ft: "0",
    is_led_lighting: false,
    number_of_led_lighting: "0",
    is_energy_efficient_plugs: false,
    number_of_efficient_plugs: "0",
    is_solar_lip: false,
    number_of_solar_lip: "0",
    is_bird_netting: false,
    number_of_bird_netting: "0",
    is_battery: false,
    battery_power: "0",
    how_many_digging_ft: "0",
    number_of_layers: "0",
    number_of_feet: "0",
    number_of_smoke_detectors: "0",
    number_of_re_roof_squares: "0",
    number_of_batteries: "0",
    is_warranty_package: false,
    warranty: "0",
    is_trenching_dirt: false,
    is_trenching_concrete: false,
    is_steep: false,
    rate: 0,
    is_design: false,
    number_of_designated_plugs: 1,
    showButton: true,
    //start roofing
    is_roofing: false,
    roof_job_type_id: "",
    existing_roof_material_id: "",
    roof_plan_roof_material_id: "",
    number_of_old_layers: 1,
    // number_of_old_squares: 1,
    number_of_old_squares: 1,
    number_of_steep_sq: 1,
    new_roof_material_id: "",
    number_of_new_layers: 1,
    number_of_new_squares: 1,
    color_id: "",
    new_color_cost: 0,
    is_roof_planes: false,
    number_of_planes_squares: 1,
    number_of_planes_layers: 1,
    is_redecking: false,
    number_of_redecking_squares: 0,
    is_rafter: false,
    number_of_rafter_ft: 0,
    is_fascia: false,
    number_of_fascia_ft: 0,
    is_steep_pitch: false,
    roof_pitch_degree: 0,
    is_hvac_replace: false,
    number_of_hvac_units: 0,
    is_air_vent_replacement: false,
    number_of_replaced_vents: 0,
    is_new_vent: false,
    number_of_new_vents: 0,
    is_smoke_monitors: false,
    number_of_smoke_monitors: 0,
    is_double_hands: false,
    number_of_double_hand_squares: 0,
    is_monoxide_detectors: false,
    number_of_monoxide_detectors: 0,
    added_cost: 0,
    royalties_cost: 0,
    notes: "",
    tile_relay_no_of_squares: 1,
    overlay_no_of_squares: 1,
    add_work_description: "",
    add_job_type_for_roof_tile: false,
    roof_job_type_id_roof_planes: "",
    overlay_material_id_for_add_roof_planes: "",
    overlay_no_of_squares_for_add_roof_planes: 1,
    number_of_planes_squares_for_add_planes: 1,
    tile_relay_no_of_squares_for_add_roof_planes: 1,
    number_of_steep_sq_for_roof_planes: 1,
    is_sky_light: false,
    // System Design
    roof_area: 0,
    aerial_photo: "",
    financial_institution: "",
    tile_relay_no_of_squares_for_add_roof_planes_tile_relay: 1,
    number_of_planes_squares_for_add_planes_tile_relay: 1,
    overlay_no_of_squares_for_add_roof_planes_overlay: 1,
    number_of_hvacs: 1,
    is_insurance: false,
    date: "2017-05-24",
  });
  const [open, setOpen] = useState(true);
  const [openSunLight, setOpenSunLight] = useState(false);
  const handleOpen = () => {
    setOpenSunLight(true);
  };
  // Add Hvac
  const [openHvac, setOpenHvac] = React.useState(false);
  const handleOpenHvac = () => setOpenHvac(true);
  const handleCloseHvac = () => setOpenHvac(false);
  const [hvacs, setHvacs] = React.useState([]);
  const [singleHvac, setSignleHvac] = React.useState();
  // Add Battery
  const [openBattery, setOpenBattery] = React.useState(false);
  const handleOpenBattery = () => setOpenBattery(true);
  const handleCloseBattery = () => setOpenBattery(false);
  const [batteries, setBatteries] = React.useState([]);
  const [singleBattery, setSignleBattery] = React.useState();
  // Add Generator
  const [openGenerator, setOpenGenerator] = React.useState(false);
  const handleOpenGenerator = () => setOpenGenerator(true);
  const handleCloseGenerator = () => setOpenGenerator(false);
  const [generators, setGenerators] = React.useState([]);
  const [singleGenerator, setSignleGenerator] = React.useState();
  const [insurance, setInurance] = React.useState();
  // start a new toggle calculator
  const [openCalc, setOpenCalc] = useState(false);
  const [offset, setOffset] = useState("");
  const [coordinates, setCoordinates] = React.useState({
    lat: "",
    lng: "",
  });
  const [showFrame, setShowFrame] = React.useState(false);
  const [roofingPrices, setRoofingPricrs] = React.useState();

  React.useEffect(() => {
    if (hvacs.length < 1) {
      setValue({ ...value, is_hvac: false });
    }
  }, [hvacs]);
  const AddHvac = async () => {
    await setHvacs((preResult) => [
      ...preResult,
      {
        hvac_location: singleHvac?.hvac_location,
        number_hvac_ft: singleHvac?.number_hvac_ft,
        hvac_horse_power: singleHvac?.hvac_horse_power,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_hvac: true,
    });
    await setSignleHvac(null);
    await handleCloseHvac();
  };
  const AddBattery = async () => {
    await setBatteries((preResult) => [
      ...preResult,
      {
        battery_power: singleBattery?.battery_power,
        number_of_batteries: singleBattery?.number_of_batteries,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_battery: true,
    });
    await setSignleBattery(null);
    await handleCloseBattery();
  };
  React.useEffect(() => {
    if (batteries.length < 1) {
      setValue({ ...value, is_battery: false });
    }
  }, [batteries]);
  React.useEffect(() => {
    if (value.installer) dispatch(GetSingleInstallerData(value.installer));
  }, [value.installer]);
  React.useEffect(() => {
    setValue({ ...value, rate: singleUtile?.rate });
  }, [singleUtile]);
  useEffect(() => {
    dispatch(loadServices());
    // dispatch(loadSubServices(id));
    dispatch(singleLeadAction(leadId));
    dispatch(loadAddsOn(id));
    // dispatch(loadSunLightCalc());
    dispatch(getPanleModels());
    dispatch(getRoofTypsAction());
    dispatch(TotalArea());
    dispatch(goodLeapCalc());
    dispatch(getInstallerAdderById(32));
    dispatch(GetAllInstallers());
    // map();
  }, []);
  React.useEffect(() => {
    dispatch(loadSunLightCalc(singlead?.state?.name));
  }, [singlead?.state?.name]);
  React.useEffect(() => {
    if (value.overlay_layers > 2) {
      swal({
        title: "Watch Out!",
        text: "You need to do Reroofing!",
        icon: "warning",
        button: "Ok",
      });
    }
  }, [value.overlay_layers]);
  useEffect(() => {
    // const ShingleColor = value.existing_roof_material_id;
    if (value.new_roof_material_id) {
      dispatch(getColorRoofing(value.new_roof_material_id));
    }
  }, [value.new_roof_material_id]);
  React.useEffect(() => {
    setValue({
      ...value,
      number_of_old_squares: Math.ceil(dataAarea / 100 + 1),
    });
  }, [dataAarea]);
  React.useEffect(() => {
    setValue({ ...value, panels: defaultPanel?.id });
  }, [defaultPanel, Panels]);
  useEffect(() => {
    if (singlead?.state?.id === 3924) {
      setValue({ ...value, inverter_type: 4 });
    }
  }, [singlead]);
  // console.log("singlead?.state?.name", singlead?.state);
  const AddGenerator = async () => {
    await setGenerators((preResult) => [
      ...preResult,
      {
        generator_power: singleGenerator?.generator_power,
        number_of_generators: singleGenerator?.number_of_generators,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_generator: true,
    });
    await setSignleGenerator(null);
    await handleCloseGenerator();
  };
  useEffect(() => {
    if (singlead) dispatch(loadUtility(utilityID));
  }, [singlead]);

  const RoofJobsTypes = roofTyps?.roof_job_types;
  const ExistingRoofing = roofTyps?.roof_existing_materials;
  const NewRoofJobTypes = roofTyps?.roof_new_materials;
  const TileRelayMatrial = roofTyps?.tile_relay_materials || [];
  const RoofOverlayMatrials = roofTyps?.roof_overlay_materials;
  const dynamicInverters = roofTyps?.inverters || [];
  // console.log("dynamicInverters", dynamicInverters);
  const UtilityProviders = utilities.utility_providers;
  // get panel from utiltites
  const PanelModelList = utilities.panels;
  //start utility depdancy
  var UtilityID = value.utility_provider_id;
  var singleUtile = UtilityProviders?.find((item) => item.id == UtilityID);
  React.useEffect(() => {
    value.rate = singleUtile?.rate;
  }, [singleUtile]);
  // console.log("setInurancesetInurancesetInurance in Parent",insurance)
  //-------------------------------------//
  // const [myDate, setMyDate] = useState(new Date());
  //state for solar panels wattegae

  // console.log("Solaaaaaaaaaaar Form all_Adders", all_Adders);
  // console.log("screenShot other component", screenShot);

  const { sunlightCalc, isCalc, totalAmount } = useSelector(
    (state) => state.calc
  );
  /*---------------Installers------------------*/
  const { allInstallers, singleINstallerData } = useSelector(
    (state) => state.installerReducer
  );
  /*-----------------GoodLeap---------------------*/
  const allDataGoodLeap = useSelector(
    (state) => state.GoodLeapReducer.allGoodLeap
  );
  const allGoodLeapOffers =
    useSelector((state) => state.GoodLeapReducer.allOffers) || [];
  const getThePayment =
    useSelector((state) => state.GoodLeapReducer.payment) || [];
  var resultFromPayment = [];

  // Get The All Result From GoodLeap
  getThePayment.map((e) => {
    resultFromPayment = e;
  });
  // Get The Calculation Form GoodLeap
  var resultFromPaymentCalc = [];
  getThePayment.map((e) => {
    resultFromPaymentCalc = e.calculations;
  });
  // Get The Term Year
  const TheOffer = allGoodLeapOffers?.find(
    (e) => e.id == getThePayment[0]?.offerId
  );
  // console.log("allDataGoodLeap allDataGoodLeap allDataGoodLeap", allDataGoodLeap);
  const utilityID = singlead?.state_id;
  const theUserLocation = singlead?.location;
  const StatName = singlead?.state?.abbr;

  // console.log("singlead",singlead)
  // get the roofing data
  // const { subServices, add_ons } = useSelector((state) => state.services);
  // const { add_ons } = useSelector((state) => state.services);

  // -------get the calc info -----------

  const YEAR_DATA = info?.term;
  const FINAL_MONTH_PAY = calculator.finalMonthlyPayment;
  const FINAL_ESC_MONTH_PAY = calculator.finalEscalatedMonthlyPayment;
  const MONTH_PAY = calculator.monthlyPayment;
  const ESC_MONTH_PAY = calculator.escalatedMonthlyPayment;
  const PAYDOWN_PERCENTAGE = calculator.paydownPercentage;
  const ALTERNATE_MONTH_PAY = calculator.alternateMonthlyPayment;

  /*------- statr for reset calc ----------*/
  // const [monthPay, setMonthPay] = useState();

  /* --------- useEffect to get sigle Lead */

  // console.log("panel",value.panel)
  // console.log(
  //   "value financial_institution financial_institution financial_institution",
  //   value.financial_institution
  // );

  // start  old JOB Type Object  Data
  const RoofJobsTypesObject = RoofJobsTypes?.find(
    (e) => e.id === value.roof_job_type_id
  );
  // console.log("RoofJobsTypesObject", RoofJobsTypesObject);
  // add planes new job type
  const RoofJobsForAddPlanes = RoofJobsTypes?.find(
    (e) => e.id === value.roof_job_type_id_roof_planes
  );
  // job type for add roof planes for tile relay
  const jobTypeForRoofTileRealy = RoofJobsTypes?.find(
    (e) => e.id === value.add_roof_planes_job_type_id_for_roof_tile
  );
  // job type for add roof planes for roof overlay
  const jobTypeForRoofRoofOverlay = RoofJobsTypes?.find(
    (e) => e.id === value.add_roof_planes_job_type_id_for_roof_overlay
  );
  // console.log("Value", value);
  // console.log(
  //   "jobTypeForRoofRoofOverlay jobTypeForRoofRoofOverlay jobTypeForRoofRoofOverlay",
  //   jobTypeForRoofRoofOverlay
  // );
  // get Tile Relay data

  const TileRelayMaterial = TileRelayMatrial.find(
    (e) => e.id === value.tile_relay_material_id
  );
  // console.log("TileRelayMatrial check for array", TileRelayMaterial);

  // Tile Relay For add Roof Planes Tile Relay
  const TileRelayForAddRoofPlanesTileRelay = TileRelayMatrial?.find(
    (e) => e.id === value.tile_relay_material_id_for_add_roof_planes_tile_relay
  );
  // Tile Relay For add Roof Planes
  const TileRelayForAddRoofPlanes = TileRelayMatrial?.find(
    (e) => e.id === value.tile_relay_material_id_for_add_roof_planes
  );
  // Overlay Roof For add Roof Planes
  const RoofOverLayForAddRoofPlanes = RoofOverlayMatrials?.find(
    (e) => e.id === value.overlay_material_id_for_add_roof_planes
  );
  // Re Roofing Material for Add Planes Tile Relay
  const ReRoofingMaterialForAddPlanesTileRelay = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes_tile_relay
  );
  // Re Roofing Material for Add Planes Roof Overlay
  const ReRoofingMaterialForAddPlanesRoofOverlay = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes_roof_overlay
  );
  // start  old exisiting e Object  Data
  const ExistingRoofingObject = ExistingRoofing?.find(
    (e) => e.id === value.existing_roof_material_id
  );

  // start  old JOB Type Object  Data
  const NewRoofJobTypesObject = NewRoofJobTypes?.find(
    (e) => e.id === value.new_roof_material_id
  );
  // object color in roofing
  const colorObject = colors?.find((e) => e.id === value.color_id);
  // new Roofing Overlay Material
  const newRooginOverLay = NewRoofJobTypes?.filter(
    (e) => e.id === 1 || e.id === 2 || e.id === 3
  );
  const overlayNewMaterial = NewRoofJobTypes?.find(
    (e) => e.id === value.overlay_new_roof_material_id
  );
  const overlayNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.overlay_planes_new_roof_material_id
  );
  const tileRelayNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.tileRelay_overlay_new_roof_material_id
  );
  const reroofNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.reroof_overlay_new_roof_material_id
  );
  // get Tile Relay data
  // const TileRelayMaterial = TileRelayMatrial.find(
  //   (e) => e.id === value.tile_relay_material_id
  // );

  const TileRelayForAddRoofPlanesOverLay = TileRelayMatrial?.find(
    (e) =>
      e.id === value.tile_relay_material_id_for_add_roof_planes_roof_overlay
  );

  // Set The initial value for value.rate

  // start math for offset
  const NumberOfPanelsNeeded = Math.ceil(
    value.annual_kwh_usage / 365 / 4.2 / (value.panel_wattage / 1000)
  );
  // new Roof plan matrial
  const NewRoofPlanMatrial = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id
  );
  // new Roof plan matrial of add planes
  const NewRoofPlanMatrialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.new_planes_material_id
  );
  // Re Roofing Material for Add Planes
  const ReRoofingMaterialForAddPlanes = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes
  );

  const TotalPanle =
    NumberOfPanelsNeeded + Number(value.number_of_solar_arrays);
  const SystemSize = TotalPanle * value.panel_wattage;
  const AnnualPrduction = (SystemSize / 1000) * 365 * 4.2;
  const OffsetPercentage = Math.ceil(
    (AnnualPrduction / value.annual_kwh_usage) * 100
  );

  // start cost math for sealer
  const AC_Ratio = AnnualPrduction * 0.14;
  const SystemOutput_AC = AnnualPrduction - AC_Ratio;

  // get the single panel
  const PanelID = value?.panels;
  const SinglePanel = Panels?.find((el) => el?.id == PanelID);
  const DataApi = {
    panel_price: SinglePanel?.price,
    apr: info.apr,
    loan_years: YEAR_DATA || 25,
    monthlyPayment: MONTH_PAY,
    finalMonthlyPayment: FINAL_MONTH_PAY,
    finalEscalatedMonthlyPayment: FINAL_ESC_MONTH_PAY,
    escalatedMonthlyPayment: ESC_MONTH_PAY,
    // apr: TheOffer?.rate,
    sl_dealer_fee: info.dealer_fee,
    sl_deposit: info?.deposit,
    loan_amount: totalAmount || 0,
    annual_increases_percentage: singleUtile?.annual_increase_percentage,
    // loan_years: TheOffer?.term || 25,
    // finalMonthlyPayment: resultFromPaymentCalc[0]?.roundedAmount?.value,
    // finalEscalatedMonthlyPayment:
    // resultFromPaymentCalc[1]?.roundedAmount?.value,
    // monthlyPayment: resultFromPaymentCalc[0]?.roundedAmount?.value,
    // escalatedMonthlyPayment: resultFromPaymentCalc[1]?.roundedAmount?.value,
    paydownPercentage: PAYDOWN_PERCENTAGE,
    alternateMonthlyPayment: ALTERNATE_MONTH_PAY,
  };
  const OfferData = allGoodLeapOffers?.find(
    (e) => e.id == allDataGoodLeap?.offers[0]
  );
  // console.log("allInstallers", allInstallers);
  const goodleapOfferId = allDataGoodLeap?.offers || [];
  var id = "";
  goodleapOfferId.map((e) => {
    id = e;
  });
  // console.log("allOffers", allOffers);
  const good_leap_promotion = allDataGoodLeap?.promotion || [];
  const goodLeapData = {
    offer_id: id,
    paydown_amount: allDataGoodLeap?.extraPaydownAmount,
    paydown_percent: allDataGoodLeap?.extraPaydownPercent / 100,
    category_id: allDataGoodLeap?.category,
    gl_dealer_fee: OfferData?.dealerFee,
    gl_rate: OfferData?.rate,
    gl_term: OfferData?.term,
    gl_promotion_id: good_leap_promotion[0],
  };
  // console.log("goodLeapData", goodLeapData);

  const mosiacData = {
    mosaic_finance_product_id: allMosiacData?.finance_product_id,
    mosaic_financing_product_type: payments?.financingProductType,
    mosaic_total_periods: payments?.totalPeriods,
    mosaic_rate: payments?.rate,
    mosaic_rate_without_ach_discount: payments?.rateWithoutAchDiscount,
    mosaic_dealer_fee: payments?.dealerFee,
    mosaic_monthly_payments: payments?.monthlyPayments,
    mosaic_is_ach: +allMosiacData?.mosaic_is_ach,
    mosaic_monthly_payments_with_prepayment:
      payments?.monthlyPaymentsWithPrePayment,
    mosaic_prepayment_amount: payments?.prePaymentAmount,
  };

  const concertData = {
    concert_apr: concertAllData?.apr,
    concert_deferral_months: concertAllData?.deferral_months,
    concert_loan_type: concertAllData?.loan_type,
    concert_term: concertAllData?.term,
    concert_pre_payment_percent: concertAllData?.pre_payment_percent,
    concert_dealer_fee: concertAllData?.concert_dealer_fee,
  };

  // console.log("concertData", concertData);
  // console.log("concertAllData", concertAllData);

  let sendHvacs = {
    hvacs: hvacs,
  };
  let sendBatteries = {
    batteries: batteries,
  };
  let sendInurance = {
    insurance: insurance,
  };
  let sendGenerators = {
    generators: generators,
  };
  // console.log("roofingPrices", roofingPrices);
  let prices = {
    redecking_cost: value?.is_redecking
      ? allAdders?.redecking?.pivot?.price * value?.number_of_redecking_squares
      : 0,
    rafter_cost: value.is_rafter
      ? allAdders?.rafter?.pivot?.price * value.number_of_rafter_ft
      : 0,
    fascia_cost: value.is_fascia
      ? allAdders?.fascia?.pivot?.price * value.number_of_fascia_ft
      : 0,
    hvac_replace_cost: value.is_hvac_replace
      ? allAdders?.hvac_replace?.pivot?.price * value.number_of_hvac_units
      : 0,
    air_vent_replacement_cost: value?.is_air_vent_replacement
      ? allAdders?.air_vent_replacement?.pivot?.price *
        value.number_of_replaced_vents
      : 0,
    new_vent_cost: value?.is_new_vent
      ? allAdders?.new_air_vent?.pivot?.price * value?.number_of_new_vents
      : 0,
    smoke_monitors_cost: value?.is_smoke_monitors
      ? allAdders?.smoke_monitors?.pivot?.price * value.number_of_smoke_monitors
      : 0,
    double_hands_cost: value?.is_double_hands
      ? allAdders?.double_hand?.pivot?.price *
        value.number_of_double_hand_squares
      : 0,
    monoxide_detectors_cost: value.is_monoxide_detectors
      ? allAdders?.monoxide_detectors?.pivot?.price
      : 0,
    job_type_cost:
      all_roofing?.TileRelayCost ||
      all_roofing?.overlayCost ||
      all_roofing?.EXISTING_ROOF_COST + all_roofing?.STEEP_ROOF_COST,
    job_planes_cost:
      all_roofing?.cost_add_roof_planes_tile_relay ||
      all_roofing?.cost_add_roof_planes_overlay ||
      all_roofing?.reRoofing_for_add_roof_planes_tile_relay +
        all_roofing?.CostOfLayers_for_add_roof_planes_tile_relay +
        all_roofing?.STEEP_ROOF_COST_for_add_roof_planes_tile_relay ||
      all_roofing?.cost_add_roof_planes_roof_overlay ||
      all_roofing?.cost_add_roof_planes_overlay_overlay ||
      all_roofing?.reRoofing_for_add_roof_planes_roof_overlay +
        all_roofing?.CostOfLayers_for_add_roof_planes_roof_overlay +
        all_roofing?.STEEP_ROOF_COST_for_add_roof_planes_roof_overlay ||
      all_roofing?.roof_tile_for_add_roof_planes ||
      all_roofing?.reRoofing_for_add_roof_planes ||
      all_roofing?.roof_overlay_for_add_roof_planes,
    new_roofing_cost: all_roofing?.NEW_ROOF_JOB_TYPE_COST,
  };
  // console.log("Prices ", prices);
  value.aerial_photo = screenShot;
  const emptyPropsal = salesTemplates?.data?.find((e) => {
    return e?.document_type === "empty_proposal";
  });
  const HandelSubmit = (e) => {
    e.preventDefault();
    if (emptyPropsal.relations[0]?.relation_value == "0") {
      swal({
        title: "Empty propsal",
        text: "You can't submit unitll Empty propsal is configured",
        icon: "warning",
        dangerMode: false,
      });
    } else {
      if (value.aerial_photo === undefined) {
        swal({
          // title: "Congratulations You finally did it and ScreenShot Taken",
          title: "Take ScreenShot Please!",
          icon: "warning",
          dangerMode: false,
        });
        window.scrollTo({
          top: 2000,
          left: 2000,
          behavior: "smooth",
        });
      } else {
        // e.preventDefault();
        dispatch(
          addSolarAction({
            ...value,
            ...DataApi,
            ...goodLeapData,
            ...sendHvacs,
            ...sendBatteries,
            ...sendInurance,
            ...sendGenerators,
            ...all_Adders,
            ...mosiacData,
            ...concertData,
            prices,
          })
        );
      }
    }
  };
  const handleAddLead = () => {
    Navigate(`/crm/leads/${leadId}/${serviceID}`);
    window.location.reload(false);
  };
  const handleGoToLeads = () => {
    Navigate(`/profilelead/${leadId}/solutions`);
    window.location.reload(false);
  };
  /*-----------------------------LEAFLET-------------------------- */
  // value.roof_area = dataAarea * 10.764;

  // console.log("coordinatescoordinatescoordinates", singlead.lat);
  // console.log("singleadsingleadsinglead",singlead.lat)
  // console.log("singleadsingleadsinglead",singlead.lng)
  if (singlead?.lat === null || singlead?.lat === "") {
    Geocode.setLocationType("ROOFTOP");
    Geocode.setApiKey("AIzaSyCrr_bBNHxQ0lZKadmJYpqS2vOebczD1m4");
    // React.useEffect(() => {
    Geocode.fromAddress(theUserLocation).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        // console.log(lat, lng);
        coordinates.lat = lat;
        coordinates.lng = lng;
      },
      (error) => {
        console.error(error);
      }
    );
  } else {
    coordinates.lat = singlead?.lat;
    coordinates.lng = singlead?.lng;
    // }, [coordinates]);
  }

  if (value.is_finance === false) {
    value.financial_institution = "";
  }
  if (value.is_finance === false) {
    value.financial_institution = "";
  }
  // calculate number of roofs squares
  // console.log("dataArea", dataAarea);
  let roofSquares = Number(dataAarea / 100) + 1;

  const deleteFromLicenses = (id) => {
    const newHvac = [...hvacs];
    const index = hvacs.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newHvac.splice(index, 1);
    setHvacs(newHvac);
  };
  const deleteFromBatteries = (id) => {
    const newBattery = [...batteries];
    const index = batteries.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newBattery.splice(index, 1);
    setBatteries(newBattery);
  };
  const deleteFromGenerators = (id) => {
    const newGenerator = [...generators];
    const index = generators.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newGenerator.splice(index, 1);
    setGenerators(newGenerator);
  };
  // console.log("singlead", singlead?.id);
  let mosaicPaymentWithPrePayment =
    payments?.monthlyPaymentsWithPrePayment?.filter(function (
      element,
      index,
      array
    ) {
      return ++index % 2 === 0;
    });

  let CommaFormatted = (num) => {
    return Intl.NumberFormat("en-US").format(num);
  };
  const handleChange = (event) => {
    setValue({ ...value, discount_type: event.target.value });
  };

  return (
    <>
      {!isSingleLeadLoading && !isCalc && !isUtility && !isPanle && !isRoof && (
        <>
          {/*  START  ICON TOGGLE CALC */}
          {/* <CalcToggle onClick={() => setOpenCalc(!openCalc)}>
            <CalculateSharp />
          </CalcToggle> */}
          {/* <CostEstemation
            panelPrice={DataApi.panel_price}
            ToggleCalc={openCalc}
            NumberOfPanls={TotalPanle}
            DC={SystemSize}
            AC={SystemOutput_AC}
            ISfinance={value.is_finance}
            AnnualPrduction={AnnualPrduction}
            InvertType={value.inverter_type}
            IsTowStory={value.two_story_home}
            IsReverseTilt={value.is_reverse_tilt}
            IsNorthFaced={value.is_north_faced}
            RoofMaterials={value.roof_materials}
            IsAttic={value.is_attic}
            NumberOfAttics={value.number_of_conduit_arrays}
            IsOnlineMonitoring={value.is_online_monitoring}
            JopType={value.job_type}
            IsTrenching={value.is_trenching_dirt}
            HowManyTrench={value.how_many_ft_trench_dirt}
            IsTrenchingConcret={value.is_trenching_concrete}
            HowManyConcret={value.how_many_ft_trench_concrete}
            IsStandAloneRoof={value.is_standalone_roof_mount}
            IsDiggingSlope={value.digging_slope}
            HowManyDigging={value.how_many_digging_ft}
            ExistingElectricalPanel={value.upgrade_electrical_panel}
            IsStucco={value.is_stucco}
            IsDeRate={value.is_de_rate}
            ISMPU={value.is_mpu_relocation}
            ISMPUMore3={value.is_more_than_3ft}
            NumberOfMPU={value.number_of_mpu_relocation_foot}
            IsSubPanel={value.is_sub_panel}
            IsMeterSocket={value.is_meter_socket}
            IsEV={value.is_ev_charger}
            IsEVMLO={value.is_ev_mlo}
            IsReRoofing={value.is_re_roofing}
            NumberOfReroofSquares={value.number_of_re_roof_squares}
            IsRoofRelay={value.is_roof_relay}
            IsReRoofShingle={value.is_re_roof_shingle}
            IsReRoofTear={value.is_re_roof_tear_off}
            NumberOfLayers={value.number_of_layers}
            IsReRoofPresidential={value.is_re_roof_presidential}
            IsReRoofSpanish={value.is_re_roof_spanish_tiles}
            IsReRoofFlat={value.is_re_roof_flat_tiles}
            IsReRoofReDecking={value.is_re_roof_re_decking}
            IsReRoofFascia={value.is_re_roof_fascia_board}
            NumberOfFeet={value.number_of_feet}
            IsRafterExchange={value.is_rafter_exchange}
            IsAirVet={value.is_air_vent}
            AirVent={value.air_vent}
            NumberOfVent={value.number_of_vents}
            IsDoubleHand={value.is_double_hand}
            IsSmoke={value.is_smoke_detectors}
            NumberOfSmoke={value.number_of_smoke_detectors}
            IsWarrantyExtend={value.is_warranty_extend}
            IsHVAC={value.is_hvac}
            HvacLocation={value.hvac_location}
            HvacHorsPower={value.hvac_horse_power}
            NumberOfHvacFt={value.number_hvac_ft}
            IsDucting={value.is_ducting}
            NumberOfDuctingRun={value.number_of_ducting_run}
            IsEnergyEfficient={value.is_energy_efficient_plugs}
            NumberOfEfficient={value.number_of_efficient_plugs}
            IsolarLip={value.is_solar_lip}
            NumberOfSolarLip={value.number_of_solar_lip}
            IsBirdNetting={value.is_bird_netting}
            NumberOfBirdNetting={value.number_of_bird_netting}
            IsBattery={value.is_battery}
            NumberOfBattery={value.number_of_batteries}
            BatteryPower={value.battery_power}
            IsWarrantyPackage={value.is_warranty_package}
            Warranty={value.warranty}
            IsSteep={value.is_steep}
            Royaltiy={value.royalties}
            value={value}
            RoofJobsTypesObject={RoofJobsTypesObject}
            ExistingRoofingObject={ExistingRoofingObject}
            NewRoofJobTypesObject={NewRoofJobTypesObject}
            colorObject={colorObject}
            NewRoofPlanMatrial={NewRoofPlanMatrial}
            is_roof_planes={value.is_roof_planes}
            Roof_plane_squares={value.number_of_planes_squares}
            Roof_plane_layers={value.number_of_planes_layers}
            Tile_Rekay_no_squares={value.tile_relay_no_of_squares}
            overlay_no_of_squares={value.overlay_no_of_squares}
            NewRoofPlanMatrialPlanes={NewRoofPlanMatrialPlanes}
            RoofJobsForAddPlanes={RoofJobsForAddPlanes}
            TileRelayForAddRoofPlanes={TileRelayForAddRoofPlanes}
            RoofOverLayForAddRoofPlanes={RoofOverLayForAddRoofPlanes}
            ReRoofingMaterialForAddPlanes={ReRoofingMaterialForAddPlanes}
            jobTypeForRoofTileRealy={jobTypeForRoofTileRealy}
            TileRelayForAddRoofPlanesTileRelay={
              TileRelayForAddRoofPlanesTileRelay
            }
            ReRoofingMaterialForAddPlanesTileRelay={
              ReRoofingMaterialForAddPlanesTileRelay
            }
            jobTypeForRoofRoofOverlay={jobTypeForRoofRoofOverlay}
            ReRoofingMaterialForAddPlanesRoofOverlay={
              ReRoofingMaterialForAddPlanesRoofOverlay
            }
            overlayNewMaterial={overlayNewMaterial}
            TileRelayMaterial={TileRelayMaterial}
            TileRelayForAddRoofPlanesOverLay={TileRelayForAddRoofPlanesOverLay}
            overlayNewMaterialPlanes={overlayNewMaterialPlanes}
            tileRelayNewMaterialPlanes={tileRelayNewMaterialPlanes}
            reroofNewMaterialPlanes={reroofNewMaterialPlanes}
            singleUtile={singleUtile}
            hvacs={hvacs}
            batteries={batteries}
            updateInsurance={setInurance}
            generators={generators}
            roofingPrices={roofingPrices}
            updateRoofingPrices={setRoofingPricrs}
          /> */}
          <FormConatiner>
            <LeadData singlead={singlead} />
            <SolarHeading>
              <h2>Solar Solution</h2>
            </SolarHeading>

            <form onSubmit={HandelSubmit}>
              <Grid item container spacing={2} columns={18}>
                <Grid item xs={18} mb={3}>
                  <h3>Utility Info.</h3>
                  <hr />
                </Grid>

                {/*utility_provider_id  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required={true}>
                    <InputLabel id="demo-simple-select-label">
                      Utility Provider
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={value.utility_provider_id}
                      label="Utility Provider"
                      required={true}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          utility_provider_id: e.target.value,
                        })
                      }
                    >
                      {UtilityProviders?.map((util) => (
                        <MenuItem key={util.id} value={util.id}>
                          {util.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* 
       

                {/* Rate  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-basic"
                    variant="outlined"
                    label="Rate"
                    type="text"
                    // step="any"
                    // disabled={true}
                    value={value.rate}
                    onChange={(e) =>
                      setValue({ ...value, rate: e.target.value })
                    }
                  />
                </Grid>

                {/* Annual Kwh Usage */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  {/* <InputLabel> Annual Kwh Usage </InputLabel> */}
                  <TextField
                    fullWidth
                    required
                    label="Annual Consumption"
                    // type="number"
                    value={value.annual_kwh_usage}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        annual_kwh_usage: Number(e.target.value),
                      })
                    }
                  />
                </Grid>

                {/* Avg Annual Bill */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    fullWidth
                    disabled={true}
                    label="Annually Cost $"
                    // type="number"
                    value={
                      Math.ceil(
                        (value.avg_annual_bill =
                          value.annual_kwh_usage * value.rate)
                      ) || "Annually Cost $"
                    }
                    onChange={(e) =>
                      setValue({
                        ...value,
                        avg_annual_bill: Number(e.target.value),
                      }) || false
                    }
                  />
                </Grid>
                {/* Monthly Cost  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    fullWidth
                    disabled={true}
                    label="Monthly Cost $"
                    value={
                      Math.floor(
                        (value.monthly_cost =
                          (value.annual_kwh_usage * value.rate) / 12)
                      ) || "Monthly Cost $"
                    }
                    onChange={(e) =>
                      setValue({
                        ...value,
                        monthly_cost: Number(e.target.value),
                      }) || false
                    }
                  />
                </Grid>

                {/* --------- START JOB TYPE ---------- */}
                <Grid item xs={18} mb={3}>
                  <h3>Job Info.</h3>
                  <hr />
                </Grid>

                {/* Installation Type  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <TextField
                      select
                      label="Installation Type "
                      required
                      value={value.installation_type}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          installation_type: e.target.value,
                        })
                      }
                    >
                      {installationTypes.map((serve) => (
                        <MenuItem key={serve.value} value={serve.value}>
                          {serve.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>

                {/*  JOB types  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    select
                    fullWidth
                    label="System Types"
                    value={value.job_type}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        job_type: e.target.value,
                      })
                    }
                  >
                    {jobTypes.map((job) => (
                      <MenuItem key={job.value} value={job.value}>
                        {job.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {value.job_type === "roof_mount" ? (
                  <>
                    {/* Roof Materials  D */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        select
                        label="Roof Materials"
                        fullWidth
                        value={value.roof_materials}
                        onChange={(e) =>
                          setValue({ ...value, roof_materials: e.target.value })
                        }
                      >
                        {roofMaterials.map((serve) => (
                          <MenuItem key={serve.value} value={serve.value}>
                            {serve.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    {/* slope_degree  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Roof Pitch Degree "
                        value={value.slope_degree}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            slope_degree: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                    {/* two_story_home*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>2 Story Home</InputLabel>
                      <Switch
                        checked={value.two_story_home}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            two_story_home: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}

                {value.job_type !== "roof_mount" ? (
                  <>
                    {/* is_trenching_dirt*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Trenching Dirt </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_trenching_dirt}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_trenching_dirt: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                    {value.is_trenching_dirt && (
                      <>
                        {/* how_many_ft_trench_dirt  */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="How Many ft Trench Dirt"
                            type="number"
                            value={value.how_many_ft_trench_dirt}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                how_many_ft_trench_dirt: e.target.valueAsNumber,
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/* is_trenching_concrete*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Trenching Concrete </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_trenching_concrete}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_trenching_concrete: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                    {value.is_trenching_concrete && (
                      <>
                        {/* how_many_ft_trench_concrete */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="How Many ft Trench Concrete"
                            value={value.how_many_ft_trench_concrete}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                how_many_ft_trench_concrete: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}
                  </>
                ) : null}

                {/* Opportunity Date Time */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      required={true}
                    >
                      <DatePicker
                        fullWidth
                        required={true}
                        label="Opportunity Date Time"
                        value={value.opportunity_date_time}
                        onChange={(e) =>
                          setValue({ ...value, opportunity_date_time: e })
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                {/* ------ START SYSTEM INFORMATION ---------- */}
                <Grid item xs={18} mb={3}>
                  <h3> System Information</h3>
                  <hr />
                </Grid>

                {/* panels  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Panel Models
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      required
                      value={value.panels}
                      label="Panel Modelss"
                      onChange={(e) =>
                        setValue({ ...value, panels: e.target.value })
                      }
                    >
                      {Panels?.map((panel) => (
                        <MenuItem value={panel.id} key={panel.id}>
                          {panel.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* Panel Wattage  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    disabled={true}
                    label="Panel Wattage"
                    value={(value.panel_wattage = SinglePanel?.wattage || "")}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        panel_wattage: Number(e.target.value),
                      }) || false
                    }
                  />
                  {/* {panelWattages.map((panel) => (
                      <MenuItem key={panel.value} value={panel.value}>
                        {panel.name}
                      </MenuItem>
                    ))} */}
                  {/* </TextField> */}
                </Grid>

                {/* Panel Wattage  */}

                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <Typography gutterBottom>
                    Offset {OffsetPercentage || "No"} %
                  </Typography>
                  <PrettoSlider
                    valueLabelDisplay="auto"
                    aria-label="pretto slider"
                    value={OffsetPercentage || ""}
                    defaultValue={1}
                    step={0.01}
                    min={0}
                    max={100}
                    onChange={(e) => setOffset(e.target.value)}
                  />
                </Grid>
                {/* panels kw */}

                {/* iis_add_on*/}

                {/* add_on_id  */}
                {/* number_of_solar_arrays  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    label=" Add + or (-) Subtract Panels "
                    type="number"
                    value={value.number_of_solar_arrays}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        number_of_solar_arrays: e.target.value,
                      })
                    }
                  />
                </Grid>
                {/* inverter_type   */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    select
                    fullWidth
                    label="Inverter Type"
                    value={value.inverter_type}
                    onChange={(e) =>
                      setValue({ ...value, inverter_type: e.target.value })
                    }
                  >
                    {dynamicInverters.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* no_of_ft_from_main_service */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    label="Number of Feet From Main Service"
                    // type="number"
                    value={value.no_of_ft_from_main_service}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        no_of_ft_from_main_service: Number(e.target.value),
                      })
                    }
                  />
                </Grid>
                {/*  Steep Roof ?*/}

                {/* is_online_monitoring*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Online Monitoring</InputLabel>
                  <Switch
                    checked={value.is_online_monitoring}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_online_monitoring: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {/* System Design */}
                <Grid item xs={18} mb={3}>
                  <h3> System Design</h3>
                  <hr />
                </Grid>
                <Grid item xs={18} mb={3}>
                  <SystemDesign
                    coordinates={coordinates}
                    TotalPanle={TotalPanle}
                    showButton={value.showButton}
                  ></SystemDesign>
                </Grid>
                <Grid item xs={18} mb={3}>
                  <ShowFrameBtn
                    onClick={(e) => {
                      setShowFrame(!showFrame);
                    }}
                    type="button"
                  >
                    Get Solar Data
                  </ShowFrameBtn>
                </Grid>
                {showFrame && (
                  <>
                    {" "}
                    <Grid item xs={18} mb={3}>
                      <DivFrame>
                        <iframe
                          className="frame"
                          id="iframe"
                          scrolling="no"
                          marginwidth="50"
                          src={`https://suncalc.org/#/${singlead?.lat},${singlead?.lng},20/2015.05.11/13:15/324.0/1`}
                          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                          title="description"
                        ></iframe>
                      </DivFrame>
                    </Grid>
                  </>
                )}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={value.is_sun}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_design: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Design Request ?"
                  />
                </Grid>

                {/*End System Desing */}
                <Grid item xs={18} mb={3}>
                  <h3> Premises Information</h3>
                  <hr />
                </Grid>
                {/* Shading D  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    select
                    required
                    label="Shading"
                    fullWidth
                    value={value.shading}
                    onChange={(e) =>
                      setValue({ ...value, shading: e.target.value })
                    }
                  >
                    {shadings.map((serve) => (
                      <MenuItem key={serve.value} value={serve.value}>
                        {serve.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {value.job_type === "roof_mount" ? (
                  <>
                    {/* Attic*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel> Attic Runs ? </InputLabel>
                      <Switch
                        checked={value.is_attic}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_attic: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}
                {value.is_attic && (
                  <>
                    {/* number_of_conduit_arrays  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Attic Arrays"
                        value={value.number_of_conduit_arrays}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_conduit_arrays: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}
                {/* Permitted Structures */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Non-permitted Structures </InputLabel>
                  <Switch
                    checked={value.is_any_non_permitted_structures}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_any_non_permitted_structures: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {/* tree trimming */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Tree Trimming ? </InputLabel>
                  <Switch
                    checked={value.is_tree_trimming}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_tree_trimming: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {value.is_tree_trimming && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Trees"
                      value={value.number_of_trees}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_trees: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}

                {value.job_type === "roof_mount" ? <></> : null}
                {value.job_type !== "roof_mount" ? (
                  <>
                    {/* is_separate_electrical_meter*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Separate Electrical Meter</InputLabel>
                      <Switch
                        checked={value.is_separate_electrical_meter}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_separate_electrical_meter: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {/* is_electric_work_currently_on_garage*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Electric Work Currently on Garage</InputLabel>
                      <Switch
                        checked={value.is_electric_work_currently_on_garage}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_electric_work_currently_on_garage:
                              e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {/* is_sub_panel_on_detached_garage*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Sub Panel On Detached Garage</InputLabel>
                      <Switch
                        checked={value.is_sub_panel_on_detached_garage}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_sub_panel_on_detached_garage: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}

                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18} mb={3}>
                  <h3> Electrical Information</h3>
                  <hr />
                </Grid>
                {/* Existing Electrical Panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required>
                    <InputLabel id="demo-simple-select-label">
                      Existing Electrical Panel
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      value={value.existing_electrical_panel}
                      label=" Existing Electrical Panel"
                      onChange={(e) =>
                        setValue({
                          ...value,
                          existing_electrical_panel: e.target.value,
                        })
                      }
                    >
                      {electricalPanels?.map((data) => (
                        <MenuItem key={data.value} value={data.value}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* Existing Electrical Panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Upgrade Electrical Panel
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      value={value.upgrade_electrical_panel}
                      label=" Upgrade Electrical Panel"
                      onChange={(e) =>
                        setValue({
                          ...value,
                          upgrade_electrical_panel: e.target.value,
                        })
                      }
                    >
                      {UpgradPanles?.map((data) => (
                        <MenuItem key={data.value} value={data.value}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* is_mpu_relocation*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>MPU Relocation</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_mpu_relocation}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_mpu_relocation: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value.is_mpu_relocation && (
                  <>
                    {/* is_more_than_3ft*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>More than 6ft.</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_more_than_3ft}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_more_than_3ft: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                  </>
                )}

                {/* number_of_mpu_relocation_foot  */}
                {value.is_more_than_3ft && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of MPU Relocation Foot"
                      value={value.number_of_mpu_relocation_foot}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_mpu_relocation_foot: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}

                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>DeRate</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_de_rate}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_de_rate: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_sub_panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Sub Panel</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_sub_panel}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_sub_panel: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_meter_socket*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Meter Socket</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_meter_socket}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_meter_socket: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_ev_charger*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>EV Charger</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_ev_charger}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_ev_charger: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_ev_mlo*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>EV MLO</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_ev_mlo}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_ev_mlo: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {/* is_Designated*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Designated plugs</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_designated}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_designated: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value.is_designated && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Designated Plugs"
                      // type="number"
                      value={value.number_of_designated_plugs}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_designated_plugs: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}

                {/*------------- start the Roofing   ------------*/}
                <Grid item xs={18} mb={3}>
                  <h3> Roofing Information</h3>
                  <hr />
                </Grid>

                {/* is_re_roofing*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Roofing ? </InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_roofing}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_roofing: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/*------------- START THE RE ROOFING   ------------*/}

                {value.is_roofing && (
                  <>
                    {/*  Job Type*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Job Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          required
                          value={value.roof_job_type_id}
                          label="Job Type"
                          onChange={(e) =>
                            setValue({
                              ...value,
                              roof_job_type_id: e.target.value,
                            })
                          }
                        >
                          {RoofJobsTypes?.map((job) => (
                            <MenuItem value={job.id} key={job.id}>
                              {job.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {/* content based on Job type */}
                    {value.roof_job_type_id === 1 && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Tile relay Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.tile_relay_material_id}
                              label=" Tile relay Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  tile_relay_material_id: e.target.value,
                                })
                              }
                            >
                              {TileRelayMatrial?.map((tile) => (
                                <MenuItem value={tile.id} key={tile.id}>
                                  {tile.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Tile Relay squares "
                            // type="number"
                            value={value.tile_relay_no_of_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                tile_relay_no_of_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                        {/* broken */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Broken Tiles "
                            // type="number"
                            value={value.tile_relay_broken}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                tile_relay_broken: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  value.is_new_roof_planes_for_tile_relay
                                }
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes_for_tile_relay:
                                      e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>
                        {/* Add Roof Planes For Tile Relay */}
                        {value.is_new_roof_planes_for_tile_relay === true && (
                          <>
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={
                                    value.add_roof_planes_job_type_id_for_roof_tile
                                  }
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      add_roof_planes_job_type_id_for_roof_tile:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes_tile_relay
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes_tile_relay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={value.roof_planes_tile_relay_broken}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes_overlay
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tileRelay_overlay_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tileRelay_overlay_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={
                                      value.TileRelay_overlay_no_of_squares
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        TileRelay_overlay_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes_tile_relay:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes_tile_relay
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes_tile_relay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}

                    {value.roof_job_type_id === 2 && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Existing Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.overlay_material_id}
                              // label="Roof Overlay Matrials"
                              label="Existing Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  overlay_material_id: e.target.value,
                                })
                              }
                            >
                              {RoofOverlayMatrials?.map((roofover) => (
                                <MenuItem value={roofover.id} key={roofover.id}>
                                  {roofover.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              New Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.overlay_new_roof_material_id}
                              label="New Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  overlay_new_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {newRooginOverLay?.map((roof) => (
                                <MenuItem value={roof.id} key={roof.id}>
                                  {roof.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Existing squares "
                            // type="number"
                            value={value.overlay_no_of_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_no_of_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Number of Layers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Layers"
                            // type="number"
                            value={value.overlay_layers}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_layers: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>

                        {/*  Roof Pitch Degree. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Roof Pitch Degree "
                            value={value.overlay_pitch}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_pitch: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Roof Pitch Number of squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number Of Steep Squares"
                            value={value.overlay_steep}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_steep: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  value.is_new_roof_planes_for_roof_overlay
                                }
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes_for_roof_overlay:
                                      e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>
                        {value.is_new_roof_planes_for_roof_overlay === true && (
                          <>
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={
                                    value.add_roof_planes_job_type_id_for_roof_overlay
                                  }
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      add_roof_planes_job_type_id_for_roof_overlay:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes_roof_overlay
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes_roof_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={
                                      value.roof_planes_tile_relay_broken_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes_overlay_overlay
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes_overlay_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_planes_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_planes_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={value.overlay_planes_no_of_squares}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_planes_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes_roof_overlay:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes_roof_overlay
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes_roof_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                          </>
                        )}

                        {/* Add Roof Planes For Roof Overlay */}
                      </>
                    )}
                    {value.roof_job_type_id === 3 && (
                      <>
                        {/*  Existing Roof*/}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Existing Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={value.existing_roof_material_id}
                              label="Existing Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  existing_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {ExistingRoofing?.map((job) => (
                                <MenuItem value={job.id} key={job.id}>
                                  {job.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/*  Number of Layers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Layers  "
                            // type="number"
                            value={value.number_of_old_layers}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_old_layers: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Number of Old Squers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Existing Squares "
                            // type="number"
                            value={value.number_of_old_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_old_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Roof Pitch Degree. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Roof Pitch Degree "
                            value={value.roof_pitch_degree}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                roof_pitch_degree: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Roof Pitch Number of squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number Of Steep Squares"
                            value={value.number_of_steep_sq}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_steep_sq: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>

                        {/* is roof planes for re roofing */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value.is_roof_planes}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_roof_planes: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>

                        {value.is_roof_planes && (
                          <>
                            {/*  Job Type for roof planes*/}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={value.roof_job_type_id_roof_planes}
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      roof_job_type_id_roof_planes:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.roof_job_type_id_roof_planes === 1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={
                                      value.roof_planes_tile_relay_broken_reroof
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken_reroof:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.roof_job_type_id_roof_planes === 2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Overlay squares "
                                    // type="number"
                                    value={
                                      value.overlay_no_of_squares_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_no_of_squares_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.reroof_overlay_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          reroof_overlay_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={value.reroof_overlay_no_of_squares}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        reroof_overlay_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.roof_job_type_id_roof_planes === 3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers  "
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}

                            {value.add_job_type_for_new_roof === true && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Job Type
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.roof_job_type_id_for_Tilerelay
                                      }
                                      label="Job Type"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          roof_job_type_id_for_Tilerelay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofJobsTypes?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                <TextField
                                  fullWidth
                                  label="Number of Old Squares "
                                  // type="number"
                                  value={value.number_of_old_squares_new_job_type}
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      number_of_old_squares_new_job_type: Number(e.target.value)
                                    })


                                  }
                                />
                              </Grid> */}
                              </>
                            )}
                          </>
                        )}
                        {/* End of Try */}

                        <Grid item xs={18} mb={3}>
                          <h5> New Roofing </h5>
                        </Grid>

                        {/*  Existing Roof*/}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              New Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.new_roof_material_id}
                              label="New Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  new_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {NewRoofJobTypes?.map((roof) => (
                                <MenuItem value={roof.id} key={roof.id}>
                                  {roof.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {/*  Number of new Squers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            // type="number"
                            // disabled
                            value={
                              (value.number_of_new_squares =
                                value.number_of_old_squares)
                            }
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>

                        {value.new_roof_material_id === 1 && (
                          <>
                            {/* start a color dropdown */}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <ColorRoofing>
                                <div className="select-box">
                                  <div
                                    className="select-box__current"
                                    tabIndex="1"
                                  >
                                    <div class="select-box__value">
                                      <input
                                        type="radio"
                                        class="select-box__input show"
                                        // id="0q"
                                        // value="1q"
                                        name="color"
                                        // checked
                                      />
                                      <p class="select-box__input-text work">
                                        Choose Color{" "}
                                      </p>
                                    </div>
                                    {colors?.map((color) => (
                                      <div
                                        className="select-box__value"
                                        key={color.id}
                                      >
                                        <input
                                          type="radio"
                                          className="select-box__input"
                                          id={color.id}
                                          value={color.id}
                                          name="color"
                                          // checked={color.id}
                                          onChange={(e) =>
                                            setValue({
                                              ...value,
                                              color_id: e.target.value,
                                            })
                                          }
                                        />
                                        <p
                                          className="select-box__input-text "
                                          style={{
                                            background: `url(${color.image_path})`,
                                          }}
                                        >
                                          {color.name}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                  <ul class="select-box__list">
                                    {colors?.map((color) => (
                                      <li key={color.id}>
                                        <label
                                          class="select-box__option "
                                          htmlFor={color.id}
                                          style={{
                                            background: `url(${color.image_path})`,
                                          }}
                                        >
                                          {color.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </ColorRoofing>
                            </Grid>
                          </>
                        )}
                        {/*  Number of new Squers */}
                        <Grid
                          item
                          md={6}
                          sm={9}
                          xs={18}
                          mb={3}
                          style={{ display: "none" }}
                        >
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            // type="number"
                            disabled
                            value={value.number_of_old_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value.is_new_roof_planes}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes  ? "
                          />
                        </Grid>

                        {value.is_new_roof_planes && (
                          <>
                            {/*  Number of Old Squers */}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <TextField
                                fullWidth
                                label="Number of new Squares "
                                // type="number"
                                // disabled
                                value={value.number_of_planes_squares}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    number_of_planes_squares: Number(
                                      e.target.value
                                    ),
                                  })
                                }
                              />
                            </Grid>

                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  New Roof Material
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={value.new_planes_material_id}
                                  label="New Roof Material"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      new_planes_material_id: e.target.value,
                                    })
                                  }
                                >
                                  {NewRoofJobTypes?.map((roof) => (
                                    <MenuItem value={roof.id} key={roof.id}>
                                      {roof.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                    <Grid item xs={18} mb={3}>
                      <hr />
                    </Grid>

                    {/*  Redecking*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_redecking}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_redecking: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Redecking ?"
                      />
                    </Grid>
                    {value.is_redecking && (
                      <>
                        {/*  Number of Redecking Squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Redecking Squares  "
                            // type="number"
                            value={value.number_of_redecking_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_redecking_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Rafter Exchage */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_rafter}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_rafter: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Rafter Exchage ?"
                      />
                    </Grid>
                    {value.is_rafter && (
                      <>
                        {/*  Number of Rafter ft. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Rafter ft. "
                            // type="number"
                            value={value.number_of_rafter_ft}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_rafter_ft: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Fascia Replace Board ?  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_fascia}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_fascia: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Fascia Replace Board ?"
                      />
                    </Grid>
                    {value.is_fascia && (
                      <>
                        {/*  Number of Fasciz ft. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Fasciz ft. "
                            // type="number"
                            value={value.number_of_fascia_ft}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_fascia_ft: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item xs={18} mb={3}>
                      <hr />
                    </Grid>
                    {/*  HVAC Unit on Roof ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_hvac_replace}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_hvac_replace: e.target.checked,
                              })
                            }
                          />
                        }
                        label="HVAC Unit on Roof ?"
                      />
                    </Grid>
                    {value.is_hvac_replace && (
                      <>
                        {/*  Number of HVAC */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of HVAC Units"
                            value={value.number_of_hvac_units}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_hvac_units: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Air Vent Replacement ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_air_vent_replacement}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_air_vent_replacement: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Air Vent Replacement ?"
                      />
                    </Grid>
                    {value.is_air_vent_replacement && (
                      <>
                        {/*  Number of Vents to Be Replaced */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Vents to Be Replaced "
                            value={value.number_of_replaced_vents}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_replaced_vents: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  New Air Vent ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_new_vent}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_new_vent: e.target.checked,
                              })
                            }
                          />
                        }
                        label="New Air Vent ?"
                      />
                    </Grid>
                    {value.is_new_vent && (
                      <>
                        {/*  Number of New Vents. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of New Vents "
                            value={value.number_of_new_vents}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_vents: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Smoke Monitors ? */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_smoke_monitors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_smoke_monitors: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Smoke Monitors ?"
                      />
                    </Grid>
                    {value.is_smoke_monitors && (
                      <>
                        {/*  Number of Smoke Delectors. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Smoke Delectors"
                            value={value.number_of_smoke_monitors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_smoke_monitors: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Double Hand ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_double_hands}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_double_hands: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Double Hand ?"
                      />
                    </Grid>
                    {value.is_double_hands && (
                      <>
                        {/*  Number of Squares  */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            value={value.number_of_double_hand_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_double_hand_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Carbon Monoxide Monitors ? */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_monoxide_detectors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_monoxide_detectors: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Carbon Monoxide Monitors ?"
                      />
                    </Grid>
                    {value.is_monoxide_detectors && (
                      <>
                        {/*  Number of Carbon Delectors. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Carbon Delectors  "
                            value={value.number_of_monoxide_detectors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_monoxide_detectors: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Added Roof Cost  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Added Roof Cost "
                        value={value.added_cost}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            added_cost: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                    {/* Description of Added Work */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Description of Added Work"
                        value={value.add_work_description}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            add_work_description: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    {/* Roof Royalties */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Roof Royalties"
                        value={value.royalties_cost}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            royalties_cost: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>

                    {/*Notes */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      {/* <span>Notes</span> */}
                      <TextField
                        fullWidth
                        label="Notes"
                        value={value.notes}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            notes: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}

                {/*------------- E N D THE RE ROOFING   ------------*/}

                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3> HVAC Information</h3>{" "}
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenHvac}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                    // style={{ color: "#4acfac" }}
                  >
                    Add Hvac
                  </Button>
                </Grid>

                {hvacs.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>hvac location</th>
                            <th>number hvac ft</th>
                            <th>hvac horse power</th>

                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hvacs.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.hvac_location}</td>
                                <td>{e.number_hvac_ft}</td>
                                <td>{e.hvac_horse_power}</td>

                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromLicenses(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}

                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3>Battery Information</h3>
                    {/* <Button
                      style={{ color: "#4acfac" }}
                      onClick={handleOpenBattery}
                      className="btn"
                    >
                      Add Battery
                    </Button> */}
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenBattery}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                  >
                    Add Battery
                  </Button>
                </Grid>
                {/* <Grid container columns={18}> */}
                {batteries.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Battery Power</th>
                            <th>Number of batteries</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {batteries.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.battery_power}</td>
                                <td>{e.number_of_batteries}</td>
                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromBatteries(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}

                {/* Generators */}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3>Generator Information</h3>
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenGenerator}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                  >
                    Add Generator
                  </Button>
                </Grid>
                {/* <Grid container columns={18}> */}
                {generators.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Generator Power</th>
                            <th>Number of Generators</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {generators.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.generator_power}</td>
                                <td>{e.number_of_generators}</td>
                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromGenerators(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}
                <Grid item xs={18} mb={3}>
                  <h3>Addons </h3>
                  <hr />
                </Grid>
                <>
                  {/* is_ducting*/}

                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Ducting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_ducting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_ducting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_ducting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Ducting Run"
                        value={singleHvac?.number_of_ducting_run}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_ducting_run: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}

                  {/* is_led_lighting*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Led Lighting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_led_lighting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_led_lighting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_led_lighting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Led Lighting"
                        value={value?.number_of_led_lighting}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_led_lighting: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_energy_efficient_plugs*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Energy Efficient Plugs</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_energy_efficient_plugs}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_energy_efficient_plugs: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_energy_efficient_plugs && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Efficient Plugs"
                        value={value?.number_of_efficient_plugs}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_efficient_plugs: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_solar_lip*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Solar Lip</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_solar_lip}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_solar_lip: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_solar_lip  */}
                  {value?.is_solar_lip && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Solar Lip"
                        value={value?.number_of_solar_lip}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_solar_lip: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_bird_netting*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Bird Netting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_bird_netting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_bird_netting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_solar_lip  */}
                  {value?.is_bird_netting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Bird Netting"
                        value={value?.number_of_bird_netting}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_bird_netting: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}

                  {/* is_warranty_package*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>is_warranty_package</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_warranty_package}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_warranty_package: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>

                  {/* warranty  */}
                  {value?.is_warranty_package && (
                    <>
                      <Grid item md={6} sm={9} xs={18} mb={3}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Warranty
                          </InputLabel>
                          <Select
                            id="demo-simple-select"
                            value={value?.warranty}
                            label="battery_power"
                            onChange={(e) =>
                              setValue({
                                ...value,
                                warranty: e.target.value,
                              })
                            }
                          >
                            {Warranties?.map((data) => (
                              <MenuItem key={data.value} value={data.value}>
                                {data.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
                {/* </Grid> */}
                {/* ***************************************** */}
                <Grid item xs={18} mb={3}>
                  <h3>Internal overhead </h3>
                  <hr />
                </Grid>

                {/* ***************************************** */}
                <Grid item xs={18}>
                  <TextField
                    fullWidth
                    label="Internal overhead"
                    value={value.royalties}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        royalties: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={18}>
                  <InputLabel>Discount</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value?.is_discount}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_discount: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value?.is_discount ? (
                  <>
                    <Grid item xs={18} md={6}>
                      <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">
                          Discount type
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={value?.discount_type}
                          onChange={handleChange}
                        >
                          <FormControlLabel
                            value="percentage"
                            control={<Radio />}
                            label="Percentage"
                          />
                          <FormControlLabel
                            value="fixed"
                            control={<Radio />}
                            label="Fixed amount"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    {value?.discount_type === "percentage" ? (
                      <>
                        {" "}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Percent"
                            value={value.discount_percent}
                            onChange={(e) => {
                              if (
                                e.target.value >= 0 &&
                                e.target.value <= 100
                              ) {
                                setValue({
                                  ...value,
                                  discount_percent: e.target.value,
                                });
                              }
                            }}
                            type="number"
                          />
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                    {value?.discount_type === "fixed" ? (
                      <>
                        {" "}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Fixed amount"
                            value={value.discount_amount}
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                setValue({
                                  ...value,
                                  discount_amount: e.target.value,
                                });
                              }
                            }}
                            type="number"
                          />
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                <Grid item xs={18} mb={3}>
                  <h3>Notes </h3>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <TextareaAutosize
                    fullWidth
                    style={{
                      minWidth: "100%",
                      fontSize: "19px",
                      maxWidth: "100%",
                    }}
                    minRows={5}
                    maxRows={6}
                    label="Notes"
                    placeholder="Type Your Notes"
                    value={value.solar_notes}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        solar_notes: e.target.value,
                      })
                    }
                  />
                </Grid>

                {/* is_finance*/}
                <Grid item md={9} sm={9} xs={18} mb={3}>
                  <InputLabel>Cash / Finance</InputLabel>
                  <Switch
                    checked={value.is_finance}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_finance: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>
              {value.is_finance && (
                <Grid item container spacing={2} columns={18}>
                  {/* calc*/}
                  {value.is_finance && (
                    <Grid
                      item
                      container
                      spacing={2}
                      columns={18}
                      alignItems={"center"}
                    >
                      <Grid item md={18} sm={18} xs={18} mb={3}>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            // defaultValue="sunlight"
                            name="row-radio-buttons-group"
                            defaultValue={value?.financial_institution}
                          >
                            <Grid
                              item
                              container
                              spacing={3}
                              columns={18}
                              justifyContent="flex-start"
                              alignContent="center"
                              alignItems={"center"}
                            >
                              <Grid item md={6} sm={6} xs={18} mb={1}>
                                <FormControlLabel
                                  value="sunlight"
                                  onChange={(e) => {
                                    setValue({
                                      ...value,
                                      financial_institution: e.target.value,
                                    });
                                  }}
                                  control={<Radio />}
                                  label={
                                    <img
                                      style={{ width: "100%" }}
                                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACaQAAAF2CAYAAACbeQ1UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE8mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4xLWMwMDAgNzkuZGFiYWNiYiwgMjAyMS8wNC8xNC0wMDozOTo0NCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjAgKE1hY2ludG9zaCkiIHhtcDpDcmVhdGVEYXRlPSIyMDIyLTAyLTE3VDE0OjA2OjEzLTA1OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMi0wMi0xN1QxNDoxNzoyMy0wNTowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMi0wMi0xN1QxNDoxNzoyMy0wNTowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ZDYyNWUwZWUtYjFjNS00MDkyLTg3YTgtYzE4NTBlYjk5NjMzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOmQ2MjVlMGVlLWIxYzUtNDA5Mi04N2E4LWMxODUwZWI5OTYzMyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOmQ2MjVlMGVlLWIxYzUtNDA5Mi04N2E4LWMxODUwZWI5OTYzMyI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZDYyNWUwZWUtYjFjNS00MDkyLTg3YTgtYzE4NTBlYjk5NjMzIiBzdEV2dDp3aGVuPSIyMDIyLTAyLTE3VDE0OjA2OjEzLTA1OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuMCAoTWFjaW50b3NoKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz76P7yWAAEGKUlEQVR4nOzdd3hcaXn38e9zzpmi6t69ttfe3nuHXcru0iG00AIBQm/hTYAkhATe8IYQAiGkQAghISQQeknofZdl2d69fddt3S1LVpl+nvePewbJXhfJmpkz5fe5rrlkydLMI+nolOf5nft2dz3vRLqRr0BmXoVUf0xpLCQ9t0Kqr0JqIMZXYGxLCucc6TkVot6Y4khIcTQgu6BMmPEA5PeEpPo8UV+FwlAEDjJzy5TzAc4BDia2R/QsrBD2VChPBGTmxkzsiAgiT1x0eO/AQ2k8YOFZOfqPKTLycIY5xxfY91CGvfdmWXLROIPHF4gLLtkfWuM5IKy+DYCo+vGp//ZAH7AY6AXiKR8PgAFgYfV5/EFeIwAmgO1A+SD/tw3YU/137Xn9lH9Xqm9L1bfxlDGISAsJso49u2POfcswG3foz1RERERERERERERERERERKQZoiN/ikjDzQdWAEuB5VjQbD5QS0vOBdYAaSz8FVT/HfB4EZA6zGs5LFRW5OCBtSKTQTVXfb9Qfd1hYDeQA+4E9gG/Bu4/wvcnIiIiIiIiIiIiIiIiIiIiItIVFEiTZkhjAbNjsZDZHGAtFj5bBPQD2eqjB9su01i1s1q1tFYRY4G2YaxK2p7qv2MsqDYObKw+NgE/qn5MRERERERERERERERERERERKTjKZAm9eSwSmdrsWpnK4BTgJVABqt0tmDKvzNJDHKWgupjUfX95Qf5nDwwUn28DhjDqqztBh4AbgTuxQJsIiIiIiIiIiIiIiIiIiIiIiIdQ4E0mY05wAlYO80TgFVY+Gxx9f8WVN+GCY0vKbVqb0uwn0tNGdgFPIJVT9uLtf3cAtwK3IxVXRMRERERERERERERERERERERaUsKpMl0pbCKZ8dVH7Xw2arqx1dhbTbl0CJgWfVx6ZSP7wXuBn6Ntf8cAzYANwA7mjpCEREREREREREREREREREREZFZUCBNDiXEglOrgeOrj+Owil/rgIHkhtZx5gFPqD4Ailgg7TosqLYH2AisB3YmMD4RERERERERERERERERERERkWlRIE2mGgSOxSqenQScCpwGnAlkEhxXt0ljwb9au88icB/wE+B6YBTYVv1YIYkBioiIiIiIiIiIiIiIiIiIiIgcjAJp3S0FLASWAMcAFwBXACcDC5IblhwgDZxRfbwTC6TdCnwJuBdr+bmp+lZEREREREREREREREREREREJDEKpHWfNDAHmA+cDzyp+jg2yUHJjAwAl1cfFeAh4JvAD4DNWDBtT1KDExEREREREREREREREREREZHupUBadwiBXqwa2uXAk6tvV1T/T9pXCJwIvBv4P8AW4LvA17DqaWPAOOCTGqCIiIiIiIiIiIiIiIiIiIiIdA8F0jqXw8JK84BLgZcAl2CtODMoiNZpHNaC9VjgDcArge3Ad4B/x6qoFYEyCqeJiIiIiIiIiIiIiIiIiIiISIMokNaZBoELgRdgYbRlWJtO/b67Q4S19RwA3gi8CHgM+AXwSeBRLMCmYJqIiIiIiIiIiIiIiIiIiIiI1JUCSp3ldOBq4GnAyVh1tJ5ERyRJy2KtWVcApwDPxAJpX68+hhMbmYiIiIiIiIiIiIiIiIiIiIh0HAXS2t884EnAU4HzgHXVj7kkByUtqR8LpZ0CnAO8DLgL+Bbw8+SGJSIiIiIiIiIiIiIiIiIiIiKdQoG09hQBxwNPBq7CAkZr0O9Tpm9Z9XEZcDlwI/Ar4KvARILjEhEREREREREREREREREREZE2pgBTe5kLnAE8EbgCOBVYmuB4pP1lgLOrj2dgIcfbgf8BHk5uWCIiIiIiIiIiIiIiIiIiIiLSjhRIawMuYB6Oc4GrscDQyUBPsqOSDnQM8CrgxcATgF8APwDuT3JQIiIiIiIiIiIiIiIiIiIiItI+FEhrMR5wQJD2zqX8mc5xfCXvzsX7F7qQdb7ikh6idL4e4PnVx3ewaml3AuuBkQTHJSIiIiIiIiIiIiIiIiIiIiItToG0VhJ4woxPefzx41tSp+Z3RW+Ii+7yfQ+noyDj6T+mSJDyxCWF0qRpnll93Af8B/BDrJXncIJjEhEREREREREREREREREREZEWpUBai3Chz/iyW1rYHZ2b35165+7b0pdWJpwDyA9nyO+NWHhmwJzjCgRZDx58nPSopYucBPwl8HrgM8A3gEeAfJKDEhEREREREREREREREREREZHWokBawpwjg/Np59zl41tT7991c+/Z5VwQUAubOQgCKAyFbL+uj9zuiAVn5UgPVnAh+Eqiw5fuswb4IPA64G+BbwEbsW6zIiIiIiIiIiIiIiIiIiIiItLlgqQH0K0cBM4R+Jir8e67pdHgK/seSZ9bGquG0Vz1Uf1k5yAuOvbenWXbz/uZ2JLClx0uTPCbkG62GvgI8D/A7wCLmNxiRURERERERERERERERERERKRLqUJas1UjO97zBBy/X9gbXlkpBL2+gvMxuENFBKsBNV+BsU0pSmP9zD8tx7xT8gQp8B7VqJJmSwGnAZ8AHgU+BHwdKCc5KBERERERERERERERERERERFJjiqkNd/pLuBzE9tSXxzfmnpGeSLoi0s4/GHCaFO4EHCQ3xOx6+Y+tl3bT3FfuH9FNZHmmgOchQXTfgA8K9HRiIiIiIiIiIiIiIiIiIiIiEhiVCGtGRwEIYudd+8eeTB9ZXk8PLGSDzI+Bhf6aQXR9nu6AJzzlMcDhu/LUhoNWXjWBH3HlHAB+Lgx34bIESypPk4Ang58Drgx0RGJiIiIiIiIiIiIiIiIiIiISFMpkNZgLmC+r/DqsS3pq8pjwRXF0TDtvScIvVU7O+onBhd5fAyjG9OUcwHzx3LMPTFPmPHEJZVLk8SsBF4NXAJ8A/hnYEeiIxIRERERERERERERERERERGRplAgrUGco8el/CVx2f3OxPbo2cXRcD4VhwtmXhHtsK9TrZaW2xGxq9BLcSRkwek50vMq+JLD+/q9lsgM9GBtPNcCpwHfBb4IFBIck4iIiIiIiIiIiIiIiIiIiIg0mAJp9RZAkPLHlUbDV5QngueWx4KzKvkAF3oIG5QOcxCkPMWRkD139Fgo7cwcfcuLBAHEFVVLk8QMAi8CngCcDHwFuAMoJTkoEREREREREREREREREREREWkMBdLqyIV+cSUfXFIaDX4vvyt6RnE0dNaaszllyoJqC8+R+zOU9gXMPzNgcE2RqD+2Fp6qlibJWQq8Czgf+CoWTNuV6IhEREREREREREREREREREREpO4USKsDF3hc6E+v5INXFvcEL8vvDZf72AJiTR+LA5f2TGxPURoPKY7kmHdSnsy8Cj52+LjpQxKpccCTgCuA04HPAuuB8QTHJCIiIiIiIiIiIiIiIiIiIiJ1pEDa0apmzVzAgnIuPLuSCz6Y2xVdWCk4XAAuSHZ4QcpTHnfsvrWXwlDEwrMnyC4uE4QeH6tamiTKAW8ELgU+iVVMU7U0ERERERERERERERERERERkQ6gQNpRciEQcHw5596Q3516XWk0GMQlH0SbyoVABfY9lKEwFLLognEGjikR9cb4isMrlCbJOh34J+Ay4C+ATcBEoiMSERERERERERERERERERERkVlpofhUm3DgHKm4zFPiovvm+JbUH5T2BYNJD+uQAnDOk98Tsv2aAXbf1ktxJITAt1R4Trray4BvA68GBhIei4iIiIiIiIiIiIiIiIiIiIjMgiJJM+QcS0sT7k9HN6b/K78zdUql5Oyn6JIe2WEEEIRQngjYc2eWrdf0k9uR+s3/ibSA44EPA58G1iU8FhERERERERERERERERERERE5SmrZOQMu5JzyePDR8W2p8+Ki68eDa+Ug2lQOXOiJS46xDWmKwyELz5lgzvFFgpTHx4BaeEqy+oCXAMcBHwS+A5QTHZGIiIiIiIiIiIiIiIiIiIiIzIjqY02Dc2Rd6F9XGndfGt+WuqKSC/rxtHZVtENwAXgP+T0RO67vZ8cNvRT3BQSh0mjSMs4DPo5VTFuc7FBEREREREREREREREREREREZCZUIe0IXOhPLQyHr8/tCl9UGQuXxWWHa/PwlgvABZ7SaMDeu3sojYQsOCtH/8oivuLw7f3tSWdYA7wROAH4U+COREcjIiIiIiIiIiIiIiIiIiIiItOiQNphuNA/uzgSvjW3K7qskne9rtr2slMEKU9cdIw8nKY4GrDgtJA5JxQIMzFxuQ3Lv0mn6QWeBSwAPoq18MwnOiIREREREREREREREREREREROSwF0g7CRR4X8oriaPBnlYng+Eoh6Kgg2lQu9DgPE9tSlMdDiqMBc08skF1UtlBanPQIRbgY+CBwCvAF4OFkhyMiIiIiIiIiIiIiIiIiIiIih6JA2lQOXOBX5vZELy6NBu8qjYZLfdxZVdEOykGYthaeu2/tpTgSMu/UPAPHFCF0xJWkByjCScB7qm8/Ctya7HBERERERERERERERERERERE5GAUSKtyzgc4f1Z+d/T6sU3pV1Ryrs+F4IKkR9Y8QcrjY8fIA1kKeyNKZ08weGyRqCfGlx2+w3N50vL6gJcBq4E/An6Z7HBERERERERERERERERERERE5EBdFLc6NOd8hHNXFoejj4w8nH5dJW9htG7kAo8LPfldIduv6WfP7T0U9kTWxjRSIk1awqXAvwLPBXoSHouIiIiIiIiIiIiIiIiIiIiITNHdFdKcVUDzjmeVxoJ/LuwOF+O7qyraobgQKgXHrpt7KQyFzD89X+pdVhoO0r4MZHwF5ysu6WF2shDopdv/Rg/tBOCfgb8AvgDsTXY4IiIiIiIiIiIiIiIiIiIiIgLdHHZx4CsuiCvuFZV88KFi3i3G28fFuAC8h32PZJjYnhpdeO7EdQNrirfi2RdmfBj1xiEe8BArnFZPHgujnQNcDCxOdjgtawnwIWAF8DFgd7LDEREREREREREREREREREREZGuDaS5gDml8eBV5YngnT5mucJoB+cc+BhKY8G8ndf3XbXrpt5HKwX3H/NPy29aesm4i0sucgEEmcl2nj7GIlUyW2ngacAfAhcmPJZWNQC8DWs//DFgZ7LDEREREREREREREREREREREelu3RpI6wfegefdcUyfcyiMdhguADyuUgh6fZ43ec/qveuzHx7blL4xLrhidlGZlVePEqRjfMURBFgFOoXSZqsIfBV4AHg78DKgJ9ERtaZ+4K1YxbT3AxsTHY2IiIiIiIiIiIiIiIiIiIhIFwvffNLCpMfQbCcB7wVeBww6BdGmx1kwzQVEQcgJvuIuKY+FpXIuuK08HjK+Oc3wPT0M35eld1mJ1FwLp0ld7ABuxFpSngzMSXY4LSkNnAKcC9wPbEl2ONIKXOTITXg+/d08I+NKyIqIiIiIiIiIiIiIiIiIiDRDtwXSTgD+DHgl0JfwWNpZ4ByLXcilQcRCD7cUhsNccV9IcTSkMBQxcn+G9EBMZmnZis85wCugNgtjwG3AI8ByYCWq63egEFiDhfbuAzYnOhpJnAJpIiIiIiIiIiIiIiIiIiIizddNgbSzgPcBz8eqKcns9QJnO8faIGJbEPFYEEFxb0R+Z4rivoCJbSn23tNDpRTQt6qIC63SmqqnHZUy1r7zbsBj1f60LT/eKuAMYDvwYMJjkQQpkCYiIiIiIiIiIiIiIiIiItJ8UdIDaIIAuAp4G/AUIJPscDpOL/BiYAXwr8BXgnScD9IwsS3F+OY0ccWR3xVRGgmJS46or8LC8ycI0p44H0AF1fqavgpwA7AVq5b2JmB1oiNqTecDH8Pam/5nwmMRERERERERERERERERERER6RqdXiEtAp4LfAB4It0RwEtCgLVKPBfIAvcCEy6EIOUJM55KLmBsY5rxTWlyuyKohtQy88uEgxVcWH2milM4bXr2ATdjwbSlWBvPINERtZ75wOnAEHBXwmORBKhCmoiIiIiIiIiIiIiIiIiISPN1eiAtCzwLeB5qbdgMc4AnAIuwoNROIAZr0xlEniDtwcO+R9KMbsgQpqAyGjKxOU2Q8aQWlC2cFmDhNDmcCta+815sW18F9CQ6otazADgb2IX9rKSLKJAmIiIiIiIiIiIiIiIiIiLSfJ0eSCsBD1T/fQwwN7mhdI0QOAc4CavitQko7vcZDoIUBCGMbUoz8kCW4fuzEDvCEHLb0sQlR3p+BReAVzDtSLZgbTxzwHFYMFAmzQMuwEKS9wJKJnUJBdJERERERERERERERERERESar9MDaQDjwM+wal1rgGWoKWQzrAYuxWqd3QdMHOyTXAC11p653RF7780ydE+W4khIZl6FSi4gNRATpOzzfKxf3SGMYqG0TViltCVYOFDMHOBCYDNwPwqldQUF0kRERERERERERERERERERJqvGwJpNXdVHwuBtSis0wyDwOXASiwEtJdqC89DchBEUB4P2XtnD+NbUvQuKxOXHOXxkDDjCVIeF1Q/WRmTqSrAeuAWrCrYGiCT5IBazBzgYiZDaYffFqXtKZAmIiIiIiIiIiIiIiIiIiLSfN0USANrbXgdFkQ5EehLdjhdIQDOAC7BqtQ9jAWnHse5yQfeHpVCwL6HMgzd3cPw+izZhRVS/Z7yRACBVVZzAF6V06bYDlwDjGGtUweTHU5LGcS2xY2oUlrHUyBNRERERERERERERERERESk+botkAawD/gVViVpHdbaUBpvKXAZMADcAeQO+9mu2s4TqBQDfNkRlx3jj6UZXp9l9209BBH0LivjKwEuPCDMJhPArVi71GOBFahVbc0gViltC/bz0RbToRRIExERERERERERERERERERab5uDKQBlIB7gNuwgNRJWCUvaawB4ALgBOznv+uIX1ELplUflXxAORdQKTgKQxF778lSGg8YWFO0KmnevuY3j+5WxqqA3YpVAzwBSCU6otYxCJyHVZO7J+GxSIMokCYiIiIiIiIiIiIiIiIiItJ83RpIA4subQFuAkaBU1ALz2ZIYT/rC7CWkg9hwalpcQG4EIIUxIWA4khIaV/I+JY0Q3f3MLY5xcDqImFPrFaek7YDN2MtU08C5iQ7nJYxFzgH2A3clexQpBEUSBMREREREREREREREREREWm+bg6k1YxgYZ0twDHAMlRbq9Ec1kLyLGA+sB4Lp83sSQII0p645MjvjijsDSkOhxT2Rux7OMPw/Rky8yukF1Wg4rq9MeM+4G7gAexnvyrZ4bSMecCZwF4USus4CqSJiIiIiIiIiIiIiIiIiIg0nwJppoi17XsQyADHAVGiI+oO87FQ2lrgYayS14y5AILIqqY5B7mdKfI7UuR2pqjkAia2pAhSnsyyEi7EmrNWujJzWATuw4JXWWBN9W23mw8cC2zAKvZJh1AgTUREREREREREREREREREpPkUSJsUA48CdwB54ASgP9ERdYcMcDpwGjABbAYKR/1sDoLIE6Tskd8dMbohQyUXUhkP2fdQlsp4QM+KEi7lcaHHx10XTtsK3IpVpVsJLEh2OC1hKVY17hFgY8JjkXrw4DKOQgCf/laB4TEF0kRERERERERERERERERERJpBgbTHGwJuAHZiYZ0lqIVnM6wCzgbSWChtuB5P6kIIs57CcMi+h9KMPpqmsDfCBZDbmiK/OyK7qEzQG1vVtNh1y297BLgF+1nXwljd8Z0f2mpgHdZC9rGExyKzFKQgN+b5/HcLfOeGIoVS0iMSERERERERERERERERERHpDgqkHVwJuA1r4TkIHIMFpaSx5gMXAcux9onb6vXELrCASpjxVAqOfQ9m2PdglvHNaaKspzwaEvV6woHY2nqChdM6WwkLX92JVQNchVp4rsYCejcAexMei8yCyzo2bY156V+OMqx2nSIiIiIiIiIiIiIiIiIiIk2jQNrhbQBuBDxwPGrh2Qwp4AysWtoOLJRWrOcLOGeV04KUBwejj2QYvi9L1BsTOEd+V4RzEA3EuMDCbB3e1nMb8EtsO18FzEt2OIlbA8wFrgNyiY5EjppLOfbu9fzLd/Pk67oHERERERERERERERERERERkcNRIO3IhrFgynbgWGARECQ5oC6xArgSKAMPA2ONeiHnLHQ2viXN3nuyDN3Zg48dmXkVisMhccmR6rPKad53bDBtHAulbcBCaSvp3haeEbAWqyB3S/WttBkF0kRERERERERERERERERERJKhQNr0lIHbgTuAxVgFpSjB8XSLXuAyLAj4AFYxrf6cPbwHvFVPKwxFDN+TZc+dPeR3RfSuKOHLjiDlcZEF2Oi8cFoM3AfchLVNXQeEh/2KzpUFzsKqx90DVBIdjcyYAmkiIiIiIiIiIiIiIiIiIiLJUCBtZrZgVaSKwClYYEoaK8J+1hcDjwGPYMGpunNu8kEMcSmA2FGeCBi+L8vooxn6V5YIU564GFg7z7Ajy4jtAH6OtfA8ie7dznuA04B7gYcSHovMkAJpIiIiIiIiIiIiIiIiIiIiyVAgbeb2ATdjbSSPB5YkO5yu4IClwJOxcNR6YKLRr1gLnAFU8gGVXMD4lhR71/ew9+4e0nMrZBeW8WX3myprDXs03xjwa2w7P5Hu3c7nASdjVeO2JzwWmQEF0kRERERERERERERERERERJKhQNrRKWJt/O4A5mKtDdXCs/H6sTaKJ2GV0rY15VVdtRJaAMWxkNJoQHkioLA7Ynh9Fhd6eleWIN6/ylrdHpBUe9AicD8WTBsETqUjC8Id0XIsEHkzMJTwWGSaFEgTERERERERERERERERERFJhkJUR88DvwJ2YeG0N9C9VaSaaS7wfGAN8BHg60ClWS8epvxv/p3fExEXHeVCwNjmNL5S/6xWpeiYs67AgvMmoOSIS03Pg5WAW4A/wNpWvhZY1uxBtIDnYNXiPgzsTHgsIiIiIiIiIiIiIiIiIiIiIi1LgbTZexD4Oyys8/vAOYmOpjuEwPnAh4BjgC+QQDvFIOUJ0p7i3pD8zqghtcPisqO0NyS3IyIzr8KiCyfsu48hLjiIaVbNsq3A32Db++uBS5vyqq3DYWG8zcCngHyywxERERERERERERERERERERFpTWrZWR854C7gXqy14WogneiIusN84DxgMbADC001nQuq4bSo/o8w46nkA8Y2ZSgMhVQKjrFH04xvSdOzpEQ4WMEFWL2+2DU6nFYA1mNtPLPAKUDQ0FdsLVlgLRZKuzfhscgRqGWniIiIiIiIiIiIiIiIiIhIMhRIq6+NwG1Ym8OVWHtJaaxe4EzgBGAEeASrG9YxXABhxhOXHWMbMoxtSjPxmOUdS0MRYxszhD2e1KIyeGfBtMaJgU1Yu9oysA4YaOQLtpgFwCIsmJdIAFKmwYPrDRgpej797Tz5QtIDEhERERERERERERERERER6R4KpNXfEHATsAtrJ7ks2eF0hRA4FmvjGWPBwLFER9QAzmGV01IeF3rGt6QZeTjDyEMZC6GVAuKyI72ggovAheArDQunjQHXAMPAUmAJ3VMt7Vis3fGNdOB21gmCFEyMeL7y4wLfu7FEuZL0iERERERERERERERERERERLqHAmmNUQBux6ooLcCqpamFZ+PNBy4H+oEtwG6smWVHciEEIYRpT353ij13ZqnkA9J9FfI7I8oTAel5FYJUNZzmXb1/GjFwK9bCcwGTQa1usBYLo/0y6YHI47lexx33l3nRB0cplpMejYiIiIiIiIiIiIiIiIiISHdRIK2xNmGBlRQW1umm1oZJSQEXAKdgVeo20GEtPA/GAWHKUxoJ2Xtvlr339DCxLUXPogqViYDSvpAoGxNkvbX1rG8wbSPw0+q/T8baqHa6LFYVbgPwULJDkQO5tGPr9ph//X6BuGMjqSIiIiIiIiIiIiIiIiIiIq1JgbTG24e1NtwKnI5V8ZLGcsAa4BKgjAWGckkOqOFc9QHgwQVQKQaMPJhh6O4sw/dlyc6vEKY9OKuq5oLq1/i6tPWcAH4BbMeqhy2eMqJOtQRrV3ot1rpUWoQCaSIiIiIiIiIiIiIiIiIiIslRIK05ysA9wA1YpbS1yQ6na8wFngAswkJpuxMdTTM4cFMevhxA7PAVx9jmNHvu6CHV68kuqFDJBeCdtfQM7DHLymkxcAdwC/YzP3n231DLW4614/0xXVCJr10okCYiIiIiIiIiIiIiIiIiIpIcBdKaxwNbsGppERbWySQ6ou6QBs4CzgGGgAepd8PKFlYLmrkAKqWAuOTI70wxfG+W3bf1UM4F9K8u4ssOH0MQWJBtlrZi1dL2YT/7nlk/Y+uKgNVY2PFOumjbamUu49i+I+Yz31MgTUREREREREREREREREREpNkUSGu+YaxS2ibgBEC/gMYLgFXAhVgI8D46vYXnQbgAghDiQkBpPKCSDyiNhIw+mmHorh7GN6cZWFMkyHp8ZdaptDHgRuBhYB2wbLZP2ML6saqHvwB2JTwWAVzWsW1nzGe+q0CaiIiIiIiIiIiIiIiIiIhIsymQlowccC9wGxZIOyHZ4XSNecAFWJvFjcCOZIeTDBeACyFIQVx2FPaGFPcFlPaFTOxIse+RDL3LSqTmVrBYmjvaul9lLPx3B5DFqgKGdfo2Ws18oBergJhPeCxdLeh13Hl3mTf83Tibd6mLqoiIiIiIiIiIiIiIiIiISLMpkJacMhaKuqH6/nFYoEUaKwOcBpyEBQPvp4vbLDoHQWThNOcgvytFfndEcTRkfFOavet7CHtissvLuABwQDyj6mkxsBm4HWuZejrQV+/vowWEWJW0h7CwqZJQCXE9jtvvLfPhL3VdEUQREREREREREREREREREZGWoEBa8vYCN2Ot/pbR2a0NW0UtPHQmVrnrfmAi0RG1AgdByhNEnsLuFBNbU+S2pyiPB5SGQkbuz1LOBfQeU8KFHl+eUTBtLxa+3AKsxrbzWfcFbTFZLFh6HV1afa8VuIzj4Q0V/vMnhaSHIiIiIiIiIiIiIiIiIiIi0pUUSGsNE8CdwCPAXCzU0mlhnVa0AGvhuQB4DNiZ7HBahwu9hdMynuJIyNiGDGOb0xRHQuKCo7A3omdpmSDrcaG3emCxO9JWW8G284eAHuAYrGJdJ1mMVT+8BRhPeCxdSYE0ERERERERERERERERERGRZCmQ1joqWFDneiyksxa18GyGLHA+VrVrFGsvWUp0RC3GBVY5Lcx6KnnHyINZcttThGlPcXdEbnuK1GCFcLCCi6pfVDlsOO1RrIVnGQtfDjT8m2geB5wC3APcnfBYupICaSIiIiIiIiIiIiIiIiIiIslSIK31DAM/BXLACmAhqpbWDMcD52I/64dQC8+Dcg7CtIfYse/hDMMPZNj3cIYwA74ckNuWxoWQmlexL4gPuekOAb8AtgHrsMpinbKdZ4AlwB3Y9yfN4sENBjy6Lebz31cgTUREREREREREREREREREZBqi6sNXH7OmQFprKgM3AA8Dy7HqXUGiI+oOC4BLgflYFa891OkPreM4cCEEkb0d25Ji+N4sQ+uz+Aqk+2IqRUdqIMZFVmXN+8flzWKshecdWIBrOZ3TwnMVsAO4GSgmPJauEURQGvV871dFvn+zCh2KiIiIiIiIiIiIiIiIiIhM4bBujQuBZcCxwInA5cDFWDfHBcBg9RFimYd4xi901/NOrM+QpVFWAn8EvJLOam3Y6n4KfAT4OZBPdiitz0+J7TkHcdExuK7IsitG8RWHCyA9WMaFgAdfcft9DbajewfwBmBu80beUNuBtwFfTXog3SKYE/CFb+V4+V+NJT0UERERmZ4ISNOYm2+K6MYAEREREREREREREamfRs1pO6yLYrnOzztVCugDTsDCZ2cAJwOnV/+vxmPf3xDwAHAX8BPgemB3dZzTKuwU1Wng0jhbgHcB64Hfx1pLSuM9GWsl+Y/Av2J/bHIIbmrxMw8u8IxtTvHwl+YRlx3pgQqrnj5Kqr9CXHaE2RgXeXzF1XZV24D/i+3Q/hyrMNbulgLPA24ENiU7lO7hVdNQRESknZwIPBU7b6pXeVOHXSz/GPhlHZ9XRJLnsGvF47G7OCt1et4Am+y7DthXp+cUEREREREREZHOcxw2p72C+s5pp4AvYt3lGmEAuAJ4HfBEoAfLix0sWFdLf8wHLgIuwApobQK+UB3nQ0xjbk6BtPaQAz4F3AP8MXB1ssPpGquBPwVOwaqlrU92OG3CgYssGFSeCMBDoRyx4X8Gcc6qoy1/0iiDa4t4b+08AfBMeM9nse38g8CTsPKP7ey3gFuBjyU9EBEREZEWdCLwWuwOrFydnjPArnMngBtQIE2kkwTYhN+7sGry9apmngFGgauAu+v0nCIiIiIiIiIi0nnWAb8LnEv95rQdkMXCaI0IpJ0BvAd4NnaT50wzGAE2f3Y81t3xpcAngc8Bew/3hQqktY8YuAZLHb4JeDNWTk8aaxD4Haxv7t8A36N+d2F3NOfARZPlqorD1f2ah23X9LP9Os/Cs3LMPzuHL1RDtvbmBuANeN4EvB77HbSrXuA52J32NyQ8lq6wX7U+ERERaXVp7E4spryt53PrzECk8wwAC7D5kHrOiaRo/xuiRERERERERESksVI0bk67EXNTvwu8FTjrMM9fAe7HbvIOq++vAhYf5HMzWMvP9wEXA38F3HaoF1cgrb144FGsteGDWAvPU5IcUJcIsR66y7D06KdQC88ZC1KT4bTC3pC45NhZdux7NEMl5+hdUWLZE8bsEzyPxBX313juwarUrUtk0PVxOfAKrHWnGko2iseOaJHWnUVERNpIhcadH/kGPreIJKeE/rZFRERERERERCQZMe0xNxVgbTbfi7UZPdBe4IfA9VjHgF3Y9+aw768XWA6cCjwFa905NYA3H3gB1sXgT4BfHGwQCqS1pzGs/N0GrFras9HvshlOAP4AC0d9COuLK0chSHmCtKc4ElLYHeJjR34opDQW4CsQpj1LnzC+KxqsfN7ng4d9zHuAp9G+d6w/BauU9q2kB9Kpgj7HD39c4EP/OZH0UERERERERERERERERERERJKQAl6OBcUODKNtBb4BfB+4B3gMKB7muX4IfA04G2vV+QwmMxshcAnwYayV588P/GKFmNpXEfgxtsE8AryO9m5t2C7mY2UNlwIfxdqolpMcUNvyEETe9kLOE5cC9t7dg48tsOZjR9QbV+afkbs2s7S0m7K735fcS33JLWvD5ksnAy/H8TMXsC/pwXSkrOPujRXu3qCOuiIiIiIiIiIiIiIiIiIi0nUC4CrgPcDxB/zfdcA/YmG0vdN8vgngPqyD453ArcCbgUVTPudC4P1YAO5XU79YgbT25rHU4nuwvqxvBi5Av9dGC7Dk51LgX4CvAzsTHVG78+ACT5idrG45dJeF08rjAT1LyveWJ4L3968u3NB/XOHtFINLfcnh26EYZo3jAl9yzy2OBZ9PeiidKFsMKI+3X1JRRERERERERERERERERESkDo7H2nSedMDHv8ZkF8BFwDI4ZBkghxXI2gGMVD9WwbJJ9wOPAm/HqqbVnuNy4I3V/99Te6JGBJd6sD6iC5nsLyqNVQS2YWnElcAxHHrjkfo5B/gz4BTgp0ABbe91E2ZjAPauzzJ0Fy4uudycE6I9pdHw11FvvK5vZWlBEPlUXG6PTd0FrC6X3Ctzu6KbnPP36S+0fryHLCHpSrt2dBURERERERERERERERERETlqc7C2mudP+ZjHWnT+MZYpeiPwVCzbcii1QNoDwPrq49bq/5WBzwHbgT8HLp7ydU+vft7Hax+IfD27mzlwjtNw/DWwFvvmFNBpDg/ksWRiHgsGSuMtA94GvBZLeqpfYJ0FaduFhD2e8cfSfnRDJt+zpDS+8OyJOf2riqn0nJi47Fp/T+MhCP3lUU/8B5VC8BYO34tZZiAdOe55uMSvHtKPtIUFTIbge7ATooDD/+U6oATsBuLq++Xqv0VERERERERERERERERExJwGvIb9C5P9CHgf1nLzbOBKrKXndPnqc7wfuH7Kx38ApIC/Bk6ufmwh8Dzgm8AGgCjqn8n4D8OBL7OykucNDq5Q9R/pMr3VhzSQCz1h6Cnsidh27QDzTsoz//Qc2YVl8I64heOA3kOQ9qn0nMpTxreEqz086LSfrIveVMC//HSCr9yYS3ooYiGzuVjgLAX0A2ms9Ova6ufMBdZgJ0OHC5eFWF/ye7EgmgM2A7uq7+eAcSzBP4aVjFVYTURERERERERERERERES6yTzgmVg3xZoh4B+xCmdgxZVmmqhwWIBtWfX5N0/5v//FQm7vAgaqHzsLeBXwAYCoZ1V91m6dg0renVfc7V5cHgMfgwvq8tQiIvtxkScuwdDdWfJDIYvPn6B3eQkX2r6nJauledsnhlm/Mkj7P4mL7h0+Zl/Sw+oEXhGkJGWw0NkAFjo7DjvROAU78VkHLG3A65aBx4BHsIDao8Dd1Y9twwJq48Bo9XNFRERERERERERERERERDrR6cBLprxfBv4ZuPYIX+exIiAFrFhIX/XtgY7DgmfvYv92n5/GKrO9uPr+HOByIAvko3pVMvOec1Nz/f9JL4wHJjYGlIYcccmCaqqWJiL15qrN/iYeS7FlZICF50ww5/giUW8FPPi49XY83kOQ8qmexaWrc9tTi4uj4T482kfOUtkF1rZVmiHAKp8NAscC5wHnAucAx2PV0AIOfqJSTxGwuvqAyUR/DOwDHsJ6lN8M3ANswcJpRawNqIiISFIi9i+ZXi8em2Ro4ZrBIiIibc1h18O6BbsxSjT3PCbA5jDqTedkIiIi0i0i7Py43mVCYux8SuUoRGbmNGzttmYb8FVg7xG+roi137wGu0Y6F3gKsOCAz+sBLqx+ztRA2g7gx8CTsOIlAKuAy4CfRHXZRXgI0pwS9vknBGnoPz4mv82R3xIQF1DYQkQao7pvKY2G7Px1P4U9eRacNUF2gc35eE9rVUurVkmLev1iF/r3A+/EqjvJLESBI9RxptECLBF/JnYS8lTgVOxiI1N9m6SQyRBcFliMheVeiU0CbwRuwnqbX4f1LdcFjYiINFsKuBh4InYMqteZagrYDvwCuL9OzykiIiL7WwhcAZyIwkb15LDFzK8y2UamGZZgcwYp6vf7jIARrALB7bTWrKSIiIhIvT0BC6Dk6vicIfAw8HMsTCMi07MUW7etKQBfxjpNHUkJuAH4N6zoRwr4MPAOHp/0yhziOX6Grb8+r/r+fCzYdk1d7sz2nrNdxCuCagY2zEDPCk/YF5PbGFCuNaVTYEBE6s2BCz3lvGPv/VkKeyMWnTtB/5ri5Oe00PSP9+AiH/YsKT+nNBH+cyXvdjntG2elHHsqLfQ77kCrgecCz8Ym3ucDvbT+UT3N5N3O87ATsRcAe7DF+p8B36v+W8E0ERFphjQ2Wfen2J1n9TqD6QXuwEJpCqSJiIg0xiLgRcCzsBucNBNRHwF2Y9k9NDeQthR4N3YeVTzC505XD3ZD3Bh2bqZtRERERDrZk4D3YQGWeskAP8LmtxRIE5m+lViFtJox4JvA8DS+1mPXRIUp/74eeCbWHWs6HgJuZDKQNg/rrpWefSDNAmgXhz3+qtr71pYOMgs9YSYmt9lR3O3wZVTUXEQaIog8vuyY2Jpi61g/84dyzDs5T5j1VimtVVSrpIW9cV+Q9q+ISzzoQr896WG1IwdkU46//NEwn71+LOnhdJoA6zX+cuyiYh3W87udj+IpLEw3H/t+LgFejd1t81PgO9idAq20xxARkc4SYAuVGQ59N9nRGsAWc0VERKQxUtjxtifpgXSoZldeD4FBrKpZPc+hBtE2IiIiIt2hdg41WOfnHSD5rjwi7WYesHzK+9uAB2bw9Y79C5GciLXdPNAQh15HfaT6usumPEc060Ca95wSpHh6mGG/0IePbcipQU+wFsI+yD/mqEyAq0tdNhGR/bnAwmeFvSG7bu6lOBwy/7QcPUvKxOXWKebkPThH0LOw9KI80b/GZbddVdJmzgHpDDy0p8R4UQWu6iTE2nK+CHgyFkrrxInUgMlw2mlYz/OXYun9bwO/BsYTG52IiHSqRjaUj1H7MBERkUbSsVamQ9uJiIiIyOxUUFcbkZlaABwz5f2tWCvO6UgDl1Y/f071ea7i8TdUbwP+HZg4xPNsxoqA1AJpacBFfjZ/zh6CtH92kOVZ3vH4qfVqtbSw19Oz0hP2OPJbAkrDPD5jJyJSB86BS3nKEwFD67MUR0Pmn5pj8LgC4PCtMCXkAQeZuZV5xZHwWZVicL+L/EjSw2o3Hkj3BmRTOpjUyVqsItozgLPoriorS6uPs7Ag3u3ANcD3sRMoEREREREREREREREREZFWM8BkgKyABcNmEkh7KtZZahDoPcTn/Rz4OocOjObYP6zWA6yLZpMv9RVWhf1cGGaqFdEO/XkEEWSXeMJshdxjAcVdjrgELjz61xcROZQg5fGxY3RDmtK+gNJoyJwT86T6YnzFtUYbzxDSg/Eb4pL7ua+4nyqkO33OQejgsz8b4+f3F5IeTrubD1wJvAK4AuhPdDTJymIV004DnoaF034I/AzYkNywREREREREREREREREREQeZ2rKoIAV2yjP4GsHOXT73QeAfwZ+BIwd5nnC6qMmBSyaVfPMIMXLXYqrOVh1tAPUAmupeRBkYoIeR3G7ozzmLJSmIIaI1JkLPM5Bfk/Ejl/3UdwXMvekHD1LyzifcLW06j4zM6+yuDQeXFocDa4PQp9LcERtJXAQBI7/vmmCh3dN93gqB3EK8EqsXeXBeoF3s4XAS7CKcf8LfA/4JbAJlYsWERERERERERERERERkeQVp/w7wlpvBnV6bg/sBB6dxudNTY3lgUejow6CeXrDXs4Ls/TOpNKQL0PYA32rPVEWclugNOJwjvr9SEREapxVS4tLsOeOHoojAfNPz9O/umgfL7sjBmobKvKEaf9a5/xN3vP9BEfSVny1JbQctRC4DHg3cDX7J9Zlf4PAy4DnAt8Cvoy189yb5KBEREREREREREREREREpOuNAiNYEC2DFSGZSXGyMWB79esXsH9y60TgE8Bq4C85dLLiwMRXEdgRzSKI8dIg4893KWZcZchXbDiZpZ4wCxOboLjXqhU5h6qliUjduRDwntGNaYrDEQvHcgysyxP1xuDBxwnteDyk51RWl8aDk0tjwffVxnh6vIe+dEAq0AHjKPQDzwc+AKxJdihtpQ8Lpl0FfBH4AnA7lvAXERERkfaXSnoAIiIiIiIiIiIiMzQMbMMCZSGwjJkF0h4APo4V6XghcBGQnfL/87COWz8EbjrEc8zDwmw1E4APflM4bYaPMMvTXMQx/mibVlWfJ5rn6T8ppmeFhdP8gYXcRETqxYELoLgvYNu1fey6sY/8btsXB2FCOx4PUV+FsCd+DriLjnaf3E0Ph7WBvmNziV1jSfZdbUsLgDcAH0NhtKO1EHgb8K/Aa4AVaPFSREREpN0FwPKkByEiIiIiIiIiIjJDO4CHp7x/EjAwg6/fDfwA+EfgzcB1B/mc1cBr2T+oNtXa6usClIDbgOJMUnGTPBeE/f74MGOhgFmJIchA39qYsM+R3xJQGsVCB2rhKSKN4CCOYc9dPRT2hiw4Z4L+Y0q4sLpPa3o2zZHqi68ojVQuLI0Hv9a+7/BSoaNY9rzpC0PctKF45C+QmmXA72MnEv3JDqUjnIKVqH0B8LfAj4BCoiMSERERkaPlgMXY3aPlhMciIiIiIiIiIiIyXZuBu4BnVt/vA54KfB5rnXkkU/tY3gt8DljH/sVNMsBTgPnA1gO+PgWcWv0cgCGsklox8N6qks3gEbgMb3UhZ87gB3B4MRBAdqmn/4SY9EJvYTRVSxORBnEOwDO2Jc32X/azd32WuOj23902iY8hM69Mak58HrjFBKDHoR8uhFQaKl4HiBlYAXwYeDsKo9VTCDwZ+BesBeqKZIcjIiIiIrPQ5CtBERERERERERGRWRsB1k95fwB4CbDoKJ/v88A3DvLxlcC7eXz1tUuAC6a8vwu4FijPrEKaBxxLowF/ZpCqQ3W0xz830RzP4Eme3GZHbluAr+X1NC0oInXmAvDeUxgK2Xl9H4WhkIVn54n6KtW+kE0ci3NEPfEz0nPKv3Ihn2zeK7efVOjIlTzeKZA2TYuAdwK/DaQTHkunWgr8IXAm8EHgVyhSLyIiItJudP4mIiIiIiIiIiLt6H7gTuCM6vsXA5cBX+bo5rx+BTwXa8VZk8U6R/0NMDrl408HLpzy/h3V8RAF4Qxe0pPy8Kog4hgX1DmQZs8Pzlp49qzxhH0VclsCyvucAmki0hDO2a6nNOEYuquHwt6IhWfl6F9VBNeA/dwhxDGkB+P5cdGdXBgO1bL4EDKRY3g85o2f38stG0pJD6cdDACvBt6AwmiNFgJXYz3U/w2rmjac5IBEREREREREREREREREpOPdB3ydyUBaH/Aq4Ebg0erHDtUr7mAf/ypwDvDHB3x8MfAW4K+wymwvAZ4/5f8fBv4H65NJ5MvTTHp5ICAbDcS/5SLmNaxTWrU1aJCCzBIIsp7cY1DckUwrPRHpfM6Bi8CXHWMbUlRyjsJwyLxT8gQpj680YRAegnRMkA4ujMvuiUHINU141bbjAke56Fi/pZz0UNrFc7DKXWrT2RwOOBn4I6xX+ruBnYmOSEREREREREREREREREQ62T7gR1ihktXVjz0ZeDnw91h4LAdMHPB1FWAvcLDF95uBLVirzpo08CbgP7GKaa8Bjp/y/9cD3669E007aOEBz9lhHytdSMMbGfiKhUTS8zxB1hP2BuS3OuICqhwkIg3hIo+PYWJ7ivJESHEkYMFZOdJzKlBxNCyIW+MdYdpfEES8oLQvuEYB3MeLUo7SuG9a5bo2dyWWWj/a/uBy9Aarb9X2SUREREREREREREREREQa7Q4sfPYhIAVkgLdixTM+C2zE2m1+HQugBdW3G7FA24F+AbwWWE614ln1a4rVz38X8IQpn38L8K9Y8A2AiHDaa6Vzg4x7nYtYhKMpS6zeQnBEvdC3OibKOnJbHaVhZ6E0hTVEpM5cAM55iqOOPXf1UBoNmX9anv5VRYLQE0+3quRR8B6i/pior3Lc+NZo0AUH3fF3tTBylCY83usAcAQnAm/GqnRJc8XAT4CPArsSHouIiIiIiIiIiIiIiIiIdL5x4PPA6VhltAhYgnXTCoD/wiqYXT/N59sD/PAgHw+B9wK/h1VJAxgFvgz8fOonRtMKdXlwIXNSA/EVLiBqdr0PXwEXQma5x2U9+ccCirvcbz4uIlJXDoIIfAzDD2QojYUUR0PmHJ8n6o2JS64xoVwPQcqTHohPS8+pvCCI+LcGvEpby6YcmXRMEKjw1BG8FGvXKc13M/BB4K6kByIiIiIiIiIiIiIiIiIiXWMn8BFgIfA0LDx2PBZKOwb4D+D+o3zuADgLawv6KmCg+vFS9Xn/48AviKYT6PIxEQGXBRnmNqs62kHGAA4y8yHKxuSyAYUdjkrBPu5ULEdE6swFEKY9E9sjSmO9FIcD5p+WIzOvgo/Bx/Xf8fiKI+qJV/UtKz+7nHMKpB0glXZEPrbDnRzK84AX0bo/JY+Vco2xk6I8NlZX/XcRS9Onqp8bAvOBHqwveat+X2AlbT8KXJf0QERERERERERERERERESk69wD/Dm2pnp19e06rMXmucBngF8C26f5fBGwFngitgb9JGwdF6AAfBH4xMGeL3LTWNZ1ASuCNK8hpH+aA2oMby3tgl7oWxcT9jjy2xylUYePLTwiIlJvQeQpTzh2395DcSRkwZk5epeWCFL1b+HpYwizMan+yor8UHqpg+1qTzypUnHEBRIJRreJecArgVOSHsgUeSx4thsYA/YCD2AnKA9hJVxD7GRoHzABDGKhNI+d5KwC5mDJ/cXV/58PLMDS95mmfTeHthPry/5VtIWKiIiIiLS6fuy6IqR+5++OyRtvSnV6ThERERERERGRmboFeB+2TvssLECWwgJqZwHfAK7B1mq3AcPY2m1tbbYPW5tdBJwJPBN4KtA75TWGga8Af4Ot/T5O5MtHGKYHFzE/7OV8l1B1tMeJ7U12pSfsg9xmKA5VW3g6UHhDROrNBYCHkQczFIdDFpyVY3BtwVp4VurcwtOBCznROV7vK3wQV9vriVWmS3oULe23gQuTHgQwggXQdgB3Ar8C7gYexU5OZiMElmL9z08FTsYCeIuwgNpcmn8mUCtF+9Emv66IiIiIiMxcgF03PRu70aVe4bEUMA58EHisTs8pIiIiIiIiInI0bgHeiVUuezE2B+KAJcAbgdcBD2PruPdh67sxVjRkBXAcFkZbd8DzemAztjb6T1ig7aCiI43Qe7JBwGVh1vck1a7zkDyk5nrCHs/E5oDCNocv28cVShORunNWLS2/J2THr/rI74lYcOYEqcEY5+oYlPKOIOXnpPriK/J7or/CU9Q+zXbtHkfaaxd/CKuAlwPLExzDHmAD8B3g28C9WMWzeqpgizuPAd+vfqwHC6ddXn2chlWL62ca5zp18O/Ah5vwOiIiIiIiMnsBdv3wcmBhnZ87B/wjCqTJzI1jk/jdNuXhsMWOsaQHIiIiIiIi0oE2Am8Hfg68GTgHq34WYEVATqg+YDINdqjr0hgrPPIz4B+Aa7F120OKXHiE4QUcT8Tv0pwF3ZmpBs+CDPSvjUn1OyY2OyrjTqE0EWkMBwRQzjuG7s5SHA5YdP4E2UVlgtDaCs82uFtr25ldVF5ZGIrWeM8DTvszAgflGDbtrVA8UnXP7vRykmvVOQJcD/wrdhKyF5pa2S8H3AzcBnwSS+1fglU8uBirnhbRmDOD72MLTrsb8NwiIiIiItIY6rEgreZnwAuBNLYw0E0cFsgTERERERGR+isDXwV+BFwF/C7WtnMOVu29lgU72DxJGQud7cRCbT/GipIMT+eFo8NW9PHgUixIDfizW646Wk01eOZCyCz1BD2e3OaA4m6F0kSkMWqtgX0FRjekKY5YC885JxQIMx5/2BzwDF4n8suCnviVvsIHnSNfn2dtX71px8Y9Zd7433vYtFeJtAMMAE/GSq02241YdbBrSD6UVcEqsj2IVWr7JrAaeBo2sX86dud1vVwP/DVwRx2fU0REOlujrlAVrBARmZk63E4mUldloFB9SPvSOZmIiIjI7OhcSqQxYqygyNeB7wHHAE8ATgbOwNaY12DdpzZjbT53YGuutwE3ALuwddjSdF/0sFXPvKcnCLkoyLT4H763qkTOQXouhOmYfJ8jtyXAl+i+e8pEpClcYNXM8kMRO2/upTAUsvCsHKk5sbXvnM3UtncEIf1Rj79qfHPqY3GZvOvyfVkpgME45E8unc/bv7OLHeN1Sv61P4eF0Y5v8utuw6qRfR4r99pqizklrHLbncBDwJeB87HU/5VY4n827sPCaD+b5fOIiIiIiIiIiIiIiIiIiDRaqfpYj62f9mGFT1JAD9bGMw8Uq4/x6qN4NC8WBZlD/6ePOSNI8dtH88RJ8NWl8LAXeo7xhL0xE5sclbFqnq61Y3Ui0oZcAM55SvtChu7NUhgJWXRujr7lJauidpRNC30MQcqTmV86ZvTh9MpKPhhyYavlfZqr7GEgE/CktQFzegIF0iZlgJdhlcCa5Rbg/2FhrOEmvu7RmsAqpj2GtfY8B/gtrGraYc6EDmkUC+N9t07jExGR7lDGqmp+tfrvep3cZYBHgU11ej4RERGRTjcE/Dd2HlWvMvxprI3NA7TeTXsiIiIi9XY78L/Yekm9pKrPu6eOzykiB+eZrNI91KgXiQ7ZWs7ada4Is/6sRr14Q1SrpQUpyC71BBnIPwaFnQ4fW3hERKSuHASRx5ccYxvSlMdC5p+WY+6JBcJsTFw+yjSs80Q9fjA9v/yCuOAecSFj9R14e+lJObaNFHnnV/fy4O5pVwLtBiuwgFWz/BL4E+DaJr5mvZSwBfuNWDDte8DzgKdjdwBM10eBf+Mo7wYQEZGuVQB+DNxKfRcpHXZMatjEgYiIiEiHeQz4M6y3Sr3OyxwWbttbx+cUERERaVXfB24C6lk9wmEFBjTHJdIhIn+INX0fQ5RibZBt7oDqxceAg/R8T5D2hD0Bua2OOA/usI1KRUSOjqtOYU1sj6jkeymMRMw/LUd2QRlfdr+p4jht3uEcvdl5lWcU94X/gmesqys9RtDbD2esjrh2o2OsoLk97G6RJwHzmvR61wB/SnuG0aaKsVDaJiyY9nPgFcB5HL6duQc+C/wL9b3rR0REuoPHFij3Jj0QERERkS5XwG5YExEREZGjM4SCYyJyBNEhw1kVzncBzyTAlm3bkQdfgagPwtUxYY8j91hAaZ/9t6qliUjdOQgznuJoyNCdWYojAQvOyNG/qoTD4yvTT5R5Dy70ZBaUjy2OhH2Vguvq/VauAAt6Iv742fP55l057t+uKmlAP/BMmhNIuwH4c9o/jDaVB+6vPm4BXgK8AFh5kM+NgW9hrUq3NmuAIiIiIiIiIiIiIiIiIiLt5uBxNGt5eUqQ4dJOKC7tYyCE7ApP0BOT2+Io7nH4Mrgw6dGJSCcKIo/3sO/hNKXRgAWjeQaOLZLqr1gLz+nsW70FZ1N9cX+Q9pfHZfeoC33XtghMh47hQpkv/nKCHSP1rADc1vqBM7EWE420A/hbrJJYp/o1sB64DXgDcC6QnvL/NwAfQndQi4iIiIiIiIiIiIiIiIgcVuTLj/+gjyFKsyjI+lQnBNKA31RLS8/3hFlPLuvIb3fEtYpD3dwGT0QawjlrEZzbnmL7aEhhOGTeSXmyC8v42FlY9kg8eE8mzPiXuSD+sQv9Iw0feIvqzzi27ijzoR+NMJxr19KddXc6ML8Jr/NJ4HtNeJ2k7QM+B9wK/B/gWcBC4AHgL7D2niIiIiIiIiIiIiIiIiIichiHqqiy0oWcGaSaOpam8BUIeqB3jadvjSfqt8TdtIIhIiJHIUh7KgXHntt72P6rfsY2p/FxtULjEcKwHgu2RX2V01zkBzsmJHwUKh6ykeOM5ekjf3J3GAQuAbINfp1bgK9iYa1ucRfwLuBTWDjt48CPmF5tQxERERERERERERERERGRrhYdLHTmK1xEwGUdu+oaW9Wi7ApP2AsTG6E86ojL1h5PRKTeXADEMLohRXGkn0Xn5RhYUyDsifGVw7Tw9EAAmXmVebkd0ZzSaIgLO3bvfFh5YEEq5NMvXMDV/7yDR/YcpMRnd+kBjgcaGR8vAB/FWll2m91YEO1LwD0ojCYiIiIiIiIiIiIiIiIiMi2Ryzz+gw7WBhnWdPTSqwccpBZ4+ns9+U0B+R0OX+LQdeNERGYjAOchPxSy9Rd9LBgOmH9KntRgbK05D1Gp0QFBygcu4JkE3O1C9jR13C3EhZBKW9U4oRc4icYete4Afk33hrH2VB8iIiIiIiIiIiIiIiIiIjJNUWV8/w/4GNJz/ZyoB3ynLz9Xv7+oB3qPjQn7HbmNAZUclgBR4EFE6s1BEEBcCNhzew/FoZAFZ+foWVq2WJHncdGf2rup/vgZwJdd0L0BmVTK4WKv/bPpBdY18PlzwJeBHQ18DRERERERERERERERERER6TCRr+z/AR9znoeLCYDKQb+ms/hqR7w0ZJd6wp4KExsCSiPuN1XURETqyoELPXExYN+jGYqjIQvOzDGwtkiY8hZAmxpKq/47M698Yn5Xdl5xX/e27fSRIzdRsTanchqNbdeZA34MTDTwNUREREREREREREREREREpMNEYe/+H/AxlwUh53ZVcy5frQYXQHoehJmY3FZHfltAXAKnFp4i0gAu9PgYcjsjdv66j8LekHmn5kkPxhwYFsZBajCOcH5lecIRNDKG1MIqkaOSd51fwfPIssAiGhub3gBsb+Dzi4iIiIiIiIiIiIiIiIhIB4p8acp7HoKsX+3SDHblYr8H7yAcgJ5VEPZ4clsc5bFqKE0FeUSkzlxggdjCSMjQnT0UR0Lmn5anb0XJQld+/8+NBuLL04XKz4LIb0hqzEnKpBzpdAUXdONBaj99wCqs0WsjFIFbsSppIiIiIiIiIiIiIiIiIiIi0xbFUwJpPoZwgDlBGrqqQtpUHnwZwqwnu8wTZmFiS0BxyEGsamkiUn/OgYs8lXzAyIMZSqNWKW3wuDxh2uNj95v2wlGvvzQ7v7IuSHVnIC2bcmTSMS5MeiSJi4B+GheVzgF3AYUGPb+IiIiIiIiIiIiIiIiIiHSoaL9FfccZLmKtC3h8u7gu4ytYC89FEGRj8lsDCjsdlTwKQohIQ7jIwmfjW1OUxgNK+0LmnpQnM6+Mjx0+hlRfZV1pJFxUGAu6MiAbphylMQtQd7kMsIDGBdIKwEagdKRPFBERERERERERERERERERmSoKeybf8WWe7Byndm11tAN5C6ZFg9CbiQl6HIVtjtKowznUwlNE6s4FHuegOBKy+7YeivsC5p2cp29lkSAF6TkVN7qBuRPbUgSp7ttZ+8iRm3D4StfvgGstOxv1g4ixKmmK/omIiIiIiIiIiIiIiIiIyIxEpX3VtWwPUb8/yUUs9N2XcTgsX4YgBT0rPFEP5LZAca9VK+rGCkUi0mAOgsgTl2HvfVmKIwELTg8YOLZI2F8h1R+fEfXGi4OU35n0UJstihwRsYWCu1sApBr4/GVgqIHPLyIiIiIiIiIiIiIiIiIiHSqaeMRZJTAPg6f6BWHG/i378zHgILXQE/R4gs2O4u7AWngGqFqaiNSdC8B5z8T2FKWxkOKotfBM9ceX9S4tn+lC/6Okx9hsPSlHz2iMC3WggobWMy0Duxv4/CIiIiIiIiIiIiIiIiIi0qGisJdaIG1ukGUOIVBKelgtytsj7IO+4z1hnye/1VEes4+rWpqI1J0D56A8HrDr5h4KIwF9y0urg0y8tBvbK7sQCL1CwI2XApYBGxIeh4iIiIiIiIiIiIiIiIiItJmoZ1Vs//JcFfb4tVSSHVBbiC0U0bMiJup1TGwKKO21j6NQmog0ggNfcQzfl6WwJ+pLD8Q9Pk56UM1XiBzjuZj5QcTDlJMeTicLgb6kByEiIiIiIiIiIiIiIiIiIu0nCrLVf3kudSHHJDqadlJr4TnfM9BTIbfJkd8Z4Gv5CFXvEZF6c0AM+d1RWNjD3KSHk4RxIHSOvz13Ja+7bgv3DueTHlKnCoG5WMy6C6OPIiIiIvsJ2P/2sxidI4mIiIiIiIiIiIgcUhRMTqmuxZH2XdgC7qh5wEHQA73HecKBmNzmgPJ4NY+mUJqI1JkLwFub5WOBQWBf0mNqtjCARZmITKCdbAP1AmcC3wUmEh6LiEizuSlvPVYx8hhgfvX9Az93D7AZ218G1c+pfZ6urkTag+M3t3/QA5wGZKrvZ4A12D6gFkTbDmzCQvxF4G4Ovg8QmQl3wNt52PGnn/0DkA6oYNvhVqDE5DFL256IiHQjN+VRAdYBK2C/9gq1Y+UI8AiQR9dv7W7quVPtXL4XWAks5OC/T4edv28CdmDn8zB5rqVtoLsdeD4eAIux68HaPoQp/zeMbUujaH/SDQ7c51SAOcApTP7+p4qAjdWH9jXSCAduk2Db5RpgFRy0zVTt8zZhcwoVHj+foO1T6ioq7nbgIL0onhNESQ+nDVX/JIMUZJd6wmyF3JaAwh6nPJqINISznctq7KTiziTHkggHhdgTK0HdyMNMH3ABtiCrQJqIdIMQOLH6OA5YDpyMTTwCZIH0Ib62COSwK4MJYBt2Qb8DeAy4A3gQK/QpIq2hHzufPg44vvrvldVHgN34UZtQDrCFrRSTE3S1v/vawtcoNon3ELbAuQULqd0DDDXpe5L2NBc4CTgLOLb6/snYNhpg5+MRj58Q9kABW0z32GLYdiYXPLYC92Lbo4iISKfJAGuxc7naYzmwFDtn68Gu4Q42eVjGrs1iJoNJO4FdwAPYtduj2LFVWkcfdt4+F5sTr73NVt8uwUL6Ifb7P9T1O0xeuxew7WUY+70XgQ3AXuC+6r93VT8une147Jx8HXZNuBoLtaarj96DfE0t3JjD9icF9p8P2oqt3dxPFxYV6BABNk94DLAIu3FtHra/WY0dT1LAwCG+3mHbxwT772sK2FzBZux4UwtJixxOFpunXoXtnxZjcwcRFsJehu2vKtg+q4fDB8ty2HZXC1duw+axh4CHmdyP3YdtsyJHLaoUAMfSIKLPReArSQ+pPfkKuBBS8yHIxIQ9jvw2h684VUoTkUZYXn10XyBNwE4AG724eSp2Urunwa8jIpKU5cClwIXY3YxLsDsb52BBgAxHdyZfC6tMYCGVPdikU+0i/ibgRmySW0SaYxA7tzkDOB1btFzI5N/8HA6/aDVdZ2MTevuwc7Vd2ELWbcCvgfXAWB1eR9pXH7YtXgacgy1uzGVye0xjE8pHc/yJsQX2fdW3w9gk8sPAXVMeWuywY3UZ3fktItJOVmE3T56LndMtxo6dc5ndudyFTIbUhpk8j3sYCwzcAdyALdxK42WxQNBabKF9HXaetAT7XWewc/va2wgLjQQHea7p8ti5WYz9/vPY9fq+6uMRbA7+DixcNDyL15LWsBjbn5wFnI/ND9X2J7X5oKPZpjwWjJzArvv2YNvSDmzbuRubD9o4m8FLwwxgXWNOx8Jnx2JBtH4s3DO/+tYxWfFsJmr7mgq2bYzx+P3Mndi8wa5ZfB/S3gIs8LgOOxYuBU7A9lO1Y18fk9tkgG2Ps02j1PZfeaya7ET1sRvbZ63H9mG3o+1TZigKsz7AcSERC5IeTLvzMeAgGoDeNZ6w15HfCqV91mZPwTQRqaNaBQfpTjnsboVq8+iGmA88D7tTRwunneUy4MnUdzI1wLaTn2MTtt0oAH4HmySv10Jv7e97K/AdWivAtAa4HLsYPlj576MVYncHXoPdmVVvi4ErgCdid8CuxcIAmTq+hqs+Xwa7c3LVlP8bwe7AfwwLp/0CW9xoxPcqrSeFLXjVFjvqFYRIYRPc12JVHcTMAy7Gft6nYHeQLsMWsxpVHz7EJgb7qq8F9rt+BjaBV6uc9iMsnFqv48Uc4JXYBHqpTs8ZYQuzN2Jj1e2Ls3MGth2cix1D12Ln2/UUYNvAgXfoT73b+X7gVuCX2LbYrnc6R9ji4eXMfH9awfabl3DwahezFQGvxs5nehrw/NMRYvuCH2ALB/HhP12kKy0FXo7tD+p1jIuw8/1fYcGVVgq9Ouz7PZb6X69uB76LLVjW2ypsf/0E9j+f66/ja4TVR4b9j81XYN/TVuwGg7uB66uPVro2b2cOC5udjAX2T8Z+vwux38UyYAGzC5tNdxy164OF1bdT591L2OL7Vmye9D5s7usWrNpRt50nZ7FrrAuo37UH2O/gMWw+aEMdn7dmHnY9/gTsRqI12JzWIPWbX3dMVlWby/7b0RiT5+T3YPuSm7Hzc0nOOmyO8FzsmLMcO9Ysof7rLrV9TVR9nakux8LQj2H7mQex487N2PbSqufzl1cf9VxnqM0N/wI7x+h0fViFxlOwiny1CmgLsWPgHOy6tRnHwtr+a/Ag/78Hm9PaVn17B/Y7Wk/3HQdlhqKwlzSOS51jYUtdIrUrb9XSgixkV8SEWUduq6Ow2+FiGr+7EJFusQBbQJfulMNO/GKO7m6c6egBXgN8CzuplM7xJOADWOWmeomwC8QhujeQFgKvwypu1etnW2sXdxNWWaeVJr3XAr8HXER9Jx0yWFDjIeob0joTuBJbvD4fW4hJwhzsTsvTsWDoM7BJ7OuxhavbaN1JJpm9NLaw9T6sil69rsB7mbxDsdsDafOxxYWLsADQKdjCVqPOl6YjwMKwi7H9z7OAp2GTyzdg+7zZtlWcA/whNmlZr3brGWyb+hi2b9IE48ylgauxc6+zsUWOQ7VzaaSQyRuaLgSeibXzvB27meAXNCZE0EhpbOHoz7Ft82iOnbXJ9npLAW/AxpXUralpLFC6E1s017mFyOMtA96LnUfVqx1fDxaiyGMVTlptteU12DGp3tert2HXrPU6ltRapF3NZHDkGBp3Q8HhxlE7hzsLeDp2nXpb9fFj1LniaCxismLxOiwUtAarBrOI1lxBSzHZreQ87Bi/GTufuoHJoGI959laWRa7nnkndr5RLz3Yz3EL9Q2krcH2fU/AQnTHUd+bEqerH7sx8nhs7vDZ2Bzqr4CfYTcC1TPgJ4d2LHYtcQ5WeeoMHh8Qa7YQ2wcuwo45FWyu/T7suu2G6mMLrXVu/xRsjque+78M8EMslNeJgbSF2H7o+OrbNdgx8FhsTifJ+avDWVB9nFl9fwg7D7oHCxLfiN2E3Urbp7SIKEiTwnGqC+jzrXaJ1MZ8GQggvdATZD1hNqCw3VHJgzva5gsiIvtbiU0012viTNpHHlsgbPSR+1jgJdhC5HCDX0uap7bwVu8F0VrLhG5Wq7LRiJ9tq12MprDJtIj6f7991GexIcAW3p9cfVxAfe+kn600NvF1AvBbwHXA97GJyDvRRGQnctjkfSNCEP0NeM52sgYLez0Bm1g+EftZt6IUk+HYZ2KLm9dgoaC7OLpz+wDbBkLqu08ewH6OmsGYmX5sO3wqtlh3Iq21uLoAq2pxGfAc4H+wYOSvsWqL7SJN6/6d9yU9AGybSyU9CJEWVjtmRtT3OrZ27GxFrX69msJCAVdiYY0raa05hgxWxetUrKPAM4DvAT/FAmpycCF2zXs6Ns94EtYKrxHVYpslZDJI93TsHP5X2Dn9T+nMAMVUAbafq1Xnrad+6nf+chx2vns1FppZVKfnrYcUVgVpFbavezqT+5NbqV8lS5mUxSqon4PND16BBY5bVYiFk1Zgc5qPMlm9/JfYfqcVWknXznladW64FQRYsP4EbG7gdOxYeAK2DbbSXMFMzGeyC8kzscBkbW7rATSvLVNEYS8O6Gnbzb2VxZYUCPuh99iYIOt8acitLw65DZUCgQvIugBcqy0vdocYO+k7Bjvp02+heYrYydJW7EI+TevdMdgO+rCL24XYz7JrxN5WxC5f2s+GsSL7Sl0ZuJ/AynlXaOyJeYjd3X8n8NUGvo50hhjdAdMoZVrvWOlp3Jhm+9wRdqf1E4BXYZWSWn0SI4tNkF6BXbx/BWvTuinBMUljtOrfTTty2F2kF2CTX8/EgjbtZDHwXGwB4ibg60y2v26FVorduF3NxgBWBe2ZWNDrhGSHMy2rgLcALwS+BHwDW+CoZztuSY7+fkWaz9N918WzvV4NsHO6K7GbIp9Uj0E1WD92/XYpdmPRl7AgySNo3wt2fXsKtvZyEvZzupT2DaAdSa0K+nOwdtnfwip9tVPQfyYauY3P9vrDYTfx1268eDpWTbqVRVhr4kuw64hvAd/E5v61P5m9pVgI7ULs2vsM2u+GK4eFeNdix8lfY3MHN2Cdbdqt2vV0tPtcRArbF52IzQuci1XYPIHWn6OeqYDJkPYLsZvdvoEdDzcmNippKVGQ9Q7odbUCy1J/sVVF613lXXkhm4PNfKUyzvVBivHyGNnyPucIAKdwWhNVsCDU+cBLsQvIVrrjqpOVsDT/l7EWVXkm79CT6QuwUNJQ0gNptrL3RM7x/rOW8sC+Aj94rFuqoT/OI9g20Oh912Lg/2AV2X7R4NcSEZmtAezOwddhVWna7ew6xBZgLsYm7P8Du9N6LMlBibSY2p3C5wLPxypUtFL1w6ORxv7mL8Cukf4ba1FxH5qpaQcB1m7jRcDLsDax7WYJ8HZsEewfsEWwjWj7ExGRxpqHVdZ4LVZxrN2u32o3Fl2KhUg+hQXUurEqSC8WdF+JLbo/E2vrlUS78qQsA34Xm4v4CvBFrNpVK9xo0g1qwa5XYaGddlxzuqj6eCK2P7kW2JvoiNrXYmz997lYe9SlyQ6nrmrbyUZs7uB/gbtRh5uk9WCVGFdhlUCfWH2sSHJQTRZix8CrsVDaZ7EA5Z4kByXJi5xVRtOdj43mwXsIe/zT+k/wi4HYRXwjt8U9ltsILgW+BOVRC2a7TsvHtq77sZO638cmjlu5RGun6MNS0kuBDwM/pssqfMnsWH7ac+PuCbbnuvrwNYEtUl7chNe6GPgDLBBxSxNeT0Rkphx219nrgN/D2sa0syzwcqzK2yeAf6MLQ+giBzGA3e3+SuyO93ZcZDicFDaxfB52I8A/YKHUZrRql6MzF9sm/wCrctnu1gEfwSoIfAJrC1NJdEQiItKJHLZg+3osjLYk2eHMWhb4bez4+bdYQGBnoiNqjhTWvWMFNnf4AuBs2v96fLaWAm/DFuQ/DHwfrX802nLsb/DtWJWedvd07Aasz2DBtM3JDqetDGBBtFdgQbSFyQ6noVYD78ECmP+CBWEfovsqtSZtYfVxEbbfvwwLZ3czh91A+kQslPYpLECpbbNLRdji8t9iJ83nJjucLuABxznAx3yZk7NL/Cezi/1mF0Fp2DF6n8NXoJLD/iwduGr1NGmYjcB7gXuxC4XTkh1O17gMKzH7D8CnUUJapikKHMXY88e3bOWOoXzSw0nSPqz8+7lYVY1GezZ2h8P/xcpBi4i0igi7K/09tEd7l5lYBXwIC9v9NTaxJNKNAuzv4NVY1YFFiY6m8Wr7tXOxu0r/Drgj0RHJwRyDLXq9Fqvw0ikibFHjQuD/AV8AcomOSEREOkkPduPNe7GFyk6yBrt+OwkLdt+X6Ggapw8LXZ2LVYh9Cp11LlQvJwD/hFWe/SBWwUjqy2HtGN+J3dTXSRYDf4Kdk78Pm49XmOPQerCba16CzRl0U1Wq1dg+5iXAX2EtE7shFJ2kNHZz2plYGPvp2PyA0hz7Wwi8G8sD/D/g51ihDekyAXan49exg/V/AsVER9QNrPPxQjzvwvH3hFziPS4a9Mw7r8LcMyukBiBIQ5gFHPgK+NiqrElDTGAJ8tdjFwhdXXapiZYDH8AWWE5CB2uZppRzeG0uw8B3ae4J3DOAj1ffioi0gizWVvg/6bwwWk0Kq/r2T3RG9R2RmZoDvAb4L6wKVaeH0aaai7Wc+W/sWnVukoOR3wiwha9PYdtkpy7AHotdq7+D9m+LKyIiraEPeBM2D99pYbSaXuCNWCCtGV0NmikLnIKFf74JfA6rgNKp50L1kAFejJ03Po32a0vbygJsXfu/sO5HneopWEGHZ2HfszzeIDZv9kXgj+muMNpUp2Hbymewal3aXuovwLav1wGfx6rSvQG7objrFywP4xJs23wLFh6VLlNrDOmx1oXvANYDb8WCItJYEZ7n4jkO+HvgP13IeNgLg2dUwFt1tNH7A4q7nLXx9BZMA7Rrqz+PVRt6B3b30u/R2eVcW0UKu3A4GfhL7GJWLUHksCYqMRUldAHuATbR3MXJi7Bj1nHYxY3uaBCRpCwD/gyrTJNKeCyN5oArsdYDf4S18hPpBicA7wJeii1gdqMAu3nn49ii5ofp3Gob7SACfgurytkNXQb6sAo2/dg2uDvR0YiISDtbilV9fj6df15Xu37rw65Zf5LscGatD5sPfE71sRy7BtcK1fQ44FLsJrN3At/G1qLk6M3D1rHfTnes4Z0GfAT7W/wyWj+rCbD2nO8BnorNmXW7XqzTzVlYAPw7iY6mc4RY1f4XA8/DqvHppq2ZWYFVSxvEOqftSHY40kwHpmOHsAmmN2PBHGmOU7EWaB/0Mau9h7AHwl4IeqD/eM/c82Lmnh+TXenxOtVotE1Y6ch3AXcmPJZucg7wMewiXXdVyUGlA8doqcIf3LSVu/d2dbvOmnHgOqDQ5Nddi+0n/w04r8mvLSIC1rLg77Ay/J0eRpvqIqwFzOVJD0SkwSLsLvd/wyqEdfqi5XT0YD+TzwDPTXgs3SqFteP4EN0RRqvpxyaO/wSYn/BYRESkPZ2Jzfv+Nt11XncJ8BdYUKJdLQPeD3wWqwKzBmtVpjDazB0L/CNW5X1OwmNpZ4PYjXp/RHeE0WpOwPYnr8H+BrtdH7ZP+g/shiGF0fbnsQ47Uh+vAv4H23+ficJoR2shFsz+OLAy2aFIMx2sXGMOS8y+ESufpxaezbEYCwL+HXCFrxD4CvgyhL2e1DxPNOjpXRUz7/yYvnUWTPNlFFBrjDGs1O9bgC+h3uzNsgo7oH8SC2qK7CdwUPHw6KgOTVWjWAunXQm8dj92V+unsQWqxQmMQUS604VYKPZFWMuQbnMxFoa4Ai0CSGcawIIvf4Ut4nVT6PRI0lh1hY9gcza1n40qLDTeQuB92P53XcJjSUKtffTvY3fdi4iITNf5WCWMl9KdIYqLsWIEVyc9kKPksRsjjsHaT8rsrMCudZ6T9EDa1GnY/uRtdOc56TosiPcMurv963HYdvA+LKgn+6tgldVvSnogHaQXK9Kg4OPs9WFz+h8AliQ8FmmSQ/UPLmOVod6LVSva2LQRdbc0Vkrzb7DJ5T5gMnhWBJeG9CJPdkXM4Okxg2fGDJwa40KIC/Z5ik7VTQn4JfZ38JfAzmSH0zX6sbKnnwZeQndeWMhBeCBwjr4oINTy+1S3ALcl9NoRcDbwx9jdSC+ju+50FZHmuwj4IPDkpAeSsIuxu9TXJjwOkXpbgk2cvhtb9JKDOx7bF/5p9X2PQmmNtBi7i/dtWGWLbjWAtUZ6J929ACYiItN3AbbWcVnSA0nYxdjx87SkB3IUtmMtJtWqon7mY6G0FyY9kDZzGjYP8lIsJNmt1mJBjm6dF7sCa3/7O1gFR3m8X2KFh1TVoX5uBn6V9CA6SIitJb4FdUzrCtER/n838PfABuB1wJM4dIhN6iPAWj8sxSY6Pwk88pv/jS14FoTQs9yDs8CaczGVAgQR5LY4inscQRqcpgjr4WHgr7Fg5puw8IXiMI3lsGoIC4DVWKseBQK7XCZw7M6X+eR9e9g6UU56OK0kB3wVO3YsT2gMc7E7PdcCVwLfB36EtQIXEamXC5mcdNO5mFVJ+nOsuuzuhMciMlsOO5f5fWxhRtUXjmwB8A6suvf30K1pjdIPvBKraD832aG0hHlYa5xtWOsuERGRQ6lVtn5i0gNpEU8B/hC7fmu3+bKHgLuwgKHUx0lYKG0Em0OVw1uOFY54Lkde1+4GZ2A/j63APQmPpVkGsd//O7C5Azm4Uax63OakB9Jh7sD21ZckPZAOksXmWTYDn0MByo42nXDZBLbQ/SfAv6M7IZplBfB2LAh1BQe0KfEe4hLERQuk9Sz39K/19K3x9K/zDJzkSc/3VArVz1N2Y7ZGsVDUH2F/DxPJDqdrnIhdqH+A9ryDTOooFThGSzHf2jxCvqL1tilibBHy/qQHglXr+F2squRHsbY+3djSSETq72TsTtgr0Q0yNRFWTfZ1qGS8tL/aguVLURhtJuZgE/J/iCpLN0KIVe9+BwqjTXUMVi3uvKQHIiIiLesM7OaZpyQ9kBYSAc/DjqHtVkZgD/ATtFhcb2dj55mnJD2QFjcPu955DgqjTXU5dkPXyoTH0Qz9wKuxNQeF0Q7NAz8FfoZuWKu3HLAe/VzrbQEW1L8q6YFIY013MacC3Ai8C5sk3tCoAcl+0sALsJYlv4P9YR5UXLbgWaVgLT37T47pXevpPcZCatkl3oJpJdTI4+hVsAT0e7HKgTuSHU7XWIjdgf1R4BlooUXkYHZhofFNCY+jZi0WTPtr7Bj2Rqw9gQITInI0VmPXIVehymgHSmGtX7q1VYN0hguxBcurUOD0aKwAXoXapjfCs4E/oDsWeWbqTOA9HGaeSkREutYaLDzy9ITH0YrmAK/Hugy007XtCPBjVKyiEZ6GdeUZTHogLWoQOx9/I1oXOpjfxYKu7bQ/mal12LzXO9F12ZHsAP4OCxFL/T2A2nY2wknAW4GzEh6HNNBMJ3uHgA9i1dJ+ie6IaJYLsCDgu5lGpRlfgTgHqbmewdNjBk6N6T8xpmeFJ7PYgwdfBF9CWd6j8yD2d/A+rEynfoqN57AFqr8FXktybQlFWtkXsLtfWsk8LFj9CSzIWwtNrEN3tInI9CzE7iB/NQqqHMoirMS57qqWdnQRFkZ7WtIDETnApdhiuvatB+eApwKvwG6mFBERAati8zbs5no5uOXYOs+qpAcyQ+uxxXiprxCbO31Z0gNpQSmsKvwfAj0Jj6VVRVhY70lJD6RB1gB/jGUSVic7lJZXBL4NXJ/0QDrYfcC3kh5Eh7oaOw7qRssOdbSLOl/EFpW/hloXNstS7Gf+N9jE6JEn/GLwZYgLEKRgzukxc06PySz2pOZ50gs9LrJgmi+DV6xqJsaAf8FKSX4HGE92OF3jBOAvsDCgFga6iAcCB/2pQGmEQysDnwZuSHogB5HCyml/APhv4CNYS67TsdCafq0icqBaw/nnA69JciBt4irgWajVobSXWmU0Vc+QVlLBFjveg829yKHNBd4CHJfwOEREJHm1niyvBV6Z5EDaxPnAy2mvhdcR4BvAaNIDOYQYO4873KNVewctA16Iqj/V1FYqrwDej+Y5juRULNQ4P+mB1NlK4E+xfWU24bG0g/uxgh6qZNk4eeB2rH1nK5rOcbCVvRh4ZtKDkMaYTXWSm7FSsndhd70sq8uI5HBSWPnVtVgw7X+A4el+cVwBAhg41c7nXABjDwUUdjhcCuKiVVYjsP+TafkpVjHtLdhi6aJkh9MVaqXNTwT+CrgGnWR1vNDBRNlz73CBosKzh/Mr4L+A42ndi9BFwG9VH/cB38faIa/HWo9O0LoTRCLSHDFQAJ6AXWfMS2gch9oXtWorhFcAN9F61TJFDuYc4P9iYcp2c7B9Q6vuF2Rmytg82TuwkG9S2un4swZrr/E+1BpGRKRbeewYeglW2XphwmM5UCseP3uB12E3ut+R8FimK4fN4b0JGEhoDCVs3jCPbXPj2AL7CLAFKyJwsJWt2nZxEpM3xvZiVbd6aY3A04XYz/a9SQ8kYR77HR+PVRJMet35wH1KK+5PwCoL3QZ8JumB1MkiLIz4Clrj73M6ktxWRrHqaPc38TW71UZsTfrqhF6/hB0Di9hxuYAdDyvAvdjx8GDZH49tk3OBY7HjX7r6th8LfSa9f1uNZWB+hq0TSgeZbbusESwQci9WNvNcrMSsNNYZwMexfrqfwHaAR1Y7HFZ3Kd5D77ExvWvARZDf5hh/yM7X4ynNWBVOO6LN2GLKvVj54NOSHU5XCLAyxGuAj2GtCoeSHJA0Vl8UcMdQnrff8BijpVYP8ieuFkh7W9IDmYaTsLG+HZuA+1/gJ8Cd2Il1q95tIiKNVQTOA66keedV5err1i7sHfAI8BiT10wV7EJ9HTYBn8KufWoX8EmfNZ+O3RV7F7A74bGIHM5S4Pdp3TBajO0PCtjffQm7mh7Drv2Gmfx7j7F9wKnYYlaA7RsibOJcLcrbR4zt018FPIfmTMbWtrVS9VHAFhMewRbiavNrFexmkzXY8SZVfWSqb5OcOE5hx57Po/YwrSjpRQUR6Q4xtoj4KuDMJr1mBTuG5rFjaAVbvNyCHU+D6rj6gGOYDCGlsUXX2rVcklZhrfb+HNiZ8Fim68HqoxmVvMpM/n5HgU1Y2OJ+4GFsLeBuYB/2u4w58g2uYfVzlgAnY1VeT8HmH9Zi51k9JHP87AeeC3wVCxZ1qwKwArtWfGqTXnPq9V8B20Z2Y9tcAdseYmy/sRbbn0TVRwrbZpLen8zF5tB+gF2ztrM52HzBS2m9MFrt2FOqvq1g122PYvupWugnxvaTy7DjTohtK1lsu6n3/OGNwN+jm/ybYSu2fvUUGj/fU8H2QbVtbRN2fNiI/Z0/VB3Pjur/T+c46LDtrw8Lpp2IzSdfgB0T52BzW0nt054J3IoVZZIOUo8/Fg98EzsJfBdWPjPpxZhuMB+rynUi8JfAr5ksZXt4U3ZHQYDtfhxkF3syCyuURhyj9wS/OXT6qbswTWUdygTwOWADdhH5RJI/Ce0GxwIfxCY7PopVW5IOFXtPsaLyaNMwhLXuXAM8O9mhTEttX3kWNgn0Fuxk+kfYnaK3YxNQuqAS6R4D2DVFo1uleSz4+ih2QX8fNrl+K3bjjccmmaaeATsmwyaLsInSU7GWKxdgE061i/skPBu7k+xrCb2+yJEsAf4Cu9O5VXjsWnoCm9R7ELvZ6HZsIWIjttDlmLzzdCqHTTIH2ILnKmxR9gzs/OYYbIEpQlfUre4crLrLuga+Rlx9jGEB4uuxc997sSBaCdvOpp77eiYXLvqr4zsGOBtbQD0FO3ZWZ3eabgHwEuz7aOadzPEh/j1djfx5JX3hWgtiTGdRQkRkNmqB7rdi10SN5LH5oUexmxrXY9duD2PnamUefwwNmAyOzMNujDwbCyOdDSzHzuOSOH4GWHuqL9M+gbQ88F3sHLfelcxrlfYq2Pn4TViXpruwc/QxbFG+FgaZzbF2I7aw/1Ps+r4fW2e4BGudeRYWMmq247EqaW/Fvs9u9XzgaQ1+DY/9jPdi1303YXNCt2HXgI7JG5NqavNBIXb+uxzbp5yPVbg7tvo5Sa0LPgkLc3wqodevhx6s7fObsVBMK6hg+6ZaGOguLPz8AHb8qW0rB84TpLD9/AAWTFuH7VtOxP7WVzA5jzAbjwL/hoWSpPHGseDnu6h/x7Ta3FQRC5rdjh0H12Nh7F1MzhfU3h6tHLavuxX4Ora9zsfm4l8CXIQFXZu9PxvEAslfw7Zt6RD1TG/eBfwBcAtWLW1JHZ9bDi6DnWCswnpDfwmbRJ8275k8pQogSEF6vmfuuRULo1VgdH1AeczhQh5/+iUH+gXwBixQ8UZaL8HfieYAv4OdxH0Y+CGt3wtbpNHuBj6CTQ5dlvBYpsth+8wMdiF/Gva3/QBwLRZOuxM72RaRznYutk/INuj5C9hE4w+x8OuD2OR2rvqY7sT2Vmwh5GfYBNMcbDLyOdg5ehKtJVZhrU7/h+6ewJbWFGLXSi+ida4mNwPXYXcU34D9Xdf2BWPMfKFrGzZhmGGy7cFcbL/2TGxyL+m2M3JwKSwo2cjFx33Ycefb2BzaTiaPP9PdZ+/CJmZT2M2h/Vg47XxsAfXC6v81U4hNWn+N5gXSytj846eYeegqxuZDT8N+bvU+3ygDX8H2B0nNCUVMnu8okCYijeSwG3TOoHHHnyJ23fVzrCrJeiwYNVF9THc/txULgP8QO973MXmOdjXJnKPNB36rOq7tCbz+TJWw7gavoX6BNI+FO36Jra3chJ1PTGAVhxp1XVsLJBWxgMEObPH/q9j51AuxUNRgg17/YNJYqGgF3bsQfzK2zjO3ga+xGfgWti+4HztHH8e2uemuK23D5t+vwbr3DGLjvhLbbk6t75CnZRG2L/sm7bE/OVCAzaf9KY39/U9XCfgVNuf3CyzIWttOam2Dp2MHduPO9djvJoNtLydhx6CrsRuj0kc5zl9jgSJpnt3YtlHPyuoj2LZ2LXYs2ogdA8eZ2Vz1TNWq/NXGsBn4MRawvQoLiK5t0GsfyhnAs7Cqf9Ih6l1OcBfwT9jJ0h9hCcpWmWjuZKczWSXq41iVrpnz4MuAg2iQ3xQWHTjV48seF8HEo478NodL6Rd7GA9iv4/bsZOnRt5dLSYDXI7dlfJJ4D+APYmOSCR512IhzXkkcxE8Gw67C2oVkwtsL8WOb7XKaQ8zu7tARKR1NSoMsBO7qP4GFnDdhd0NO1u18MpOrLrNr4DPYpNKL8HufmymS7FQ2k+a/LoiR/LbWCunOQmPYwJb0PwadofzTmxfMKObuw4jZnK/ADahdy92DrMEC8E8F2vxkPTPQiY5GrPgGGOLD9/Hzs8fZPLO5tkoYdvtXmwbux1bWLsI+F3gyTQ3mLYYm5BfT3PaRpewBcDbmHngqozNIbwau05qRCDtU1jINam/cYf9XPaRfLU2EelsjbyRaBhbZP9fJgNbs92vxdgC72j1/c3Y8flTWIjk5ViopJmegwWZ2yVA8hB2PnPyLJ6jiIXzf4DdGLIJC23sJtkbq/LVsWzBblr5MvB72Hl7s86rlmDb4d9Ux9Nt6l15r2Yvdk7+P1j4cTv1OWfNVx+7sXnrX2Ot7K8CXoYFK5pZQf8irMLcPzXxNevlcuAD2HVFkjZgNxD9LzbHt4vJdpyzUcaOa2D7uwexoNsXsE43l2DHg9OZfnbjTuA/mZx7kObYi1XYvJLZVfJ7CLumvRb7Xe5hMpCdlDK2f9yOhW5/hM1tv4LG7Z8PtASbU/8sFsiTDtCI/ra1uyS2Aa/DDrp9DXgd2d9y7OR4Lda68BdH/Uy1YFpVao7/TSODPgc9yz2FXY6JjdWqaQ57K1Ptxlp4bgbejU0GN7qftNiEwR9hLUs+gV3YinSz72OLLR+g/UJpNQ5byKlVHjobOwm+Fzth/zkWThMROZTtWJD121g1lR00LtBawSYQrmfyLv7XYK1YmlUl5Tzg6SiQJq3lTKz9TLPvrJxqExZI/SkWmtmMVRBqhjLwWPVxGxZcPRELj/4WcEKTxiHNU7uj/ivYguaDNHYydQJbPNmKBaGeih1/Lmrgax7oedjfWDMCaZ7JyjhHI8QWhBpRXd0DQ9j+pV1asImItJK9WJWqb2KtpHbSuHBtGbs+3AHcgx2zX4nNOzUrgLQaOye8ifYIIJWxKi4XMbPgSIydD/0cCwTdg1WAGarz+Oohxs6pvo5VP34V8FrsxtlGG8DWVP8Nu3aQ2RnCKqF9HdufbKNxYY8YqzB0B1Z57efAs7FOSvVu7XcoS7Eqe5+mvW7kPh3rvNbsGzqnugcLd/0CK7rTjJDwvurjASyc+3Umb8y/giO3S/xu9SHNlcPmXEeZeSDtEex4/0tsbmgDFkJrxS4Xo9icRm3Mf4iFbJvhRGxO41tNej1psEYFZGJs49yB7UjfAaxs0GvJpD7sBGcl8I/YHd/Ds33SqeG0aMATzIewzxP2O4IUVCZg/OHAfusOXITKpxmPHZR2YXfevozk0/3dYDHW5u9Y4O+A79FeJ98i9VTGAhgOC6Wdkuxw6mJJ9XEedlJ6D3ahfw12wbgvuaGJSIspAF/E7oC9Drs2aaZaFaaN2F1lb8LuemyG07CAywNNej2Rw+nH5gQuTOj1t2PVDX6ITabVozLibHjsTtiHsDvovwM8EWtlemaC45L68Ng+/4tY1Y/baW6FqiK2gPI5bCHsjdiiejNmadZh7Waua8JrzZbD5kQ1eyUi0jpGsDmsb2Dh6m00t+3wGFZRez12E+Trad712zOqr31jk15vtn6EVUuZzlrHELbw/kPsHOl+2qcanMeu5z9RfftWbD6y0ZZh1wUKpB29CrYu9GUsQLmlya+fx9bI78fmZd6Nha6a4UTs+vKnTXq92VqI3UhzZUKv/wi2nXwT2/+PHvazG2e4+rgPu8n1iVhl9Ss5eDDtFyisk6Rt2HzOdNp2FrFr5Guw85v7sP17K4bQDmY7VvnxYeD/YlVDG+04rHX2t2nuuaA0SKMrNm1isoXk72N3TaiWVuOdDbwfW4T6d+wCqi58BSoVCHugb43HBVDJA0H8m11CbnNAeRyCNLhmFqNtXXdibfMeAN6OVfiRxspgB8VjsEnxL2EnCCLdqISduIFVEDw3wbHUk8Oqgy7H7vx6JnZCfyd2gn8Hzat6IiKtpYRN3nwJu7sw6cnuR7FrotqFezPCwedg5c0VSJOkpbAqE8+hue0DwSaSf4TtC35IHW7WaoA9WHuGm7HJzBdi5zVJ3hkuR283FoL+HHY+muSNUUVswnsz9rfwaprzN/hUbPHrnia8loiIdIYyNp/zOSyU9Wiyw2Er8LdYgKXWiaPRLqy+TrsE0u7DjvWHmmOMsZsvfoL9bn+NXQ+3603jw1jlpBHgz7D1t0bqx25WuQkrdiDTF2Pb5tew68D7STbMsA/bdrYB/4/m3KR1CnZd2S6BtBcDv5vA605g3d6+iF2T70lgDAdTxIJxD2DjugrbH1zAZL6ijAXofp3A+MTsw6q5XgYsOMTn7MSCg9diN0feQfseB8G+hz8CPojNOTfaGVhl0o1NeC1psGa0ECxjf5SbsaoAzwbmN+F1u91K4G1YKO3vseoMdbsr18f2ACCA/nXVtp4egshTmYDCHkdpxNp5uqDr23puBz6JXYi9C0u3N6ttUzc7AXgflqb+LFaWWaQbFbGLlBzwFmyhqNmLwo0UASdXHxVsAfDH2N/8zTS/KpKIJGcPdu3x79jEd6vcRVXEJkShOW2UFwEXY9cBIkk6Ezv3ONQEXaM8AnwGC6Xe3+TXPhq1lg83Yi13X4PdYNOMORuZPY+1hP537EaQzYmOZn+PYsedAKsk3uh5iCuwRTAF0kREZDo2Y8fOz2PXb60iD/w3dqPjn9H467cIq540QHLVeWaigq03XY61HK3JY9Vhf1l9/ID2aEM6HRXsxgOAPwfOauBrRdhi/9+iQNpM5LHq0/+O3ZDUStWHflJ924xQWoiFRRfT+u3jnw68AZjb5Ne9B5s7/BdatxJhGRvnfdi15suA38Z+Vt/CKgBKcsrYDWBD7D/fVauIf231/68h+aB9Pd0MvLf670aH0hZj65j/jh2DpY01c3LzBmzH/jDWb3314T9d6qAHeB6wFvgYdsI8VPdX8RCXprzoqhgXQbjRUdzpCNJQHofSkLPQWq2tZ3f6EXZ31TuwKgHLkh1OV5iPlVg/AWvh+UOscopItyljF+WPYceC52PHiU4TYqHfJ2IVWn+I3RF2K3Y3RStNRohI/dRapH0KW8xo1Un8rwG9WDjg2Aa/1lqsncjNDX4dkUNZwORNUs1SxkJdH8HC+O1mFGsXcjN2Q99vYX/LaivYuvZi55sfp3XvUN+KLZxmsEWMdANfaxBrG/1VWicULiIirelu7Pj5FazSSKspYddvPcBfYhX6G+kSLOR0bYNfp16uw24CWQ2MY9V8fo79zNqhfffRqGAByjTWxnNJA19rPnYddWcDX6OTbAH+A/hnrHNXK/oJdn78V8D5DX6tpcCTsSpxrXpOvhi7YeaMJr5mjAWEPgF8l/borlJhstXj3cBLmKz+J8nahYWwj8PmbB7Cjn/fwFoFt+K5TT3cghWCyWA3pDXKAuzc6L9QIK3tNTsWtAVLgN8B/CmNP+iKOQP4KNa68LPYAn3D+Io9epZ7elZ4XASFnY7xR6xKmq9Aaa+DuBpM676p9XuBP66+fTPNXaDpVims1/qx2ETHl9HdRdK9bsfaB28HXgUsTHQ0jbUGC6S+FJvQ+yZWWvhRrCy3iHSGCexC/++w8H+r+zLWVvw92MJ9o6zDJgYUSJOkXILdINWseYdh4PvYzVg3Nek1G+UR4E+wv9+3ARcx2Z5DWsdj2N26/4SFvlrZVqxt9Grsxo1GOg+r8qIFVBEROZg8NjfzF1iAqZVVsHZux2HnZHMa+FrnY+s47RJIewCbY1yNtb37PN1x7Rlj1xyfAf6QxlWfjbBKWj+jdVoJtqIYuA2bD/pPWjd8VfNT7OapT2ChsUZZis0HfY3WLc7wCqxCWrOUscpif4Ltv9pNAfgHrPBMq96E222KWFX+pdh682ex85rxBMfULDdha+0n0bh9WQqbV+ijc6qtdq0k6lTF2F0EW4D3YwfFgQTG0W0WYItea4G/wS4WGqrW0tNXIDXHM/ccjwuhkoPR9QFxESoTDl/GqqYFdFM4bS92knwb/5+9+wyTozrTPv4/VZ0mSaMshEQSOWcbYww457Tedd7X2axzttfZXiec466zjXNah3XEATBgwOScBQLlHEYTu7vO++HpRoNQmBn16aruvn/X1ZeEJKqORj1dVefc53ns++CRtFf7vKw6GDgXOAxroXpbusMRSc1GrH3wtcCbgRNo70XOPuDJtddNwLewXVDL0M2sSKsbxsIAn8SqILaCUeDrWFD+FQHPMxt7cBdJw2LgTYQNXY43iN3ft1NbmzK28/kmbPfpswlb2Uom53asusHPsGtRK7gb26y4AHs2DuUErG2nAmkikzMNW9TJY212O0mEbRzbnPI4JLyt2LXz07ROdZcxbLyHYJVGQ4mxOesirVG1B2x+7evYv2XWg0CNtBX7ez8CODvQOWLgDOxrrEDaziXYpsSP0jpBTrBQ1MFY5cVQCljItUQ2A2mnAP9C81p1DmPfS++h9atWtcrcZydIsMqHt2H/LptTHU3zXYx9X/0n4Z5dFmAV2P8e6PjSJGk2TrwWeCU2Sf0K2rtCS1YUgBcCx2HtGn5Hk1uX+SpEBZh+XIKvwtZbIypbHC4PyRj4MtvbenZGOO1i4GVYKv85wIx0h9MReoDXYRexTwJ/xXZHiHQaD/wIW0x7E9ZGOOROz6w4BluIeyV2w/xLrLqFPgdEWs8WrBLSl7CwfytZj1VtPBNb2AjlcGBf7HNOpJkeSbjFmR2NYJt9Pod9b7WbW7E5k6XAa9GGviy4DXgrVh2j1RZf/w+rHv5awm0J3AerVCwik3MWTdhAnEERFsJ7LhZUkva1mdbdQLAFq4h1OLa2Espi7Pnw5oDnaKRb0h5AipazvTrMPoHOcTRWaEIeKsE273wEe15qJWNYlatHAU8MeJ5Z2CaRfwY8x1S9GDitSeeqh9HeS+uH0SRbPHY/02r3NI2yCWuneRZweqBz9AInAVfQOmF92Ym0d1utwUozv4bWLJHZqo4Gvgq8A+vT3Rx++8tFEOVh2hEJMx5WZcapVboWWAW1qABRjN1SJk0bXZqWYpPZ7yW7/e3bjcMWyP4bm4jvT3U0Ium6Fvs+eDNWgaMTglkxcBS2E+0PWIn9RamOSEQmaytWZfbTtF4Yre6PwHmBzzELOD7wOUR2dBLWHrwZW4xGsWDq52nPMFrdILbY8gk6d7IzCzy2A/q52Gd4q4XR6r6KbY4L6QhgTuBziLSbCKuM1GmveseItNcpJKwN2PNbK9/L/BW7DwjpUKxKmmRfvTLORYRbxerB3hPyYGPAx7E2uq0WRqu7GauyNxTwHP1Y6C1UW9mpegLwGJozXzACfANbe93ShPOJdJq7sbntUJUYe7A5xq5Ax5cmycKD3hDwc+BfsVKlnbAQngVzsDKKXyGFRSqf2CsqQFyycFr3/gkzTrFwWs/Bib07Ix4UZGtjA1hK/4XYw600x4HAh7HJkMNTHotImgawG8d/xR7oV6U7nKYpYTvF3oMF016HAqoirWAbVu039ORdaAlwIXBNwHPMwlqnZeG5TzpDAZtcPrEJ5xoDPkVrVtmYikHgXGxj2d0pj6VT/RULW96U9kD20i3AnwnbavRg9IwtIiJmA/AhrMJYq1en+TVhqw0dDBwb8PjSWENYZceQFckPRl11xitjz0SfpvVbmV6LfaaE0gecSrYCab3Yxvgjm3CuUeBr2PVHYTSRMMpYMDtUG/YcNq+Qpc8xmYIsLUzciCXaPwKsTXksnaIbeAbwXeBFWMWYpvKJtfH0FQun5aZB3A2l+Z4ZpyRMOzLBRfbnOsAocClwDtZ6SjdJzTENeCm2S/yZNGdnhkgWJdiN47lY2ezzsKBaJ+jFqod+GGtj+ky279IWkWwZwHY2tnoYre5KrLx5KP1YMChLz33S3o4FntKE8wxjm6u+THtXRttRFfgeVmFEVeab68/AW2jdKgw7+g1wScDjL0YVPURExDrkfAj4Nhaub3WXABcEPse+aH66VXjsHvG2gOdQIG27MraR+rNYC+BWdx/wA2zTZQgRNh+UlSCHA56KbZpshm9iHdo2Nul8Ip1qNfC/WEXCEPbFArbSwrK2MLEMC+K8AQuoSXh54DhsZ/kHsG/sVPjEgmm+DESQm+4pzPX0HZMw/fiEaccmxF2QjNZCbA16ZdAS7EbpXdjOZQmvAJwJfBJr3Tcr3eGIpGoQm1x7H/Aq4HeEu5nMmhnAE9ne+uvhqY5GRHY0ALwfK7ffDmE0sOrQ/yBstaODgdkBjy8y3olYW5DQLgG+gC1ydpoEm+xrl2BuK7gIq0x3c8rjaKRbgKsCHn8ecEDA44uISPatxLpSfIf2CKPVXULYtauFqG1nKxnCNpqF2tR7EAqkgW3M+SK2frw53aE01G2ErZrfi32mZME04CU0Zzw/x94vrV5FT6QVDGDdh0LNT5WwbmfSwnJpD2AnNmJlbu8F3opVKSmkOaAOMR94E7Zg9VXg4lRH42vBNAelud6y8x5clFAdBteAKKWLICnD4JKI6oj9t4vJyv6jdVh1oruwf5enpjqaznEI1rpvMfDfKBgrnctjIfGfADcApwNPB86i/XcjOOwG9+XYjq3zgB/T+m0lRFrdViw43o4BjPuAP2Ftg0Pow+5tVgc6vkjdEcATmnCe27HFzfuacK6sGsEWd3uxDTW96Q6nrd2AVWK4Ie2BBHAFVvEtVMuc+YGOKyIi2TeIVYL+Bu0VRgO4EPg74VprLsDWaG4PdHxpvD9hnYiOCXDsQ4CZAY7bSqrAT7GAUbtVx16F/d1OBboCHL8EnIRtRhkLcPzJOA7rUBLaZdjmNVUUF2mee7ANfCE2qBawz7HLaL97yo6RxUAa2EL4lViFqLuAF6Kdlc3QB/wr9rX+Kta2rJLmgPAWGqsrzvaNC4y5WoU0l5CMQZSD4RWOsY2OqFALp6VrGPgbsLT2eh6qbtEM07EWnvtjkya/I/2b9Y43WvXs053n5YfO5Jt3bmQs8WkPqZPcVntdAjwaqyB2Bu2/O68InIYtrp+AfR5ci92jiEhzDWOLGf9D+4XRwCo8nQ/8BxDiDrQba5v2T9K+t5d2dzrhA2lrsY0jFwU+TyvYiD23zwFeQ1a2VrWX24CPYK2Y2tFlWJXOUIG0Odii+spAxxcRkWxK2B4eaceFwxEsqD6ChT0abQ6wKMBxJZwrsWBRiEDadOyZvlN5rJPHJ4D7Ux5LCKPYs+1mwgTSCtgGxRLprnHVq6PNDXye1djc4T8Cn0dEHmwIuBQLjvU0+Ng5bF6hSHveV3aErAbS6u4FPo21sHk1ap3VDDlsAX4xsB/wXWB5mgMaLwmwhNa9yEJuLoKoCIVZUN4Co+udVWJzFlZL0RLgg7Uf/x9wfJqD6RAFLHSzP3aT/ANgW6oj6nCjiWd2KccbjpxDJYHvLdnESDVJe1id5o7a63zgKdii8ylY6fh21g+8DAtrnwf8GgvHiEjzXIhVR9uY9kACWoJ9xoYIBfRgLV9yKJAm4XRhO54bPfG0oz8D30MB8bo12IT7UVglW2mceuDvF2kPJKCNhK2+Mhe7h1YgTUSks/wRC6NlZk0hgFuwDT9nBjj2fODwAMeVcMpYdZhQ5gU8dtbdCHwUuCntgQS0Hgu57hPg2DmsRWYxwLEnYzG2eS0f+DzfxloHikhzjWDFHAZp/LxgjN0bqZtiC2tA48PgNmOhqDdji8CjKY6lk8wF3gd8GAuoZT28OGVJxaqwVUehOM/Td1RC94Gern093ft5inM8SRmSsVq1tnSWPjZglQDei4VBqqmMovMcAZwLvJ/2D91kmgOGKgmRg7cdPZcXHdRPKVYRiJTcA3wJq+TzPqxd1I20d8ghjz00fxqrQNLu1eFEsuR64DNYtdh2tgGrRBniHq+EbTRp2/t5yYRHAo8IfI5rsIDQlsDnaTV3Az+jPStIpuk7wPfTHkQTLCHcNXZfLBAtIiKd41rgc7Rnq+vx7sSeVUNZEPDYEsat2GaREPahM6ukrQI+j82VtLNB7O8YoiBCDitwEXrj2O70Ak8l/Hz6RdjmtXbezCqSVQl2XxSigllENoK1shdaIZBWdwXwSuDLtGdp1iwqYK0LPw08kzAlYzPFVyEZgcJMz/RjE6YdndB3WEJpnqc031Oaa9XU/BhpBNPGgN8D52Ct43Rj1RzTgLcDn8KqDoQoxS4T4LDWnVU87zx2Hs8/aAaFSKG0FG3CWjufg4XGv4SV5V2L3YC2owVY26b3AwemPBaRTrACC+RfkPZAmmAztnhT3sOfm4oYq/qqQJqEdDpwYsDjjwF/Qq03dmYM21XfrvdfafgdVhl3U9oDaYKlWGvSEOZg1x8REekMa4CvAH9LeyBNsBHbFBBKLzA74PGl8e4gXCBtGp0XSNuG3Y9/n/Z/zhkCLiNch54DSHdNay4WSAu5vrwNmz+8I+A5RGT3VmMbrkOYQ/gKixJQKwXSwCZZ34O1L2z3XTZZ8gisDchb6JTywL4WThuzNp7Tjk2YdnzCtGMSinM9uX6Pi8GXwVfAN/eWeCn2b/Ex7AZL7Wqa49lYufnnYZMCkpJK4iknCe8+dh4vOGgGsVMoLWVjWFjkLcDzsWv077GJuXbs6V4C3oh9Bh+b8lhE2lkC/Bgrt98JxrBqk6GqQS8i3R2x0t6mA4cGPsdfsIpV8lCu9pLGuBOrxNDObYHGWwrcHOjYXUB/oGOLiEj2fAv4ZdqDaKL7CLfwOh2rNCqtYwm2fhnCQViop5NcAHyWzukUdD3hKoE7YFagY0/EMcBxAY+fYK2iLw14DhHZsyq22S3E5/ZCVCympbVaIA1skeY7wMuxBe92T8dnxWysfedngRNozffO3kmACPqOSJh5akJpvifuhtw0iAq1YFrVXk0wjLWvegNwMQqlNcsxWJXGj2AXQElJ1UM58bznuHm85BB1T8yQ5ViA+d+AF2CfU5djVdPaqY2Uw8KpnwBOTnksIu3qz8AP6JzJR4CVwLJAxy6g9uMSzsOwVvehjGILEksCnkMErErlF7Fn7E6xBbgr4PH13Cwi0hn+glXR35zyOJppJXBLoGP3Y5uKpHVsJtzcZ6dtPrkBq3a1Lu2BNFEF2xgTQgwcQjpV8+cAjyZsZaP12PtlVcBziMieJViV+bG0ByLZ08qhomuAF2Nt9ELtPJAHi7CAwTexalGt/P6ZHD/uFYF30L04YcapVWacUqXnwISoAHEJ4qJVTGtS1bQ/Y98H30LhzGbpwaojfQN4JGp/lZqq91S8513HzONVh6a5yUd2YgS4GgsyPxX4V+ALWDu6AdonYPIk4KPAKWkPRKTNrAC+R+dVRB7GJiBD3NPFwAw6byJbmuNRwNEBj38+8IeAxxcBe9r/GfB/hGmfnGVrCNciqBdVSRMRaXebgM8RLpyVVeuAewIdu4RVSZPWsYFw7d77CNvuMEuGsHvy89MeSJPVA2khQo0xsA/pVBdaADyRcGvJo8AvsDUHEUlXAtxLmK5JDs0rtLRWDxRtwlqDvR5rcSPNcSKWOP8oVjmtsyT2imKrjOZiKM33zDilyoxTq/QdVSUugIt4cJAtnGXAm4G3o10AzfRELJz5chRKS00l8Xg8bz16Ducc3nkfRxnnseDZRuASLJz2dLYHm+8gXGu6Zno8dj1UpTSRxvkTcGHag0jBCOE+G4tYhbRigGNLZ+vFwmgh74cvBm4PeHwRsBDaeYSrVJllGwi3oN5D57WYEhHpJB74LZ25NhPy+jkD2D/QsSWcUKtA+9E563CXYp8pnaYeSAsR5IiA+aQTSDsYODTg8ddhxTq2BjyHiEyMxz7LQlwLI+BAWj/X1LHa4R9uBPhfLBTyvymPpZPMwUJQ/wOclPJYUuF9rRJaFYgh7oGoBPkZMP2EhOnHJ0SlprXw3Ia1knwl8PemnFEADsPad34JtSJJzUjVk4scbzhiNq87olOezVuOx67XK7AKJ+/Bwmn1ymm30tqVKB4HfAw4Ne2BiLSJAcJMwmXdCDYBGSKQFgMzUYheGu8obNdzKP8Ergx4fJE6j7WZ70TrCbegXgSmBTq2iIikz2PtnzuxPdMgVgkkhBKqBNKKQlVIK2DP9J1gI515T14B7iJcZaFphG2buTPTCVtJHawymjaviWRDgs0thCpCUaRzroVtp10WJMpYa7DXYbtxXocFpiSsIvAsYBFWMe3HtHagYOr8uOCZg9x0DwlMOyrBV8DlYPBex+hqh8vZn3GNj4OOYRVF7gdeA5zT8DPIzszGgoAHAOdiFRzUPrWJHDBYSejLRbzm8NnEzvGFW9elPSzZtQTbRboBC15cjlVMOwE4GzgD2z3Vah6HlVV/Ndb2SESmLk/7PKdMRgXYTJi2xjns+agTv64S1nFY+49Q/oYCaSKhbQVWBjp2P1bV4+pAxxcRkfTlaY/CB1MRKoBUAmYFOraEswabG+xu8HETQvfgyY6Izv08WQYMBzhuvbJQT4Bj785C4BEBj78KK1IzEvAcIjJxHitIEeJzDGy+vFOuhW2n3RYkVgOfA5ZggZyQFzsxMfAwrOTrkcBn6cwdDNt58LVYXn6Gt7SMg54IivM8UQHG1juGljpcZGG1BqoCNwHvxVo+vQmV926GGHgC9n3wLeAH2IKyNIkDBioJffmIVx1m8zVfvHWd7k5aw/ra6w6sRd9CbPfUY7E2mAdh/8St4AnAh4B3oFLhIjJ5HqsYGWInWR77fC0EOLZ0tuMIVyFtDLiZ9mjxLZJl27B2NyHkaf7il4iISLNsxhZf9w1w7PkBjilhlenUgg2N1SrzwI22inDPvj00Pw+wL3BKwOPfBfwOFYcQyZJR9D0pO9FugTSwFj8/w9LkrwSeR3v+PbNmf+At2M7Xz2G7Xzs+C+Ir23+en+Yp9IOLIdfjiXsc1WEYWhrZx7ODqFY9rQE2YO1Ul2GV0s5C3wehOeB44F1YdacvEK5su+yEAwbKVint1YfNpOwTvnHHRspJx38UtYoysLz2uga4AGuLezwWMD+b7C9mlYDnY5+9n0E7tERk8jYRpkKawz6jOnWnsYRRAg4h3PvqCmySWUTC2ka4jYUFsn8PLyIiMlWjWIvBEIG0YoBjSli10gQiUzKKtUAOoZfmrw8uAmYEOvYI1q4zVJVKEZkazTvLTrVrQKWMtc27B2tf+HJgXqoj6gx5bCF+AfANLJ0e6gaq5fhqra1nGeIS9B7kqQ5BlPMW3fMwtNxCai6y4NpetvUcBX6FBSNegYUz+/b27yF7tC/wBmAxVjHwEqwFlzRBvVJaTy7iDYfPIfHw3bs2MlJVKK3FlLFr+D3A+cDhwCOBU4ETsaBao8vfN8o0rErrFVibMRGRyUiwFh8haFJAGu1AwrYS+htwW8Dji4jxWMeBEKYRroqiiIhI2kYIF4jIYaE0VQueuCI2XzjZiWCHzd9vm8L/K9IoHtuoHcIioCvQsXdmJnBEwOPfB/wJfb+K7CiHfa/nmNz3R/06OIzWsyWAdg2k1S0HPohVKXoltojd7n/nLDgTq5S2GGtfuCLd4WSPT6A6AsTQc3BiH/UJuDiiMghRHkY3OMqb7ecunvKpEuBKLNRxL/Bq1MKzGRzwVKw11leA/6PTW9k2kQMGKwldseMtR82lmsD3l2xipKpKsS0qwVrY3YpVQD0eeBJWNe1wYHZqI9u1BcA7sc/de1Iei4i0liq2meCwAMdWy05ptEOA6QGPfzMwGPD4IrJdqO+1AtoYJyIi7WsAe34LoQd7hlsS6PitxmHPHvOwwgjzsPuM2djXqgzMxTaLT7bqeIQF/1aw/Z5oDRY43AZsxf6t12MbyDTJLCF47P1VofHr2M1u2bkAm7cPZSXwj4DHF8miHFbtcBpWfXAm1rlgGvbMHWHXwVlAzOQDaVWs+9ra2v87Uvvv4dqPg1gRolDdPaSNdUI4qwx8E2v18VrgKWS3qko7ORB4P3Ak8Ang+lRHk1UefHn7f3YfaOE0F0NumWNkjSMZhcom90DBZze179r1wMeBO4E3YlWGVPY7vOOBjwCHAl8H7k51NB3EAcNVTymGtx0zh8vWDnLLZnVPbAObgYtqr0OAZ2LhtKOwm+0sOQt4DhZK1WK6iExUgn3WJTS+oll94l6kERx2jxsqkLYUWBXo2CLyUKEWVj2arBaZqCFsAajT2r3VW8vruVlaUUK4SiIFwm7+yLIS9nefgwXOZgPzsSpPi7F1jUOwKjBzCFP5aRUWUltXe63HwoersK5Mm7FF+U3YQv0I9l5QWE32xgC2pt3qa/czCFsleQkWFhVpVw4Lls3Gvp+mYbmLg7Eg2gIstN5X+zMhci8JFv7cghWA2og9qyzBroVbsWvj+tqf2YJ9hqnCmjxEq1/UJuPvWBhnKda+MFTvatkuBp6L7Ur5KHApuknYLV+bpvUVKM3zdC30jK5xDC6xIJqvQHmrs8tALbg2yWmq/8Wq9bwZeAZ2EZOw5gFvB44F/gurWFfe7f8hDeEA72G4klD1qt7chu4CPgX8CHgh9pl2GGFbh01GHrvfuAS4POWxiIiINJrDJsB6Ah3/WlRhWKSZBrHJ5kYvHEUoDC0yUbcDn8HmUzup1brD/s43pz0QkSlICDvP2ykTmvWF97nYXPqR2BzfEcAxtV9rtn1qPx6wk9+rVzZfgm1Avxu4uvZndd8jU+Wx9esBwoQsSwGOuSuzsQBpCPcDVwQ6tkhaIixcNgO75h0GHIdtBF2MXV+a2Xa3PqaFtddRO/n9Aayr0W3YNfFmbPy9zRqgtI5OCqSBJTbfgS1ivxNLk3bSA35aHolVh/oc8H0sLSt74LHqafmZnv4ZHhdDdRC23hqTlMFFUB2ykNokg2nXAW8AbgHehO0ukvCegH3mfAxr4bkp3eF0jk6ZuelgK4BPAt8Dnld7HY4FbtPeWX4I8O+oyouITFwVu1cuo2q2km2OcNUIAG5Cz40izTSMfc81OpCWD3BMkXZ1P7bhSkRaxzYs0B2Cp72rbeWxubtZ2EbuR9VeR5L9UFeMhQMOAB6T6kiknXjsnjxUdaEDsa4jzVgu2QcLpYWwClvbFGl1MbbJcwYWwD4d6252GhZOy7o+4GG1l8hudVogre4bWGrzfdgNY6d+HZppEVYl7QTgg1iVLtmd8beFDnwCURdMP776QMRi4NaI8kaH9xZMe6Ct554jGJuBc4EbgA9h/y5Zf9BrB4cCX8SS7Z/BgjQi0hirgS8AP8ZaZb4Wu5FP23OBX6FAmohMTAULsQ7T+EBa7U5RpCEibLEoBI9tItsS6PgisnOhFqeyUsFYRESk0Yaxdo6exj9rtWOVUYc9584HHgE8FVt4X4D9XfW8KhJON/Z9NtaEc4UKo4F95i4JeHyR0EpAP3AillF5DFaBrF41WKTtdHIQ6x/Af2AL1q9GJQSboQt4MRYQeA9wAeolPDHjpoWjcd+1fYcl4GBwScTICofL2Z/14/dO7f4x7k/AfcDbgBcBhYaNWXZlGva5czwWiv1HqqMRaS8eWINV5fwLVg3yhdgNflpmYBNsN2BjExHZHU+4++MIm/i/O9DxpbOEbCeWoA1MImkItQisxWUREWlXIauY9WEVja4OdPxmclgVmGOxTaRPwlqAlejsNUqRZmrWPXk/YQNp67FQmkiryWMddZ4FPK328z7sOqhnZmlrnd6u8l6sWtcbaz+X5jgZq1L3ViycI5Pgk+2vqABREXoOTJhxapUZD6vSszjB1/dkOWq9P3d7yNuAdwFvR21xmqUAnA18C3gF9kAuIo1TBu4E3g2cg7UqTtPTsR0vIiJ74gj3jBZhO881ySGNcBThWgjch7U/EhERERHJulDPV0Vsk2OrP791Ac8Afgj8DJunOxwrEKEwmsiDhfx+b0arTrBAWqgKySNok6W0nhh4ONY961fYmtWpwExUHVQ6hG74bKL7u1hLkLcBT0ElEZthP+Ad2K6YD2HBAZkknwCJhdKiLsBBMeeJexNcDNVRGLgtIhl9cGW1nVgH/A9wO/B+rGS2LoLhHQZ8BPs++DyqBCHSaFuBXwJ3AG/BqqWlEcbfH/tc/RvNKYsuIrIzDpvoiIBqymOR1tdLuOfmDcBooGOLyM6FDESLiIhI5+nGKsA8HytQMA+tR4rsSb3MRCubQbgKaVuBjYGOLdJoeeBhWHeys4CDaL9W3CITohtAkwCXYtWhbsNaeapyV3gzgecCBwCfAP6IWnhOST2YBuByUJjtwUGuClGU4CuwbUlEZSu4GFzEzqaay8CfsXDaq7GHRX0fhDcPeClWnvUzwF/THY5I2ykD12Oh81XA67Hdmc32COA44KoUzi0iUpfQvF2x0t6qhHsvbUABbpFm2wYsB45OeyAiIiLS0mJsAf7lWIeQ/VHoXWSi7gQ2A/ukPI69kSNc9mADsDrQsUUaaT/glcAzscIkCqJJR1MgbTuPhdE+iZX8fAcWEJGwYmyR/tPAkcAPgBWpjqjV1dp51hXn1taJ4oTqMER5GFnpGF3jcDHgLMQ2znXAx7Cb39djgUEJqxd4Iva1/hxWvnxziuMRaUdrsdDnFuBlwOImn/8RwPEokCYiIu0hVCCtioVihgMcW0R2bQgt7oiIiMjemQu8BPgX4BRav9KTSLOtx9pStrIuoCfQsUfRXIFkWxfwZOBVWDh7errDEckGBdIeaiPwTeB+4HXAY7DywhLWoVj1mkOA/wauTXc47SMp24+luVY1zcUQlyA3zRMVoDLgGF7uwFlYreZ+4MvAEuCtwBkpDL0THQ58GCvd+i2slbCINM5a4LPYYtuHgX2beO4ScBR276VqoCIi0soctthUDHT8QXStFGk2j9o5i4iIyNSdCrwBeArQn+5QRFpWjtYPcs7GugKFsBFtopHsOhzrPPZCml8MQSTTFEjbtT8DK7FWes+ntUuktorZWCnnQ4FPAeejVi0Nk9SXdMqQn+EpzLJwWmUrRAULro2sdPgq9appY87xGyyc9gbgqYTr/S7bzQNeg5V0/SpwcbrDEWk7I8BPsc+z9wJ9TTz30cCxKHQtIiKtLYe13ikFOn5E60/Ci7Qifd+JiIjIZPUDTwJeC5ye7lBEJAO6CFfkZT2wKtCxRfbGo4A3AU9ARY5EHkKBtN27Gaugchf2QXJYqqPpHGdgrQs/DfwSa9kiDeSr9qIMrujpO8JTHQXnInwZiGFsvaM6DC7iOiLe42Luwkpuq5VteH1YEPYw4BPA71ApYpFGGsQCnwuAVxNuQX1HB2GhawXSRESk1RWw4JiIiIiIiHSmOdh6wWuxDSsiIglWfTmEGOUaJFsc8DTgfcDJKY9FJLM0gbxnW7BF69cBf8UWsSW8RcBHgfcAx6Q8lvbmIRkD56DvyIRpxydMOyahtDChMMtTmOeJu/1KP8YnfZW3AVdiN5US3olYC+G3YCFNEWmcrcAnsWt7sxyIQr0iItIeQk4yi4iIiIhIts0E3gi8G4XRRESk8zjgOcAXURhNZLcUSJu4v2LtJL8NrEt5LJ2iFzgHCwQ+HiXfg/NV8BV79Rzk6T85of/EhJ4DPbl+X8n1+P/zVV7oq/zUV9mU9ng7xDSsUuPHsZsatVERaZyVwMeA25t4zgPQ97GIiLS2BHsmLqc9EBERERERabrpwNuxymj96Q5FRESk6WIsjPZZFMoW2SMF0ibnfuxG+03AjcBYqqPpHI8Afgi8BpiV8lg6jq9AcZ5nxsMSeg71xF3cHXfziriLD3jPnT7BqzZCcBHwPCwQ+yzsZkdEGuMK4E/ASJPONw9VPBQRkdZWBZYCQ4GOr6cLEREREZFs6gHega3V9Kc7FBHpQJovkLTFwDOBzwAL0x2KSGvIAXmgCws86IN89xKgAvwB2Az8F9ZST8KbDXwCOA5LHN+FvW8llPGfBs5aehZmePpPrlZdRCUZ4ydbb47XVIf4CHAIHtX8Ce8YLJT2ReDLwNp0hyPSFjzwfeAs4PgmnG8utmvm3iacS0REJJQk4LEj9GQhIiIiIpI1RaxN5zlYV48sS3joM0t1h1+L2PnG7xg9j4hMVejvHX1vStoeA3wOWJT2QPZgItdBsGvejgWsHCqMIg2UA07DWsEdSLgdzu3EY6G0HLAg5bF0mi7gBVj7zmFU4a95vLXzxEFcAhw+ylOZfmy1UB1lwchyx9j66IE/o1vCoKYD7wSOxloNXp3ucETawrXARcBRWFA/pH6sSpqIiEgrC3XHH2HXyWKg44uIiIiIyOTlgGdjldFmpjyW8XztFQHrgWXAFmAlsG7c7wHcB6xh+4L8TGxdtLTDceZia3+52u/vU/t/HFr9ENmTkIVvSkB3wOOL7MkpwIfIVhitfv0C2AgsB0ax6+A92LUswrItK4FVbL+mVYDFWKW3Su0YVawaan2trAs4COjFrp31a6CuhTJhOWADMB+7qRLJuhIqgZmeejCtJu6BqAvikifXkzC8MqI6YtXUJKgC1rozj938KJS2G3o7ygT9FjgTOCHweeZgFdJERERa2SA2SdVoDpubKAU4toiIiIiITM1hwNuAfVMeh8fWNO/BuujciHUhWIstxI9ii+rDwNgO/+8wMDLuOAUs3LJj4YMi9jwS1X4/B8zA/u7zsEX6BcDBwH6oiozIeFuBTYTZkD0XWx++K8CxRfZkIfAq4OFpDwQYAG4HbsC+H1Zh18Ut2LXPY9e8IbYvkXrsGjnC9gCbx8JnpR1+LQf0YdfB+rWwG/sa7I+tcR2EdbXbj/BFHqTF5bA05EDaAxGR1uMrWNW0LigthKjbM7LcMbYJnBrtNMNB2A2AAmm74BwUcxGxUpKyZxcANxM+kJbHJrxERERa2b3Y5FYIC7AdmCIiIiIikr45wJuAY1M6/zasu8E/sbm7+7DAyxasKtrgFI87WntNRjcwC1vAn451QjgcqzDzVKyimkgn24hVJzw8wLHzqJq6pOcpWBe3NAwDtwGXAtcA92PXwfXAZix4NtXqhNtqrx2t3cmvRdh8XTfWunsWFtheABwKPBYLqSmgJg+Sw3YLLMPeICIik1OrmhblPaW5nrgE0fKI0bUOn9SCaRLKKmwxUHaiEDm2jiV84dZ1LBmY7NyCdKg7sR0iIauy9ACzAx5fRESkGQbZXs6/0VQhTUREREQkG3LYIvxzaz9vptuBPwBXAXdgQbSNTR7DjoZqr/EuZHtnHwXSpNOVeWh1wkaZjgVgRJrtbOAcmt8y9hbgIuAK7Dp4LxZCS0uCzQcOYsHTJeN+byb2vX8wFtYWeUAOuzhcj7Wp6kt1NCLSsnytc3S+H6JCQtwdMbLKUR0Cp6LVodyPPZjLDjwWSCvGjotWb2OkOtXNAdJh7gZWYLsaQwpRsnwykpTPLyIirc9j18wQlUVLWDucqwIcW0REREREJu5I4HU0b+2wgnUx+BtWBeY60g+h7clY7aVOVCI27xxq7nkOVolJpJnmAP8GHN+k81Wxrlh/YntFtE1NOvfe2AKsIVwgVVpYvULaXdjNkgJpIjJ1tWppcQ9075cQFx0jqx1jm5x171S1tEbbyOTLirc9D/TEEeXE8927N7JhtJr2kKR13IVVjQ0dSEv703A99mDQ6NahISccREQkWxKsQsEojW+Z4YBjsEUoLeqIiIiIiKSjADwGOKkJ5/LYAvwfgJ8DtzL19mMikp4N7LzVXyP0okCaNN9jgac14TwVrCLa+di18HJaL9yVw+b0RB4khyUtV2D9Z0VE9pqvWKvO0j6euNtbC8/17oFf1+WoYTakPYAsKkSOjWNVfrZ0M1++bT2jqo4mE7ccKzXc7jZhgdb5DT5ukcaHEkREJLs2ECaQBnAYVu5fgTQRERERkXScALywCecZAH4NfAu4DOvqJCKtaSNh59fT7jwinWU68Disin9I27AQ2reBv6BN/9Jmctgug9uBrSmPRUTaiK9lgHL90NOVEJcco2sjKkNABE6htL21DKtKIeN4D9MKMfdsG+NzN6+j4hVGk0nZRGcsfEeEqdLWD8wOcFwREcmeBLgTK8k/LcDxTwTmovtdEREREZG0nEr46mgrga8CnwGGAp9LRMIbIGx7wdnAgcC9Ac8hUvdE4MzA59iAXQe/DKwOfC6RVORqP64g+33YRaQVJRAVoPsgT9TjGVnhqGwFn9SqpcnkeYgKrHN51qlw+YPFkWNTtcKNm4dJ9MWRyRsj7ANzVjjC1arsDXRcERHJnruxQNqiAMc+jMZX8hQRERERkYk5HDgr8DnuBz4BfA1VgxFpJ6sCHnsOsBgF0qQ5Hg4cFPD4y4H/Ar4e8BwiqcuNW6+/CcfpQCm94YhIW/KAg9L8hHy3Y2iZY3S9s4bBIWMRbcp7iIp+IN/HgNej+gM8MKcr5vx7BnjXlSGfeURanq+9RERE9sbdhKu0HgGnAH8PeA4REREREdm5k4DHBjz+UuBcrCqMiLSXAWAY6Apw7EVYO+G/Bji2yHjHY9X7Q1kOfBBrVy3S1nLjKhTd7T2bvGcftdITkYarhdLiaZ6eQzxRl2N0VUQytv33ZGKcA++5qVrlBu0dMx4oRI7RsYQ1g5W0hyOSdYPANqwVWqPFAY4pIiLZtAFYG/D4jwF+D/wz4DlEREREROTBStgi/LRAx1+OVUZTRRiR9rQZaz14YIBjzwJODnBckR2dBhwa6NgV4HMojCYdIsr3VKi9lkZ5v8WBamaISBi1z5aoAD0HenoOScj11X5ZnzsT5nLgIu4nYfiBOkcd/nIeirHj53ds5V1/V5t1yby0o6SrsXbtISwCZgc6toiIZM/NWMg5hNCtEURERERE5KEOJtwiPMCvgPPQioBIu1oB3Bbw+IuA/QIeXwSsav/8QMf+GvCDQMcWyZxcFD2wJnpHz8yxDWODeUYG8ipWJCJh1B4zXQTFuZ64VGV4RcToWqdH0Inw4PIeIrYl5bQHkx3TCxE/uWULH/znWoYreiNJpo0BS1IeQ6X2CqEAFAMdW0REsucGYCVhFqwi4FHA3whbiU1ERERERLY7Cjgu0LHPxyqjjQQ6voikbw1h578XYS2Fvx3wHNLZDgAWBzr29cCP0TyXdJDcAwEQz91xPlnfO2+IuFBieFMRn6A2eiIShE+s9WR+OkTFhLjbMbzc4cecPnf2IMqzIiqyJvUaSxnhge7uiM3VKltHq2kPR1pbP7BP4HOMYi0z0xQTrrVmD9AX6NgiIpI9NwCrCFdB4SzgJOCPgY4vIiIiIiIPdigW+Gi0YeAPWJVlEWlfa4FbAx5/IXA28B1U5kLCOIFw1dG+D1wV6NgimZTL924vkOEdG6N8Qs+cIaJ8wvDGIpXRGBfp81xEGs/X2i1GJeha5Im7YHg5lDc7nEPBtF2IclybK3KHVyAND8zujvn5rVv4zo2b0h6OtL5eoCvwOUZIP5C2AlgW6NgzgTnA7YGOLyIi2XIXcA9wZqDjHw48EvgzoJ0HO5cAqp0sIiIiIo1QIkwYDeAS4NJAxxaRbFmOPafmAx3/aGB/YGmg40tnO44wgbSbgQuxLjoiHSOK4oT6yyduWVKOh+O8p3vGKL1zhyn0lh8IjYiIBJFAlIPSPE/vQZ6ufTw48Fpy2rmIS4i4hQg6/VXMO358yxY+ftk6lg1oHU722jxgRuBzbMbKlqdpK7Al0LHnAvsGOraIiGTTTUDInQGPxyqlyc5NwyZLQ030i4iIiEjnOBQLeYRwMXBtoGOLSLZswDawhbIQeDqQC3gO6VxHYHMtjeSBv2BhTZGOkquMbv+s9t5dnSsk9/iEo1yUUJo+SlyoMrSpxMiWAj5xOKdkmog0nq8CDvIzPVHJE5UiRlY5qsNAZO09BaICkLCqOoyCwsCMnpjLlg5xzyZtKJCGOBTYL/A5tgLrA59jT7bVxhHCbMKVs866GNX2FJHO9E/gNuARgY5/MvAE4G+Bjt/qFgHPBYppD0REREREWt5crPp9o63DnhnaWai5NpFWtBy4Ajgy0PFnA/8CnEe4jdfSmSLCrG9UgYuw66FIR8lVK9ED/+G9+3uScDtwlPe2npbvrtCbHyLKVxndXGvh6byW20Sk8bwF06Iu6No/IS45RlY5ylscPgEX7fkQ7S7q8huI2JJ0eDEwB0QOfnXbANetHkl7ONI+9seqpIW0AVgZ+Bx7UgZWBzr2dGBBoGNnWQQ8DZu4FRHpNNdgrZpDBdIAHotVSvtzwHO0oi7s63Jo2gMRERERkbawgDBzGzcA9wY4bpasBIaA7rQHIpIBy4HLgZcFPMfhwKOB3wBJwPNIZ9kX6A1w3A3AkgDHFcm8XJwf9xnt2UoSrUyqES72Fg5JHHEuoXfOCLlCwvCmImNDeUjARSrPIyIBJFYRrbSvJ+6G4eUwusHhy7VQWqcGYj1EOa6LSyzzHX57HTvoL8X84KJN3LJRgbRxuoEK6kE/VQcAPYHPsZpsPHgMBjz2PgGPnVWLgTfTmWE8EZFRrG1nyMWXE4DnA5fWziPmSGyCX1t3RLLDEWYBQ0REpBlm0Pg2ZQD30f5VYcrYvKyIWH+f27HqZdMDnWMu8GrgEtLvSCLtYy5QavAxPbaZU5U0pSNFuUKVB17FKkmV5dVyNDw+7+G9Aw+l6WP0zRuiNG2UKPZ4D16ZNBEJxFchN93Tc7Cne6En7rLPnI4OY8Vc6HLc4XLQqa84Dz1dEdeuHWbVNj3jj1MAngO8AFVpmoqDgUOacJ41ZCMwuAnblRPCQuDoQMfOounAa7CwhIhIp7oCuDrwOR6L3eeI6QeeRWddc0UaKVS79Qjb6CIiItKKerEqvI22jPYPjHTqNnqRXVmOtSgM6TTgDPT9J40zDcg3+JhV4H5guMHHFWkJUWUs4sGv+AZfdbfjdpI085ArVZk2f4juWSPUq6vV23uKiDSch6jg6T4goWdxQn4auLgzQ2kuB3iu8VWGfdUCe532IgGqcPPaUV7zx1XctFbV0WoKwHOB/wK+BZyDduVP1hlYlauQ1gN3Bz7HRG3DQmkhdFIgLYe16nwxjd85JSLSSq4A/hH4HAuBlwBHBD5Pq3gcthtcRCbPY/fDIXY4OWwhPxfg2CIiIqEdABQDHHctoIlckc6yBgukhawqMA14A9oQIo0RYXNOja7q57Fq/x24si0CuepI/KBf8Im7NClWrsXvusqDiz09c4bJlSoMbSgxNpTDe2uxJyISRATF+Z64O2H4PsfYBmehtA763Im7/RrvGax0cJOirpxjoJzwuj+s5M4No2kPJyvywL8BHwH2q/3a27Gb53PRrouJOhvYP/A5lmM7YbJgBVY2/eAAx14EHAP8JMCxs+bhwDuBWWkPREQkA67BrnP77ekP7oVTgbcAb6SzW3c+Apt0n532QERaVBW4BWuZMi/lsYiIiHSCjWkPQESabhi4rPZjX8DzPBJ4KvANFHyVvddBq84izfHQ3XqOwWolvr9aiYniXQc1nYNiX5k4nzC0scTI1oLlO0VEQvB2F5Cf5nGLPVGXY2RVhO+Ejo0ecBAVuCYusLYTq8OBXXdyOce2kSqD5Q79IjxUgYeG0cCqo70R2yH0BeC+5g+tpTwcOL4J51kC3NGE80zEZmyXWghF4DgsLFkOdI4sWAy8mc6pBicisidXAH8FXhbwHHngGcCNwFdp7+vMruwLvAKbdBeRqasQbiaz3ualE2YsREREJkKrhyKd6T7gT8CzgXgPf3aqctgc7c3AhYHOIZ1D1yuRBsvlStWH/qpnRXUs2hx3J/1+F9929Ypo+a4qvfOGiItVhjcWSSpR2BGLSMfytVBarhu69/PkehKGljmqg+6B0FYb81GOn0QF7uzUQFpXPmL5QJlz/ryS+7d24trjQ/RgrTnfhLWw2lE/FkrbB3gHsKxZA2sxDngOYSqF7egW4N4mnGci1hE2qLgQq2ITun1bWuZi33/PSHsgIiIZsgK4AHgRFpoPZQ7wNmA18Eus0lGn6AVeA7wg7YGItIGIMLMIMXAQ9v2qatUiIiIi0sk2AL8BnoBt2gjlQOB12LzEnQHPIyIikxS5CHZ8gbvKe3fZnv5n7y0DEuU93bNG6NtniHx3RdlREQnGe/AJuAIU53n6DkkozKol1dr1s8eqo5WJuZ0IOvHVU4xYsnmU//j9Sq5frarLWBjmA1irwJ2F0eoibPfR54GTwg+rJZ2IPRB3BT7POrL1MDxK2HDcIuCMgMdP00zgtVggLdTOPhGRVnU18NsmnGc/7D7o+CacKyumAe/CJtmLKY9FpB2E2tLmsEqG3YGOLyIi0ooOZmcdm0Sk3VWAS4GVTTjXM4AXA9ObcC6RyfK07yq2yG5F3tcCHuNfcKNP+EcykSo8Hkggcp5SX5m+ucN0zRht73CIiKQvASLIz4Cegzxd+3miAvgq7fXZU6v8Fvf42/BsrY5AMtZZr+oY5BNHZQxuXqswGjAfeDvwaqxCyJ4UgGcCnwWehAI04/UCrwcOa8K5rsbKhmfJWiwoF8JM4NGE3fmWhhzw78AbsPePiIg82B3AL2hOm7oTgXNrP7a7GPh/wEtpv2urSFruAAYCHNcB84BSgGOLiIi0qh50bRTpVOuweYLBwOeJgZdjayEiWRJh6yX5tAcikoYoynl2fMX5BLxbm5Qn3n7Te4cH8j1luueM0DtnmCif4JP27qEnIilKrFpars/TvSih+6CE/PTtVdTahqfsYn7vPWt81UJ3nfJKKtCfi7lnQ5lP/GMdo5V2ShtOyT7AW4BXMbnFyAirVvUR4GXYJFCnywPPA55Gcx4ErsJadmbJSuC6gMc/FHgM7dVQ+QVYGK0/5XGIiGTZlcCvm3Aeh11nPkF7V4LtBd4NvAdYkPJYRNrJJqAc6NhHoftFERGR8fYBZqQ9iMAS2murvEijDAE/I9zG6PHq6ydPaMK5pD1NPBwzcTH23mz3YHYZXQdlJyJfC3Ts+KqWo6XVcnzLpJYQPfjEkcsn1sJz3jCF3rL9um+ntUgRyRJfhagApfmensUJpbkeF9eqpbU6By7HGJ4/4tmc9nCarTsfcdO6ET546RrOv3db2sNJ2yHA+5h8GK3OYRVE3ge8F9u138lOBt6I7UwJbQ1wLc2pFjMZ67DKEKHsDzyf9mkr9kIsDHBg2gMREcm4e4BvAxuadL7HAR8FHtGk8zXTbKw16VvQvZtICKGqNMxA37MiItKaQm3zPgxrad3O5qFqxiK7chdwMdCMVbtjsTncdpwjkLA8VkU7xDrOUbR3x5UYa8/dzn9HmaKoWnbs4nVFUp3armZfazFXmjFK39xhSv2jRLG3amnKRYpIAD4BHBRmeroPSuhamBB3+dZu4Vlv11lkC7DSV3ceIG7XV1KF/kLM/VvL/H5JiE4qLeVY4GNYm87pe3msRcCbsWoiJ9Be1asman/gP7GHgGY4H7ihSeeajHXAbYHPcTpwFq39PpuFVRZ8P1b1TURE9uxq4Mc0Z7IZbPfzucCzaI9KsBFW9e2D2H1bf5qDEWljKwMe+3CgK+DxRUREQghVwehQ2jeQNgtrE/g0Wnv+SySkEeBbwL1NOt8Z2Ma105p0PmkPHliOVfVrtH2A/QIcNwu62N6NqDvlsUgG5eLcLpIa3m9zjuuTiiOKp5Dm8OCrjnx3md58QlxIGN5UpDoWA+BcqyZERCSzvAVicz3Qvb8n6oLRlVDZ5vAJuBCFVgNzjmrU7S9xEVtbNlg3Bd7DjO6Ye7aM8VdVRjsK+BDwzAYeswi8BAtmfQP4G7C2gcfPsnlYZbSn0pxJogT4K7C0CeearASrkDZEuAeFBVhVlxsJu+AXykzgNVibztkpj0VEpJWsA84DngQsbtI5H4ktBu2HtQNZ1aTzNloRq/r2OuCx2C5TEWk8jz0DDRMmOHY68BvCViQWERFptDXARhrfUWA2cFCDj5kFB2GbGF+N5o1E9uQfwCXYHEEz5uXPwjb5vxO4sgnnk/awERgLcNwYOBN7L24McPy07INdB19b+7nIQ+Si/K4r8HrvNlRH42VRd2XRVE/gvSPKJ3TPGbFQ2sYi5eEcPnG4qIPSFSLSND4Bl4OufTy5Lhhe7ilvikjK4FptOSdiU1TgPBezvpMCabnIsXx4jM9evYEf3rY57eGk6UjsoenpgY5/NnAc8B3ga1iLrXZodrsrB2DBojc38ZwXYu06s2ol8E/svRDK6cALgP8mzO6iUBYD/449TM1KeSwiIq3oFuCrWJWvZlUtOwL4L+we6gtYJdBWuYuOsTDdv2Jh6P3THY5IR1iL3Z+GCKSdiT1/KJAmIiKtZCuwjcYH0sAqFv0RuDnAsdNwHPBW4DmoKqrIRFSxNYjjsc4tzXAW8CngXcDlTTqntLZ1WEW/RnPY5sMf0R6BNIfNvb0WeAWQT3c4kmVRUo7YzeuOpOp+v9dn8eA8dE0fpW/+EKVpY7g4wXtVrxWRQGrLTvkZnp6DPcV9PHFXrbXnrnO42eGBCKIi20i4ylehU15JFWYVY3584xZ+eNPmtP8l0nQk9rAUKoxWNxOrYPVNrM1VuwZvHg58FnhTE89ZBX4I3NrEc07WKuAiwgYRu7GqdKcHPEejHQ98Eng37fs9ISIS2jB2HbyI5obC+oBXYVVgn4VVR826Hmxi8kvYZgSF0USa4z5gINCxp2ML1a22LU5ERDrbfYSrNHwWFkprdTngCdjmmxejMJrIZPwTC6aONvGcj8LWPp5N67cTjLH5gjlpD6SNLQe2BDr2STQvjBlSju1hz/9AYTTZgwgHu375leB+4ZPGBMc8jnx3ld75Q/TMGSGuV2drlf3KItJ6PMTd0HNgQveBCfk+IKIlPndcjI9L/rqkwlgyCslYZ7wow8oNFdYNtHOhrt1yWLWqbwFPbuI5H4Ut3H4cOJH2mUyJsXZhn8YWpZuZhr8MuJRsf+JswXaHVQKfZyFWme6YwOfZWyWsPe552CRFLtXRiIi0vlXAucCSFM79COzz/DPAaUBvCmPYky5sMvITwPeBp6Dwikgz3QysD3j8pwInBzy+iIhIo92PVdMPoQ94PHBgoOM3wxysGswPsM2vIjJ53wAuaPI5j8Q2gL0OWNDkczdKD/AY7PPnP1IeS7u7h3BrOi8Cjg107GaYgV0Hv4mtu4nsUS7aU9vMhC3l4dx9hZ7y3u/Q9bWiPzlPz6wRcsUqg+u6qIzE9hsqmCYiIdRaeJbmeeKuhOFljvJGh69i4bQM8h4ix7K4iy/i2JrpOEuD9Zdi3n3BGs67ZVPaQ0lDhO0s+CJwVArn7wdeid1IfhUrH3w/rdnGM8ImiV5Vey1s8vlHgO8C9zb5vFNxD3A7VsEhpCdid3z/CdwY+FxTsQh4NfY9MDflsYiItJPLsAnndxKm9c/u9AIvxBa+foqFvm4m3RbSDihi93r/jgWhF5LZJxORtrYSGAx4/DOwzUZX0Rq12kVERO4HVgc8/uOB52IbMlpJhAXQ3gg8jfbZyCuShqXAL7EOFfs08bwLgA9i9+gfwaq1tYIIq/z+JmwOYT5W6e0y4K/pDaut3YW11QzROeVxwDOAO2hupcC9VW/R+TbgBUAh3eFIK8mVR3a/+dYnblmcT/5Q6C6fQ4Tb61BE/f93UOwrk8snDG0oMby1YFMzCqWJSAi1Fpj56Z646BleETGy2uHH2F4VMis8uBiiEutwXJGpsQXmgNEkYctoK+afGuJsLIx2ZMrjWIiFhp4P/C/wPdKpbDJVfVh1uddjFVGavcCbAL8D/kT4ymONsB74A3A4tkAeimP7rpn3ANcHPNdk5LCHwLdgEyGtXrpdRCRrqsBXsB2gL0xpDHOwwPG/YBO2PwT+AWxr8jhmYlVpn4vdo+yLqnGKpGkj1pospBdi971/CnweERGRRqgQdnNlNxaouA34TcDzNNIs4GXAOdhmRrUmE9l73wOOxkKezdSFVSY/BquY9h3smSCr5mHzBy/E5q3rIaATgZcANwFr0hhYm7sR+7qGCKQBvBy4E9s42QqKwEuB12Brl6rsL5OS89XdJx28d2t8wo994l7mnG/cImWtIlquq0LP3GHiYpWhjSWq5QjnOqgUkIg0T+1zJ+6G7v0T4l7H8HJHZcBlK/PlweWoRF3+hqTcEmGWhogcxJHjAxes5ee3hmrRnmlF4BBgcdoDqenBKncsxB56LsFukC8j3aoiu9OHteV8AfaANpt0qo2sBj5LuBYHjbYFmwT8D8IG0mB7KK0b+DBwYeDz7cnDsEnFp9K65dpFRFrBINYWfBEWyEpDEdt9/Vzg0djk39+xkMhNhLu/6QNOx/7eZ2AtiuajCTyRrLgF2IS1HgnhaCwQew/2uSMiIpJ199ReBwU6/hHAm4HlwDWBztEoT8Q2vJ6B3deLSGOMYd1FDsO+z5rJAfsD78aqNv4Y+C2wocnj2J0F2BrHs7Gv0QweWlbj6Vi496PNHVpHuB5b4wlVOGJ/4L3AAFYoIKscVtHtVVi72P5URyMtKxcXJlQxfk15OHdvoad8OBGN65rrweOIC1W6ZowSF6sMri9RGaptEM5UQkRE2oKvtcMs1lp4FmF4BYxtABKXic8d7yGKuDMu8nWg0intOh3gHTz1sGlcv3aEq1cOpz2kZhsFLgC+jQVkQgeDJmp67bU/tpC6BLgcqwB2K+mXFXZYZa+nA4/E2k7uS3ptr7YCXwauS+n8U3U3FjZ8chPO5YAzsV1o3wJ+AqxqwnnHexTwPGxC8SBUFU1EpBluwSZKpxO+TfTuFLB7hX2Bk7CqaSuxa+FNWEvPJcBaptZibw62weBQ4GRs5/U+2ISyFrFEsucmbEE8VCAN7FllC/AhwldkExER2Vu3YNVhQgXSwOZjPg78F7YJNmvq80aPBw5Am0lEQrgeq1B2NLYpvtlmYt/jx2HzAr8Cfk96FccK2BzF07AWwUcBc3fz5/uA52BrNRcEH11nWYXNET064DmOxjbsR9haW9YcgVXhexo2v6XroExZbiLVyLx3K6vl6Pse9z6HLzV0BB68d0Sxp9hXJoo9QxtLjG7N4xOHizokiSEiTeWr4CIozLQWniNdESOroTpi7TLTGxi4HMQlv8xFLdPDvmESPI8/uIf/u7PUiYE0sB3zH8N247wBmJbucB6khN14Hgo8Agsu3Q/cBVyLhdPupjktKmdhN8THYe2/jqz9d6gSypNxIRayGkl7IJO0FWvP+nDsYTw0hz1UvxcLEv4aOB9b/A9lNraj51FYZbQjsPe1iIg0z5+x6mDvJxtVYadhgbFjsN2ea7CJx/W11wZgHdbaczXWyqP+tJBgE8YLsYngWdi1Zj42aTyv9srKJgMR2bkbgRXY50AoOeBfsU0QX8JaBjdSF9YG+CQsRHA+1i5ZRERkKm4HrgKeGfAcEbbQ34Nt7PwFUA54vomIsPuBZ2GV9I9he3s8EQnjj1gFsPeQ3rPzPOx7/mTgGcDF2NzFLUxtk9pkRNh6y6OwefnjsS46vRP8/48HXo0906xv/PA62mXAE7BCDaGcBJyLrcf8HEh7UTTC1tqeha2jPBy1qZYGyHk/gXJAnm14fp2U3RvjQoMDafVT1HJnhZ4yUZyQKxQY3lKkOhrhHJmoWiQi7cUnWAvPXujaPyHqcoyscpS31lp4pvC54z3EeYbjLm70HTp9PDCcMFwOfZ+facuBT2E76N+BVdnImunYzejDscmiJcBSbLf/Cmzx9j5sAXcjsLn25ybTizWHLRLnsdZWc7EF3gNrr/2Ag8nW1+cG4HOEDVWFUgb+hv1bNiOQVjcTKz3+MKyV53XY7rirsPfN3pqLBRePwyYVTsUeItOqoCciIlYZcwbWHmN3u32bLcf2ymnjDddeG7F2CvVriK/9P3OwkEkPur6ItKIV2LNMaL3YxP5CrC3Q+di991R34sbYYtUpwInYItZRteNeSPqLGSIi0truxMINswOeI8Y2vc7Dwl+/wEIVzdjsOl43Nsd5GhaSOx1tKhFplgHge9g8/7+nPJb5WGXjs4GnYIG0a7CQ7l3YnMDeVtGJseeBQ7DPvUOwv/txTH1+5LHAK4FPNGB8st352LpFyEAaWADsXOAE4AdY8Ydm/ztOwwo/nIEF0U7F5rhEGiLnJhK4sGTG+spo7u4oV57rYh/sW8EnjlypSnd+hLiQMLSxRHk4tqpBCqWJSKN5q5YW5aG0wBN3eUZWRoxtcCQVq6LWTM6By3MtOb7rOzST5RN022zVqr6ELWq+lWwt1u4oj7XMPHzcrw0C9/LgQNo2rKIaPDju6Wq/F2ETQB7bzd+Dhc4KWGn8eVi7q+lkM6a+HPgK8Pe0B7IXVgI/wyrWNDOUBrb4/3zg37BWaZcDd2DVaJYBm7BA4xZ2vdg/E6tQMwd7sF+A7bA7AXt/hpxMHAEurZ0rC5X6RESybAybcJ6F3edkvW1yV+3V7GvjRA1i18rFaOeqyFRdgwXTdgykNloBW+Q+AVvwvgi4DQvEbcAW5Ha1CD8dWIQ9Ey3CnpGOxxbQx2/SOab2+3c2dugiItJh/gn8FnhpE861GNuU+zCsXd4F2PVxNOA5i9j18hjs2vxo7LqaxTlHkXZ3H7bJex5WkSptfVgo7SxsbvpubJ56CbYGsAabo96MVVjf2eeGx+Y6+rG5hHol9X2xANphWMvGRlRhnAm8EPvMvrkBxxOzGitA8PQmnGs+cA72njgfq6h9LWGvgw5rzX0Cdv09E9vglPU5OmlBuQm3xPRs9In7OragF3Qi1ieOKIKu6WPE+YShTSXGtuVJKmrhKSJh+MTCYIWZEJUSoqJjdG1EdbgWSmvGo6gHl4eowB2+wq1NOGMmjVU8p8zv5tL7h1g2kHal9lSNAl/EFibehT2otIoe7OZ5oqrYd1mrVhXZCHwD+GHaA9lLZeCnWDuhU1MaQ8z2imZgQbQ7sAf9euu0Hd8n9ZvDfbCH/Pous2bt4qlii4k/rJ1bgTQRkT3bBHwd24X5cibejkIe6nrg21iF3ayG5kSy7q9YFYTQgbS6bmy3/bOwBfebsQWPJdg9b6725+qVGGdjC3SHYdWiF7Pr1vP92K72pVgAWEREZCqWAX8CnodtzggtxkJhj8Y2e/4Rq050T20sA3t5fIeFu/fHNjAeiVVnO4nw1W9EZM+uBz6ChbZOSHcoD3DYfPM+WOUosI3192H37GvZXml5xxVEj81zzMHCRgfVfgy1/nEo8Dbg9ez956Vs9zusEvWZTThXCat2dzbWPeZPWCDuTmzz1DZsHWKq6tfBfbDNTUdglUHPJFtdiKQN5SYcsnBUgF9VK9E7c1E1+CTng1p45hOG8yVGtuSplmOcUyhNRBrPe8BD3A3dB3qiroTRVY7ygIMkfLU0n0BcYFlc8pcG70yfYSNlzyuOm8GKgTKfubLj296PAN/Cdtu8ByubG6c5oEBa+e9UwUopfwEYSnksjbAMayF0INl4EJmBVX3IsruAT2NtkVr5vSwi0mz1NuUeeAkWopDJWQl8GbiC5rc2EmknS4ErgWc2+bwOWxA/soHHnI4t5v8IBdJERGTvXIm10Xxxk897Zu21vjaGq9heRX8zVpmofo3bhs3HeSDBQt/T2d6JoQcLdh/A9kowp6BnD5Esuhx4P/BRbB0ki3qxKlJZkweeBlyIPQd0dKWHBroSC0k3I5BWF2PrIQ/HrneXYYHNO7ENTNuwdcMB7No3hFXOr68q99ReOew62Ff7732wIhLHYcUIsrD2Ix0iN8mWcGPlwdylUZwsjvO+0Ix2ct474kJCz5xhcqUKQxtKVEashaeK54pIEAm4GLr29eS6YXi5Y2wTtsTjCPbZ4yJwOa5wBX7dyYE0B5RznorCx+P9L1b++Z3AE2lMKWfZexWs5djnsYeDdvFNbBHraWkPpAXUK/xcgO2o7eBPbxGRKVmBTTZvA16GVSuQidmMXYN+grUbyu32T4vInvwDWwQ7Le2B7KUIW2ifhd2rioiITNVS4JfAc2hOlbQdzQaeXHuBPTPchS3I1xfi6+3zqrXXPKySaFz7+UKswqjulUWyr4pVR3TAx5hcBxaxiulvxkJUt6U8lnZyPla17Iw9/cEApgNPqr3AOvUsxbrILMfWp9Zgge16CHEfbG6thFUcPBCrzje9WYMW2VGuOjaJkj+eERzf8VV3ls8lhzQtEebBOU9pmrXwHFxfYmwwj69aiz0JTF/jdCiLk65a6DU/3RMVE+IVjtE1jmpt71XDP3s8RCVP3MVNeE0aVxNPfykmjqCqeEfdZVjZ5XXAv2E7GyQ9CfBdbBF9aaojabxtWNW3I2itVrHNNgr8DKtiWJ8EbYcqeSIizbYea81xL/BBLFwlu5dgQbTP1v67Vduei2TJxcCfaf1AGliV4bOB+1GVNBER2TtXYnNEryD9laJerMLZ+HZ+O1tFSXucIjJ1VaxNogc+jkJpk3UUFkp7D7aOJHvvMqxgxMNIv1DEzNprvB2vg7oGSuZMbtLS3sJXVYZz63wlSuUtne+qMG2fIbpnjhLnEpuGVXAnrFobQ2mygJW4ZIJqobS4y9N9QEL3gQm53to/S4O/J7yHuMiFcYE/UcU+2zr4NTCc8OoTZvL201Q1dgd3AW8B3o1VTJN0JMA3sMXzpekOJZhfAv+HTQLIzv0Z+C9ga+2/ddUWEZm6UeD72MTpzSmPpRV8G/gwVhkCdA0SaZS/YQvvra4LeAwWTBMREdkbK4Hv1H7MIreTl4i0Ng/8HngXmh+YrBzWZvn0tAfSZn4L/DztQeyCroGSeZGvOib5qpYHcxcmlWjApdROLc5bC8+++cPkuqt4fXs1h0Jp6dD7O121QKbLQWm+p/fQKvlZHt/goGaUB5fjYuCqxh21dSVAbyFiWkHFHnZiK/Bl4PnApejTudkGgE9hi8D3pTyWkCrA54BfpT2QjKpPiqxIeyAiIm2kjF13zsE+ZyvpDiezvga8H21OEAnhEqwKcqs/Y8VYSxkF0kREpBGuwSoZD6Y8jqwbQJXzRRrFA3/A5l9vTHksraaEFTU4Iu2BtJF7sI2Bd6Y9kBYwgKp0yw6mstLvvedTScVd45N0kjLeQxQlFKeN0Td/iNK0MYV2mqXVp+RalXLN6fPgYshPh96DE7oWeZvibcT3hIe4yy+JilyfVMAnepFAuewZq+pDZzf+DrwS+G802dEsg9gC8CfI7s7QRloO/A9wddoDyZg/A+8Abk17ICIibSgB/gG8EfgisCHd4WTKJqwy5/tQGE0kpAuBX6c9iAaYCzwWW5ASERHZG2NYu7LzsMrGsnNfwDoOiEhjeOCPWLjq4pTH0mrOAP4dmJX2QNrIBVgbWYWtdq6KPUt/D1tXEnlA5HKeSb/yfkt5JHdndSwirSpp3jtcBIWeCn3zhumZPYLL1aoWSVh+3EuaS6G0VPnE/gly3dCzf0LvQQlxt2/I94LLcZ5z/PpB31966XNmz27H2ka+GtutKOHcCLwMCwBuTncoTXUB8CVgWdoDyYjrgE+jMJqISGhLsIm+16AKwgB3A+/BrkHrUh6LSLu7Hfg6rT+JnsMCafPTHoiIiLSFTVjHgN+gSsY782VsjvbetAci0mYS4G/AG4CfpTyWVvNS4Oy0B9FmfoV91iuc/WAeC6O9C9tkKvIgkXMwlVdSic6tVqK/+RT7ZfpaDiQuVumeNULf3CEK3RUFGJpJX+vmUygtVd5bMC0qQmmBp/dgT2G2t6peU/l+8BD3+OEoxx1JGXxVr/prYCThCfv38aIj+xv8r9h2VgM/wKqlfQlYn+5w2s4w8CPgtcAv6MwdMD8DPgmsSXsgKfst8Hrs4UpERMJbj1VieAXwFTqzWpoHLgLehrWH2JrqaEQ6x4XY/W+S9kD20pnAwrQHISIibWMptkHi+nSHkTlfBj6GBRSKKY9FpF3dALwdOBfNUU/UPKyQwYlpD6SNbAG+hq3HKZxt6vNW7wGuxDZG5dMckGRPLoqmmCiK/D1JObq/Wo6IC0l6wSQP3juiXEJX/xhxIWFoY5HRgTw+cTiFd8LzKCTVbPWvtwKBqfFVrErjLI8reOJSxMhqhy8zuWbIDuJuvh938Q9fDTXa1lT2nuMWlHjsll5+cOvmtIfTCq4D1mLtFV+ClWXOpTmgNrAaq47wQ+DOlMeSphHsazAH+E8684Hi18B7gVtSHoeISKepYlVKP4JVSnse8MRUR9Q8G7Hr7w+xSria7BRpnlHgx8Ch2CJOq97/9gPHAVegzxAREWmMq4D3A58Ajk15LGnbirUm+ziwqvZrWikTCed+LJB2N7Zx7WHpDqclbAWG0h5Em1kLfAboBp5D6z4rNsIo8Dvgs1gYDSBObziSVbmkOvX7I1/O/SbKJafmitWj0qyUBjwQPiv0VIjynriQMLKlQHU0traiug0UkQbzCeAgPw3iUkLUFTGy0lEZsF93EwimxV34qMDviVihAO2DOWDUJWyrKqk3CSuwiZBrsJvhpwInpzqi1rQJuBT4CdaKYDDd4WTCJmzHp8daly5KdzhNU8aq83wYuC3lsYiIdLLVwHlYqOL5wJOBk5jcVpBWMQZcjv19fwEMpDsckY61Hltg7sfCsK262edRwPnYwp2IiEgj/BHbOPIW4NF05mL8Juw+4VvYRhIRaY5N2LPyPcB/YOsfpVRHlE0bsaDQ54Hb0x1KW7oN+CAWTnspMC3V0aRjAPgp8EXgppTHIhmXq45Nff7We/eb6mj86KRUPcrlfOrVmnzt/Llild45IxZK21RgbCiPS3x7TlVnRf3fXoGa5nKk/n3X8XytWloeuvdNiIuOkVWOsQ0OXwG3qylrb59ZuT7/l7jE3fVwmzzYaOI5eHaRMw7o5pKl2sgxCbdgN8V/A14IPBI4OtURtQYP3IwF0X6GFm12tA74FFYW/c3AIekOJ7hVWGWMT7N9p6uIiKTrDqwdzt+x8P2ZwGG0blBkvDJWkfUPwC+Bf6KnPZG0rcQqwPRii12t+FnzKGB/9GwjIiKN9WdsIf4twLOwa2UnSLB5128CX8U2k4hIc5WBC7D1j+uwz6Djac179RBuAb6PfU5tSHks7exOrKPKNuAcYFa6w2mqtdj762tY5UKR3crtTQDCOU9lJHdJuZg8tdg3dlDaVdLqfAIu8nTPGCFXqDC0scTYQIGkOrGKRbIX1L6z+RRKy4Za5+LiHE9UgqgIo2sdSRlrHbzj94WDOA9Rwf/Qxdyq75udG0yqPPKALt5WnaVA2uQlWJWva4CzsEXbh2OLtiqb+2BVbIHmMuxG+rJ0h5Npg8C3az++jvasTlPFWt+eV3vpw0dEJFvGgAuBi4HHAs/EKsIeTmsuhI1iE3iXYLtLLyA7rfUcmtQXuQV4N1Zl4LlAT7rDmbT5wFHYZiUREZFGuh6rELMK2xC7b5qDaYIR7F79K1iVOK3KiKRrFdbC8x/Ai4AnAAvp3FXqNcBFwA+x0PBoqqPpDNuAT2LvxZdjRSHauWqox56PP4u9zxTKlgnZ64nFpOp+UR2LTkwq0X+6KDv3X1YtzZHvqdKbH2Y4X2vhORZbKz2XnbG2HYXSmm/811tv7VT5BHK9np6DIO6GkZWO6lA9KFv/Q1irz5n+zqjIDbWPK9kJB5S9Z6iiN/ZeGMYmSf4CnA28GDgNa7lYTHFcWVAFlmLBvR9iC8EjaQ6oRYxiu6zuA96IPex3pzqixtmKfb98Brgq5bGIiMjuVbE2dOcDx2IT0Gdh9zizyP4k4CDWivQfwHew+5Cs9aqvYC1RkrQHIpKy24D/xBYcXgr0pTucSTsNq76oKmkiItJo92ChtBuA1wPH0Hrh7YlYi3VU+BK6nopkSRWroH4J8G/A/wNOxOYEOmVT/jBWKe4HwHdr/y3NsxULKt8EvBZ4Iu3ZwnMj9n32Oex7TmTC9jqQZlXS4uvKhdyaQm95XubCMB7ifELP3BHiYsLwxiKV4Rjva1WLJAy18EyPKqalz4PLeboWeuIux/DyiPKWWmvPWijN5RiLe/ynojy3ql3nHkTo69MYFSyU9hesbcszsUXbxVg1kXarcrUrHgudrcJuoM/DAmnlNAfVgjz24HEz8B/AvwMH0boP+mXgdqz629fQg7uISKu5EXgHVgno0cCTsEnouVhwJCsh/BFssnIVVuXtx8C1ZKci2o6GsN2v2vUqsr0t2e3AG7D29a1y7/tIrIqkFtBFRCSEYeBHWLX5/wD+Bdsk0g6GsPv1LwE/S3ksIrJrCRYa/S3wZOBlwKlYMKgdq35Xsc/epcDPsU1uy9IckHAxtlbyEuAVwP60xyb+EWA58D/Y+2xTusORVrT3H8IOkkr0q8pIfGS+q/LBLFVJG89Fnq7+UfLFCoMbSoxuK2zfe6ygQzgKpqVDobT01aqgFWd74u4qw8siRtY4W2qKoNDvV0Y5LvReIZg98d5TzDlmlGI2jWStaETLuhirxrEAeArwbGwHYz+2YNuOn9oVbDF1GfCL2utWtMC6tzYAH8WCjm/FdgB10zqLc1VgBTap+A3gLnQFFRFpZauxkNePsXDaY7CA2unAbKAEFGjehHSChZ5HsLacF2Ntfi7Cdpdm/cnNk+3xiTRbFZuIvxarFPwkYDrZfn4axr6Ps141UkREWt+dwNuwe/F3YhthZ5Dt6+SujGDPFt8AvoW1whOR7BvEAlp/xOYCXgU8AqvcWEhxXI1SweYYrsL+nn9G89lZshFrZ/l/wDnAc7GNkq343kuwv8//sr0CnMiU5BpxK+giX0nK0XWV4XhrvqeSzTKEtXBIrqtK37xhcoWE4c3FJKm4Ch5HvQZPK94atwL7+jta8+GjNdW/0h7P9h33rRIQaA/e3vpxF/QclJDrcwwujSISBnJ9/tMuZoVX85s9GhhNePh+XXzlWfN5yc9WMlbVvXWDVLFw1rex9ouHAU/HHtROwRYsWv0zI8G+DdcDf8Me0q4F1qEKWI3kgSuxB/wzsR1AZwNdZLfyXhV7oPot8HXsfZHlgHBM9u6hdF8XTsjvm6z9u4V8b2ft71rXaX/fNNRvFldhO6R/jVVJOwQ4CTi59lqIBdMittfk3ZuvYT28Vd9BsR6bsLsWuBy4Amv3Nzruz2T9xjaL76us3lu0uiz+W2fZlcArgccDb8ZaYmat8sIoVj3y58DvsIUq2Tv1+WOR3enE90knX0NC/91b8etaxa6Tr8BCIM/FAtyz0xzUJFSxSjA/wtrf3Ub69+xZ6x8S+j2fpb9rs4X8+3fa13Ub8HtsM9jRwPOxjdT70ZrhoCpWbf1i7LPpEmzOoV0rOLT6Z8HdwHuxOakXYlX7DqR1NgltAX6FBbKvx76fJirUNStr74esXZszLVfoaczam/f80cMHPHwus1/9WigtKiR0zx4h111ZNbyxeMXYQH6lwlLBVfBMx3EqcGTag+kojg14/g6srP1Kp02KpKv2uOryUJrnoyhX7R1dF60j5qfeM5Lu4FpD1UN/PmLhtLxaLYcxVntdD9wBfBMrJ3wScAa2YLuI1gunrcBCaOdji8ErsRvprLbEanUe2Iw96P8Te9B/CtYa9oC0BrUTHttB9jPs/XEP9kCV9XhwPVyZJaqaE07I92PW/t2qhBtP1v6udZ32901bBfuc34YF1K7CWpX3YrtU9wEOxVqYz8JCaiXsmXUiE4UVrEXGptqPy7BKaNfXfhwDBrBd2u06UdxsWb9mtyp9hkyOx76vfwtcAzwcW3B/HBaATUuCfQ5dgO1kvwmr6DKa4pjaiUefQbJnnfg+6eRrSOi/eyt/XTcBf8A2ZXwZmyN6GnAEdr+dNWVsI8nvsA0tS7AqaVn4N8janFDo93yW/q7NFvLv34lf13qI6wqsleIXgYdh4aBHA/PSG9qEbQIuxYJ1F2L3+lvI9sbqRmiHz4IR7LpyB/Df2PvuccCjSPeZcXfux54jfw3cgm3on+y/Q6hrVtbeD1m7NmeaG/r5/IYcyHuI8/6wfFfls9g3VaY55/FQrY7FtyXl6DvO+Z9UK9HI1hW9uWo5Ioo77bkxuHqNtPnY4vTbsUUACa8M3At8CfglnkGsJZ80Uy3yWt1GPLwyqsZdfr3LkehyNTHTShFXLx/h6d+7n9GKvmhN0oXtXpyJVRQ5HquidhS2aJulnUQeWItVALgOuAy4D1t8WYdCaGlwWAvYA7Bw4xOAR2Lt05otwSpC/BlrVXsjdl1sdCg4whYiF9K4Rb96DHc1Fq7c3KDjNsJ+WAu8fWjs91geW9i9nM5cPI2B47BKlT007msbY1/Pv2FtVLJyMZ2FhaB7aOzCXYRdB1aQrRBQHgt6P5zGTlzksOvd5dguTJmcHuzZtIjd/8RYC76Y3f8bOez9NYgFzwaBodqPzd54cibwG2zcjbQceAn22ZEFDmsz/zBsAreRn5FjwE+xXeadqBf7uh5FY1vJlrDPpV826HhZlcNCrgdglRfOxK7lXU049xD2Nb4cC6LdgT0HraXzQjGhdWP3LbNo/L1UHrvnv73Bx5Vdmwv8G/a1b9T9Yg5b+P4ntvCdlXtusM/2f8U+pxp1nxJhX7ubsb/zUIOO20pibEPemdjXo1GfuzkscFB/L7WDfmye8Vjgsdh9x2HYvXhaxrDw9vlYYOUObBPLNqb+/XsSNlfSqPsph70XLsI2wGRBCXumPYnGhmIKWADiEiZXjaedzMECKwuw92cj1D+b/o59nmRpjiQNMRZEm4dtRDsdu28/jGyEhBJsA/UV2Ia6y7F7+/Vk8zp7Ojbn38huNDH2eXcZ7dUuuRv7Hj8M+wytV+/fJ81BYQHsi7HrzLXYdXDDXhxvDlZB/AAacy2MsWvNBdizUlaecWdiz4a9NHZMMVaddV0Dj5k6V/7dnMYdzHlc7J+LlYvMWqn6nXKRT5zjdhzn+cR9bXQgt8VXHdvWdFMezuEij3NetdMaxb6O3cAzgP/EJpOlOW4FzgO+h01ymSxNjXSAygCMrI6Iuz0uh77+E6RAWib0YxNHs3hwRZGDgWnYDeZ+hK+ktg27GVuBTRTdju3cWIctuqzBdm5k5cZUbOLjAOz9cQC2G/Zo7P2zL2EW6jZhkyzXYQ9Sd2IP82sJ+8mbJ8xdY739dpY+ACPCtVtMCFs5K+tiwn2WVtHkY5rqLZxC/PvWW0Xq+td5HPAcrA17ozd9LcE2HN7Z4OPujZhwrRHKdO61x7H9a9toCZ2zQcQBM7B73IXYYsPR2NzXQVhodG/atIxgiwO3YyG0O7CNF2uwAOmqvTi2SKdxhGmblOV7slDPq3p+0/39ZOSw+cV9sUDIwdi18ijsWjmXcB1eBrDqQrdjQbTbsOvoUmwusVFCvCcqZOe9EPq+sZM/T0LOtWk+6KEi7DNnAfZ5tBg4vPbjUdj9fOh0wBpszvp27PPoXrZvsMxqCG28UNfAdv8smI5t3K+/745m+7Vw34Dn9dh76xZs7eR67LlyObZu0qggLNj1vpHXCX2GtTCXnD+roQf0nn2BzwH/Qmu1BhwEfh7F/tPALSNbClTGYqI4YXhzkZHNhVo4DVzUrp9/TbD90h1hZSnPwUo1d6c0ok6zCdvx8xng6of8rt7awSmQNjUKpGVSvQLWfOwzfHbt1Y3dUM/FJjvnYDfR9ZvFpPbrB2E76uqTKRFW/Wk1duNbr1SxAguhbcQewtbV/txmrA3nGtq/RHW76cce6OdjAcf9aq/6g9jO3h87E2H/9vdgi3PL2P7wtKL28/tos90kIiIiOwgZSLsV27k70ODjinSKPPZctD/2XNSDPTMtwDZl9GLPSgUefN8bY993K7H73AHs3nbLuF9fjYXTGrloICIi0mwxNhe0ELtWzqn9fC52jZyGzTUuYGJdX2Lsenk/Nme0EqtceA82V7QBC3Avx9YERUTqcthc9Tzsc2gWVgWp/pk0h+2VkRcwsXBMjK1p1Cv419c3lmHrHRtq/12/v9e9feepb2raD7vu7fi+m409N86t/bk9hZMjbD1tLXb924y9/9Zi17+12Pvt/trvacFVgsv5xr/NVmC9cJ+A3Sy2ih7gxUnVzQW+UZo29iccI0SeuJCQ76oQ5RIqIzmGNth9bxTre3QvJFj5x1VY6vsVpNPGq9PMAJ6HLfR/Bvgd4xP29cCg3toismceC7lu2sXvd2MPaDOxm+Vk3P8XA4uwiaTxgbSt2ENZhe1hozXY59RWsrMTUPbO5tqr3nYijz1U9WEPWHnsgWv8+2Nn6u+R5djD+irs/aKdMiIi0kkK2PUz1IZAXVdFpq6MzZOuGPdrDrvPLWHPTHN5aCAtwhbJ12GBtBG0OCUiIu2pykOvlTlsnmh+7ccS26+Xe1IPda/CrsNr0byiiExMBZtbXgPcOO7Xe7G11ZlsX++Yw8Q+U2Js/WRN7c/X11O2opVYMR4LJ27EKpbV9WHvuxnYc+NMbEP/nt53DmuhugF7ptyKhR07tRWyZECotpo3AD8H/p0wpa9DibF2FAckiTsQ+B5Vt6HQU6bYW4bIUxnO4WKPrziGNxdIqu6BqmlObT2n4g7gE1grkDcBx6U6ms5xKnAuVhL7J9gOIRGRRqqHXbdipe93dGXzhiIZV2b7w/j9tV/7Z3rDERERaSndWIuHEPM79UlzEWkcz/aQ2WZsd7qIiIhsV2H7ZkYRkbRtq72WpT0Q6SgDtdf9e/qDIlkXagftJuBLWMWKVnQk8FHgw8ARPnEkVUdSjojyCdMXbqNv30G6Zo7SNcNeUeypViKSqsMnSqZN0iDwXeD1wG9QO5BmOQB4F/A+4JQH/Y4b9xIREREREZGsKmGVRRsdSKtiE58KpImIiIiIiIiIiMikhQqkgVW++imt24e9C3gN8Hms/Wg3AB6ScoQDpu87yIz9t9G//za6Z41S6i3TNb1MrlglqSiYNgWXYFXSvoZ2iDZLH/AS7Gv+TOrv8/EcCqiJiIiIiIhkUw9wGI2f36liFZxEREREREREREREJi1kIG0Eq5J2a8BzNMPjga8ALwX6x/+GTyx05quOnrnDzFi8lf6DttIzd5h8d5Vcsbr9zyicNlFLsYpd7wRuT3coHeUE4OvAa7Hd9bumYJqIiIiIiEhWTAMOCnDcAeBuLJgmIiIiIiIiIiIiMikhA2kAq4DzgDWBzxPaYuDTwGdrP98lX3WUpo8x69DN9C0YJC5UiYv28n5cOM03ZdytagT4AfAC4I9oV3azzMFa1Z4LHL3HP62qaSIiIiIiImk7AquS1mjDwArUslNERERERERERESmIHQgzWPBomsCn6cZSliVtO8AjwNyD/pdP+4FOA+FngozF29l1uItzNh/gFypgos8US4BB97bS3bpOuDlwOeATSmPpVPkgecBPwKeDcQT+r/U1lNERERERKTZZgPHE2Zup14hTbMWIiIiIiIiIiIiMmmhA2kAW7BWgO3SfvEM4GvAm4CuXf0h7x04iPMJUc6TK1bp328bsw7ewqzFWyj2lfHe4RwPCbPJg6wCPg6cA9yV8lg6RQQcg7WqfTdWOW1yFEwTEREREREJbTZwEmGevgbQM7iIiIiIiIiIiIhMUTMCaQC/AX4LVJp0vtAOxII63wAO3eWf8jzQotN7R65YJVeqEhcT+uYPMeeQzXTNGLUWnrI7A8DPgecCv6Z93kdZNx94B/Bl4OQpHUFV00RERERERELZHzg90LFXA5sDHVtERERERERERETaXLMCaQDfBP7WxPOFNgN4AVb97clYq8PdeiCcljjiYpV8T4WeOSP0HzDAjAMH6J0/bL9fdQqpPZTHWni+FauYtird4XSMXuBZwH8DL2SiLTx3RuE0ERERERGRRpmGhdEKAY49Btwb4LgiIiIiIiIiIiLSIXJNPNedWJWr44F5TTxvSA44E2uTcR7wPWDNRP7HB4Jp+YRcsQoO8l1VolwCDnwC21Z3Ux2NH/g1AeAe4AvAHcBbgBPTHU5HyAOnAJ8CDsbCpSv26oj197Pa1IqIiIiIiEzFscBzAh17LXBzoGOLiIiIiIiIiIhIB4g/8KLuZp7vbiyM9rBmnrQJ5gLHAQuwwNS6yfzP3tcqokVQ6K6Q765SKFWJcp5Cb4XqWExltF6YyuFaOZzWmLEPY5PjNwLTsZDU1Ct3yUT1AScB+wLrgWV7fURHx1VOS8agss0R5cE1s0ZliyvmHCu3VvjxDVuoJmmPRkREREQkdU8GXhLo2HdhG5FWBjq+iIiIiIiIiIiItLlmB9LGgM3AIcABzTxxE/RgYZ3DsUDaMqA62YPUw2neOwo9FQq9FaLIExcSStPGwEF5OAcefCuG0xo73uXAVdjXeV+gv6FHl50pAkcBhwEjWOXDSb/PO5kCaVOjQJqIiIiIyAOOAl6NzT+EcCPwJaAS6PgiIiIiIiIiIiLS5prZsrPuCuC7WOvO6SmcP7RHAwuxydtfsRetDZOqpbdKM0YpzRzFRZ7RrQWi2BPFnmrFMbKlAEAUd2zvw6XAx7Bg1DnAyamOpjPkgDOwUNoBWLvaxuycHx9Y7Ni3tIiIiIiIyG49FnhCwOPfhW1AEhEREREREREREZmSZldIq1uOVRQ7LY2TN8Es4BFY4G4pk2zh+RDeQa1yWlxI6OofpdQ/Sr67QlKJiPOe6liEr1plNRzZrZwWZlyjwHVYG895wP6kE7bsND3A2cBMYBWwFmhc7ao2beOpCmlTowppIiIiIiKAbQ56E3BgoOPfDXwfe74WERERERERERERmZK04hDrgR8A/0zp/M3QD7wW+DrwGKDQkKN68IkjqUREsad/v23077+N0vQy+Z4qhb4KUewtnFZr/dlBLgdeAvwPFpCS8CLgZcDngScRIgjodniJiIiIiEgr6wa60h5Ei+oBnk3YzX13Yc/WIiIiIiIiIiIiIlOWVoU0gNXAINZmojFhrWzaD6siNYhVSxtq7OEdzkGpb4zuGaN0zxwhqUZUyzFxMcEBSTUC77JRNS38GIaBv2Khx8OAOcHPKACLsJ36Y8CttR/DaPFwmiqkTY0qpImIiIi0jacBZ2HPbFsBn+poWstLgNcA0wKe41fALwIeX0RERERERERERDpAmoE0gBVAHng46VVra4bp2IT7XKztxeZGn8BF9TadjkJ3le6Zo/TMHiHKJZSH8rjI45OIepIntXBac87rgRtrr0XAQU05q0wDHg8swEJpG4OfsQWDaQqkTY0CaSIiIiJtoRt4F/AO4FhgA3AfUE1zUC3iTOCdwBEBz3EPVs3+loDnEBERERERERERkQ6QdhxiE/AN4B8pj6MZerDdzD8Gntjog3u//eWihCiXQOQpTRtj9iGbmb5wkCj2RM4TRd4iW/VXe0qAi4GXYy08B9MdTseIgZcC3wGe0rSztnjVNBERERGRDnEWcHTt52cD3wT+GziJ9OcnsuwA4M3AqYHPcw2dMT8jIiIiIiIiIiIigaVdIQ0slLYEq6wUsu1EFsTAQuCRtf++Axhp/Gkc+NorgijnifMJxd4yXTNH6Zo+ythQjqQcW6W0ZoZ4mh8Y2oIF05YDhwKzmz6CzrQfcBpQAq6mmRUPHJkOqKlC2tSoQpqIiIhIy3PA24Enjfu1HuA47Bl5GrAUa+Mp2+0PfAp4JuGfcH4A/CHwOURERERERERERKQDZCGQBrAGq9X1MCzA0u76gVOw0M49wNqgZ/MOHMTFhDifEBcScl1VStPH6Jo1SlKJKA/m4YG2nwGlExAaw1pI3gjMBA5LZRSdZwYWSjsEuA1Yn8ooMhZMUyBtahRIExEREWl5pwGvBPbZ4dcdMBerkvZwbE5gCUE2b7WcA4BPAs/GNriFdDHwLWwzl4iIiIiIiIiIiMheyUogrYpVCzsIOILwE61Z0A0cie0GXw/cGfyMfnvltHwhIVdKyBUTcoWE0rQyUeQZG8g/5M829IULH3rbuQq22/6q2s+PAQqpjKSzFICjsLY827AAZvOqpY2XkWCaAmlTo0CaiIiISMt7C/BkILeL3y8BBwInYsG0aVg4arApo8ueA4BzsTDarr5mjfRl4GdNOI+IiIiIiIiIiIh0gGZMak7UBmyy9RCsUlonKAFnAvvWXj8CBppx4iTZnszJdVXI95bJlSrExUqwwJiLPJXRmG3ruyABHESRb3ZI6G7gw1gw6lXAsU09e2fKAWcD87G2qV8HNqY2mvr7zac2AhERERGRTnMI8CigOIE/W38+PgF4HPAn4HxgWbDRZUsB+1q9DngKzZm3uRy4rAnnERERERERERERkQ6RpUAawM3AF4CPYjujO8XBwEeAxcB5wC3NPLlPHD5xxIWE3rkBu6JEnupo/KCqUEMbi1RGY6Jc0szKaVuAbwD3Aq8GngTkm3b2zuSwioDvxr63v4C1URURERERkfYWY1W+JvuMv7D2egTwVCww9VfgRqzqdTuaATwPeClwShPP+1MUSBMREREREREREZEGykrLzvFuxnYEn4i1tewU3cBJwCJgE9Zesuk1nLx34V6Jw0VQ6itT7CtT7CkDjlyxiq9GVEbrnVqb0tazCtwFXAtEWKvYiezWl71TxN7nh2DBwBVAOZWRpNTCUy07p0YtO0VERERa1lzgHdgGlanoAw7HgmlHYdXTeoAhYFsjBpgB3Vib0jcD52CVpZvlCuB/gFVNPKeIiIiIiIiIiIi0uSwG0gBuAuYAJ2NhoU6Rw4JRp2CtO5cAY6mOKIB6OM17R6G3TNf0McDCaoXuKs5Za896kC1waGcDcBG2kLEImEUqMaWOsxhrweOxSnWDqY3E0dRwmgJpU6NAmoiIiEhLioEnAy8GevfyWAWsytqjgbOwYNqs2jnGgFFS2NS1l7qxzTr/CvwnVglub79Ok1EBPgT8sYnnFBERERERERERkQ6Q1UDaGHAPMB/bAd1pZgNPxAJqS4HNaQ4mqFrorNBdoat/lK4Zo0RxQrUckytViXOeajkGH7RqWgXbFX4vtnt/EbaoIWHNBs7AFpFuBzamOxyaEkxTIG1qFEgTERERaUl9wDtp/GazaVjl5WdiG10WAfna78XYM161gedrtD4sXPdM4IPAy7H5j2b7DfBV2nnOQURERERERERERFKR1UAaWOWqNVhrjkUpjyUNOSyscyCwvPZqtd3ek2BJIJ844kJC14xRumeOUuipUBmJcRFWVa1qf87V/5fGuhu4DNt5fzhq4dkMBWxx6mRgGdYmppLqiCBoME2BtKlRIE1ERESkJZ0GvAtrsRnKvlg7z+dildMOBvqxQFp9o1E54PknwgFd2GacI4AXAB8GXgIsTGlMS7FWqjemdH4RERERERERERFpY1kOpAHcDwxhLSynpzyWtBwGPArYCtxKtnd5N04tcRbFnq7pZUr9o5SHc3jviHIJHqusVk8ONbB62iashedGbKGgH7XwbIZFwNlYdcTbsHY76QsQTFMgbWoUSBMRERFpObOxNpSNro62KxFWZexk4BlYG8yTsU1evcAwdnefq/0Y8q6yfp4u7JnyMODfgDcC7wOeBMwjvWfNYeAzwP+RflhPRERERERERERE2lAu7QFMwM+xNoqfAEopjyUti4EvA8dik8bL0x1OE4yrBeeihDiC/oXb8N7hIs+2NV0MbSoSxR68VU+zP9yQsw8DX8F2ir8XeFzDjiy7sxCrEnA88AHgvlRHM179X7+NaxSKiIiIiDRYfdNJs+cd6ttK5mLBr/rGlyHgJuAWrDr2XdhmmLVsD6jVN4B5Jnb3H437MaodZyb2DH8w1lb0EcB+QDc2p5H2thQPXAB8FxhMdygiIiIiIiIiIiLSrlohkFYBvoO1+Hg/ndtGsRt4HVa16xNYFa+OYJXQIMrXNrA76Jk7TNeMUVzOM7q1wMDqbpxreFroEuC1wKuB12D/BhJWH/Dv2Pv8A8BfyFJVwPGxRIXTRERERER2pR94NlYFLE31VpldWNX1+VgF8iFsI9IosAZYCawC7sDmINYAq7HqYTsLkFWAadhzSx6rBrcAC6Htw/bwWS/Z21h3J7bxak3aAxEREREREREREZH21QqBNLB2ld8BDgBeQedWq8ph1br2A/679uqY5nUPVEED4lxCnE/AQdQ/SqGnTGUkZuvKXpIEnKNRAbW7gY8AtwPvwdq9SFgOOBWrCvgN4JvAhlRHtDOqmiYiIiIisisLgX8he3MODguIjQ+JHVT7cRSbe/BYWG0Ee97e2fyDx4Jo07DAWhELvWXt77ujZVgb1RvSHoiIiIiIiIiIiIi0t6xPlo63Cvgc23dax6mOJj0Rtgv7w8BhWAvPpWkOKA3euweCQFHsiQsVcsUqLh544Ne3remmPJzDRd7CaVOPMW7B2pksBd4IPBFbfJCwFgNvYXtVwNvTHc4uKJgmIiIiIjJeDngkcGjaA5mkIjAn7UEEtB7b9PNr9PQiIiIiIiIiIiIigcUfeFFLdSFcDywBjsd2XHeyLuzrcDCwGbiPDqqWtiOfOHBQ6KqS76qSL1WJ8gmF3gpd/aMk1YjyUK5WOW1qp8ACaTdjO+UPx/4NJKwe4BjgOOz7/x6y+j53TCj0mIxBZZsjyoPbWfMf2alizrFya4Uf37CFajbfASIiIiJijgTegapLZ8ka4AvA17DqbyIiIiIiIiIiIiJBtVogDWwidTlwCAqlxViVtCOxyml3YG1GOpb3Dp84vHcUSlUKPRXyPRXinCdXquJynrGhHHj7M1MIBK0FrgVWYzv+ZzX4ryAPFQH7AydhlemWYa10smkPwTQF0qZGgTQRERGRlvFM4HVpD0IekAA/AD6ObWYTERERERERERERCa4VA2keq5K2HngYMCPd4aTOAfsApwHTgLvQJDNQC6fVAmq5YpXitDK5QgIRFHutxWd5OMZX7c8x8eppw8DVwN1YIG1f1MKzGWZjobRZwEosFNhyFEibGgXSRERERFpCDntOf0zt55KuIeAnwOexjT0iIiIiIiIiIiIiTdGKgbS6O4Eq1rayL92hZEIX8AhgEVbFazVQSXVEWVILpkU5T2n6GKXpY+S7KyTViLhobT6rlYhqOcY5P9Fg2t3ADViluv2B3oB/AzHdWCjtcGAVcD9Zb+Hpxv03kIxCZVCBtMlSIE1ERESkJSTY82gF27jT6RvI0rQW+B7wWeC2lMciIiIiIiIiIiIiHaaVA2keuBIoAyegMFDdEdjXYwi4FxhJdzgZVAunOQel6WN09VtAjWpkQTTvqJYj8JYm2kM4bS1wGbAJtfBsFgccgFVdGMRa+G5Lc0B7VHsPOQe+DOUtDpev/brXayKvYmSBtJ/cqECaiIiISMZtBi7HqhrPAOYChTQH1IE2Ap8DPgWsSHksIiIiIiIiIiIi0oFaOZBW908sdHUCqpRWNx84Gwvp3QIMpDucDPPugVeht0L3rBHAkVQi4lJCFHmSSvTAn9lFOG0UuAr7Wh8ALMCqpklYfVgobRpWMXFjusPZMxdZvioZc0QlrEpaDC6n155ehYJjS6XK5fcPs3agmvY/pYiIiIjsXhm4CbgIq2w+HwunTawWteyNu4HPAN/EwoEiIiIiIiIiIiIiTeeqf2qbgk6vAd4PzEt7IBnzF+CDwNXAWLpDybja0oivVWRysWd0IM/Ayp4HKllVy7H9nvO7Wko5APt6PxsFJJslAf4KfAS4FMt8ZVv2R5hJXQXHkrVlXvSNldy2Sh9nIiIiIi0iBk4H3ohtKJme7nDalgduAN4H/BELAoqIiIiIiIiIiIikoh0qpNVdhU24no7agYy3GDgDa214K1BJdzjZFzmPc5Y3i/OeUv8Y3bNGKPaVKQ/m8In9ph8XKhpXOW0zcDFWretwoL+ZY+9QDnufPwrYAtyFVWTIrggbtV6TeiUe5k3Pcdbh3Vxy1xDrVSlNREREpBV44D7g/4AlWLW0eVhQTRXTGmMQ+DXwZlplk46IiIiIiIiIiIi0tXYKpIG17csDp2GRDzGzsKDevsA12GS17NK4BIyDKPa4COLYU+wr0zVjlMpIjupojItqYTT/oP99GLgea+G5P7AfWmhphpnAo4G5wO2oPU3bSTwk3jN/Wo6zDuvm0ruHWKdQmoiIiEirqGDP7L/HKnnNBBahZ/e9dRfwn8AXgHtTHouIiIiIiIiIiIgI0H6BtHoQCOARKAQ0XjdwInAKNkl9f7rDaSHe2QtHlPNEOU++u0JX/yjds0cgcZSH8turpNmPFeBurHJfATgUVe5rhiJwDHA8sBq4J9XRSEM5rDJhJfHs05/jkQd3c819I6zaosKPIiIiIi2iCgwAdwB/Ba4GeoADUTBtsjYD3wXehX0tt6U5GBEREREREREREZHx2i2QBhZKuxJYiwWwetIdTqZE2ET/ybWf3wmMpjqiVlMLp8X5hFwxIc57csWEQk+Z7pmj5IoJowMF8K4eUFsLXIuFow7BqgBIWHngIOBULBh4C2pV21Y8UK56Fs3KcdL+JW5dOcbyTfonFhEREWkhVWALFkz7J3A5FrA6EOhKb1gtYRD4C3AucB62ESpJdUQiIiIiIiIiIiIiO2jHQBrAGNYCZCMWSulNdziZMw84FliALQBsSnc4Lcg7vHf4xBHFnnxXlVypSq6YkC9VyPdUGBvMk1Qi8Aw4x8047gDmAweg6n3NMBs4E2vheTOwNd3hSKONlj2HLyjyj7uGuf5+ZWtFREREWlACbABuxaql/ZPtbSfnYJtNxGwFzgc+D3wNuASrNiciIiIiIiIiIiKSObm0BxDQCLZbOAI+gAWBZLuFwDnAIuBjWFU5mQLvwVetpSeRp2vmGL5qFdJ81UEEQxuLg+Wh3O+iXHK/c7weeDaqltYsZezzQNqMA7YNJwyXfdpDEREREZG944GVtdeFwK+BhwEnYJvMDgUKaQ0uZauBS7G2nH8DlmBfLxEREREREREREZHMatcKaXVVrFLaENa+U5XSHiwCDgeOw9p+rEDBnb3mEyt+VuytUKi9XOTJl6qQuDXlkdw1wDZwC5xjTrqjbWsbgC8CnwbWpzwWCcABhZzjtzds4+YVqpAmIiIi0ibGsGDalcBlWLXje7EK6GUsmNbubT3LwE3AH4HvAl8HLsC+BiIiIiIiIiIiIiKZ1+6BNLAWIFcDo1irxNmoXeKO9gVOwSb2l6MWng3hx7X1zHdVKE0fw8Ue5xgo9pSvcrFfUhmJZ4PbzznitMfbNqxWwCYcX8YCaRtSHY8Eo0CaiIiISNsbwiqC/R24CLgFuAvYjLWwrGIbz6J0htdQw9jf7R/Ar7AQ2leBq7C/r4iIiIiIiIiIiEjLaOeWneMlwJewXdUfwqqlyYPtB7wLOAr7Wt2IVU1TeK8BfGLBtFLfGKVpY7jIl8tDuT8MuO7VSSV6Y2U0fpxP3D4uUueVveG9w0V+pcN/xXv3dRRGExERERFpF2uBP9VeOezZ9TispedhwMzaaxbQQ/ZDaqNYxbP12MawG7HQ3eXAlvSGJSIiIiIiIiIiIrL3OiWQVvc7oAh8BGtVKQ9WAv4VOB74CdbCExRKaxjvHXgLqMXFxPfvv61SHs7dPLS+dFB5OJ5TrcQ5572+4lPhIcol6+Jc8sGkEn3HV6jo6ygiIiIi0pYqwA211/eAadgmq2OAI2uvg7HWnkWsilpP7edpqADbsE1fg8A6rNrbtcB1wG3AQEpjExEREREREREREWm4TgukAfwvNgn9QeCQdIeSWYcA7017EG3PA44k31Xx0xdui8a25aLBDSXKQ/l620kF0yYhyiVrCr3lT/tq9LNqOaqkPR4REREREWmarcDNtVfdNGAxsC/2jHtI7eeLsYBaHohrrwJWUc3Vfr0wwfN6oFx7eaw6+1jtv6tYpbPVWAW0O3d4jUzlLyoiIiIiIiIiIiLSCjoxkAbwI2xH8geA08h+K480KArVDJ4YAAeF3gpRfoihjSVGtxbwVVcPrcnuOIgL1ZWF7sqroij5fbmib2cREREREWErVn3sOmzuI8f2AFoROBDor70OxIJoeWABML/25zy7FmGVz1YCq2o/HwWWAmvG/TpYOK3+ShrxlxMRERERERERERHJsk4NpAH8BbgfeCvwypTHIp2uFjzLFRN65w6TKyQMbSpSHYuUR9sdB7li5bZCd+VNLuYvJPpqiYiIiIjIQ1Rqr/HW1X6MsSBafWdLrvbfE1Ued+x6hTSFzkRERERERERERKSjdXIgDeAO4MPAIPB6qFWrEklDbe99nPN0zxwlV6wytLHI2La8qqTtyIOLPblC9e8u4g1E3Jj2kEREREREpCXVK5eJiIiIiIiIiIiISIOotx0sBz6EVUobSHksIngPLk4o9pXpmzdM18xRXOR33yymk3iIcn4o3105z8X+NcCN+tqIiIiIiIiIiIiIiIiIiIiIZEOnV0ir2wx8BVgFfAxYnOpopOP5xOEc5Lqq9OSGifMJw5uKVEZjC6d1KO8hzif3FborX3FR8ovqWHxv5341REREROT/t3evMXKd9R3Hv8+5zMzu+hKMnQABcW+KEHekSoAKqlpVECogIkgJUpNQVQgkoCrwCgkhhCqEQJWCxAv6KkEGUpUWESdAxSUBYkJEruR+q4ntOCFZex1nd2dnzjlPXzxnicPVdtZ7dna+H+nR7jkz4/OzPPKrn/5/SZIkSZIkSZK08VhIe0oF/DewDHwI+Bug32kiTbUYgVTAYnbHkLxXs7zQZ+VYSYhM13zDSCroDeqby0H1b6FovtdU2ZNdx5IkSZIkSZIkSZIkSdLTWUh7ugq4krTG8wPAhcCOThNp6sUmELLIYNuIvGzIy4bh0T5NnUpam12MgaxoyLL4w7zXfDrvNXvregr+4pIkSZIkSZIkSZIkSRPIQtofdjPwGWA/8FHg7E7TaOrFmApY5UxNvrrCc6FHNSwgQAibdHFlhKKsH8v79VVNnX0pxnB7jIGQXpIkSZIkSZIkSZIkSdIGYyHtj5sHvgD8Gvg48Fqg7DKQFCOEMjL77GFbSuszWix+O0Vt04gQskjWa+7ozdaXx8hldcWjXceSJEmSJEmSJEmSJEnSn2Yh7c+7Argf+Ffg74FndxtHU6/tnfW3j8j7NUuH+6w80SOurrGc8G2WMUKWx5gV8breXPWZkMUfNaPN1LaTJEmSJEmSJEmSJEnavLKuA0yIG4EPA58FHuo4i5REKPo1W89cZm7nkLzfpNuTWt2K6eRlc7gY1LtDiO+JkR/idk5JkiRJkiRJkiRJkqSJYSHtxB0FLgXeA/wMGHYbR0pCHpndMWTrmUuUcxUhTFgprS2ikUE+qO/ubxl/MoT4wUh4vOtokiRJkiRJkiRJkiRJOjkW0k7eTcCFwBeBwx1nkZIMetvGbD1rif62EWGS1nYGCEWM/dnxlf0t1XlkXA4sdR1LkiRJkiRJkiRJkiRJJ89C2qnZD3weuAC4pdsoEhAhEClnKraetcyWM5fI8qbrVCekGNQP9maqjxH4p5DFu4Cq60ySJEmSJEmSJEmSJEk6NUXXASbYIvC/wAHgH4EPALs6TaSpFmMai5aXDbM7Vsh7kaX5AeOlPL1hI01Ni5CVDeVM/fW8bL7QVOGBpglPMkmrRiVJkiRJkiRJkiRJkvR7LKQ9c3cCXwKuAz4B/HW3cTTtYoSQw2DrCnlRs7QwYLjQI8ZACB03vtrHFzPVbaHgsixvvpnlzcP1ON9QfTlJkiRJkiRJkiRJkiSdGgtpa+Mx4EpgH2mN5/nAy7oMpOkWGyAEyrmKuWKZoqxZPjKgGmUQIqGD9leMgaLXrBT9+rK8rHbXVXZjjGFxdbKbJEmSJEmSJEmSJEmSJp+FtLX1K2A/8HPgEuAdQL/TRJpecbUEVpPvHJL3GpYO9xktFes6LS1GyPJYl71qb8j5VtGvvgYcjjEQ3NEpSZIkSZIkSZIkSZK0qVhIW3sLpGlpvwJuAv4O13iqQzEGCDA4Y0RWNiwf6TF8okesMkJ+Ggth7erQLG8OhhC/UczU32rG2S9jEyoyi2iSJEmSJEmSJEmSJEmbkYW002cf8DngauBfgLcALwSy7iJpasU0qaw3NyYva/KyYbjQb1d4snYrPCNEAiGLZEWzkJXx2iyP36lH4bIYQ71GT5EkSZIkSZIkSZIkSdIGZSHt9LsJ+Gfg3cDFpGlpsx3m0RSLTSArI3O7hhT9tMJzPCyIzTNf4RkjhBDJ8ricF829ednsJuOrsQ5H1yi+JEmSJEmSJEmSJEmSNjgLaetjBbgC2AN8EngXcA4w02UoTam2d9bfPiLvNSw9PmBlsaSp0mSzU/rzAoQ8VlkeD5Qz9Z6Qxf9oxuG2tRq8JkmSJEmSJEmSJEmSpMng+sj1tQh8Fvhb4CvAw6SymrT+IpQzFVues8jsjmXysvltWe1EPw8Q8kiWN4/35sZ7in59YYx8BLjtdESWJEmSJEmSJEmSJEnSxmYhbf01wDzwKeBtwFdJRbWmw0yaUjGSVnjuHLLtuYuUg7p94QQ+nEHI41IxU+0NeXw3MZwH3HA680qSJEmSJEmSJEmSJGljs5DWnRXgPtIKz3NJKz2XOk2k6RSBDHpbx2x73iKD7eP0P8OfKKVleRz35sbXzmwfnZ+X8Tzg+vYT9bpkliRJkiRJkiRJkiRJ0oZUdB1ArAA/A24nTUu7CHgfMNtlKE2ZtnxWzFRsOXOJvN9jeb5PPc4J2VPNtKxoqnJQ/SAr4qWRcFfI4n6aYAlNkiRJkiRJkiRJkiRJgIW0jaImrfH8CXAP8A3gvcAFwJYOc2nKxBjIezWzzxpSlDVLhweMFkvyXr1SztRXhyx+jSzemeXxnnociJETW+8pSZIkSZIkSZIkSZKkqWAhbWNpgEPAI8AdwB7gHcB5wK4Oc2mKxCaQ5ZHB9hF5L96zcqz6Xj3KbsiK+EtCvLepMmJmC02SJEmSJEmSJEmSJEm/z0LaxhSBg+25EfgB8BrgncBru4ulaRFj+CmBa8vZai8hXj882jvS1IEsC11HkyRJkiRJkiRJkiRJ0gZmIW3jOwj8F/A/wI9JpbS/At4A9DvMpc1nAbiV9D27msitMTKKdbuaU5IkSZIkSZIkSZIkSfozLKRNjhr4EXAtqYz2duDVwJuBszrMpclWAfuBW4CftOe29r4kSZIkSZIkSZIkSZJ0UiykTZ4auKE924GLgLcBL2+PU9N0Ip4A7icV0b5PWgt7uMtAkiRJkiRJkiRJkiRJmnwW0ibbUeBS4MukNZ6XAG8Eng/sBLLuomkDWgHmgYdI0/auIE1DkyRJkiRJkiRJkiRJktaEhbTNIQLXt+cM4B+A9wOvaK+3dRVMnauBY8AhYC9wFWntq9PQJEmSJEmSJEmSJEmStOYspG0+C8DXgf8EdgHnAxcDZwNzwKCrYFo3DVCRpqH9mDQN7RrgIGlKWuwsmSRJkiRJkiRJkiRJkjY1C2mbU92eA8BXgMtJ5bT3ARcALwZ6QOgqoNbcasnsKHADcCVwHfB/wCIw7iiXJEmSJEmSJEmSJEmSpoiFtM1vpT3zwL8Du4GtpGLaucDLSeU0Ta554KfA94FbSEXEeWC5w0ySJEmSJEmSJEmSJEmaQhbSpsux9kBa37ibtMbzL0mrPd8KzHYTTSehBm4H9pKmoD0IHAIeAYYd5pIkSZIkSZIkSZIkSdKUs5A2vR5rD8CNwM+BFwE7gTeSymmvAvIuwulpauBh4A7gVuAXpELhAeDR9nVJkiRJkiRJkiRJkiSpcxbSBDAC7m4PwHeBbwMvBLYDrwbeDLwMvzPr5RDp3+O+434+BOwHjnSYS5IkSZIkSZIkSZIkSfqjLBfpD5kHrjnu+rnAG4BzSCs+zwZeD/wFsG29w20yEThKmoC2jzT57NfAA6RVnPdhAU2SJEmSJEmSJEmSJEkTwkKaTsQhYE97IE1Nex2plPa89voFwIvb6zkgrH/MifAkac3m48BvSCW0+0gltHva65WOskmSJEmSJEmSJEmSJEnPiIU0nYqjpAlq17TXGfAiUkntFcBLgK3ADHAWaaLaDqC/vjE7E0nFsyPtOQY8QZqC9iCpdLav/f3RThJKkiRJkiRJkiRJkiRJp4GFNK2FhlSuevB37veAVwJvAl4KPAfYRSqmFaSiWgmcAQzaz0zCZLUGGLZnuT1DYEQqoO0jTZV7ALi//f1g+x5JkiRJkiRJkiRJkiRp07KQptNpBNzcnt/VA84FngW8Cth53MlJBbVI+o5u46miWr89q9er7ylPIV9sM8bj7o1J081W2mfE9l7T/txHKp09RiqaHQIeac/D7WuSJEmSJEmSJEmSJEnSVLKQpq6MgO+QSl8lae3n6gntqYDtwFtIBbYGeAFpstrqdU0qrD2/vXeiMlLpbB9pwtlq+WweuAk4QCq+rZDKZwvt63X73NVnr14fX2qTJEmSJEmSJEmSJEmSptL/A82iFvgR9xfVAAAAAElFTkSuQmCC"
                                    ></img>
                                  }
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {/* SunLight Screen */}
                      {value.financial_institution === "sunlight" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <Button
                                onClick={handleOpen}
                                startIcon={<Calculate />}
                                variant="contained"
                                fullWidth
                              >
                                Sunlight Financial Calculator
                              </Button>
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Loan Month</InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              required
                              disabled={true}
                              value={info?.term || " Loan Month"}
                            />
                          </FormControl> */}
                            {/* <CalcSunLightData>
                              <span>{info?.term || 0}</span>
                              <h5>Loan Term</h5>
                            </CalcSunLightData> */}
                          </Grid>
                          {/* finalMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalMonthlyPayment}

                          />
                        </Grid> */}
                          {/* finalEscalatedMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalEscalatedMonthlyPayment}

                          />
                        </Grid> */}
                          {/* monthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.monthlyPayment}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                monthlyPayment: calculator.monthlyPayment,
                              })
                            }
                          /> */}
                            {/* <CalcSunLightData>
                              <span>${Math.ceil(MONTH_PAY) || 0}</span>
                              <h5>Monthly payment for 1-17</h5>
                            </CalcSunLightData> */}
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.escalatedMonthlyPayment}
                            onChange={MonthChage}

                          /> */}
                            {/* <CalcSunLightData>
                              <span>
                                $
                                {Math.floor(
                                  calculator.escalatedMonthlyPayment
                                ) || 0}
                              </span>
                              <h5>Monthly payment for 18+</h5>
                              <p style={{ fontSize: "10px" }}>
                                Assuming tax credit is NOT applied to Solar
                              </p>
                            </CalcSunLightData> */}
                          </Grid>
                        </>
                        //     <>
                        //       <Grid item xs={18}>
                        //         <ClacButton>
                        //           <Calc
                        //             servicId={value.service_type_id}
                        //             totalAmount={totalAmount}
                        //           ></Calc>
                        //         </ClacButton>
                        //       </Grid>
                        //       {/* loan_years*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>{TheOffer?.term || 0}</span>
                        //           <p style={{ fontSize: "14px" }}>Loan Term</p>
                        //           <p style={{ fontSize: "10px" }}>Term in Years</p>
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* monthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.ceil(
                        //               resultFromPaymentCalc[0]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated initial monthly payment for 18 months */}
                        //             {resultFromPaymentCalc[0]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* escalatedMonthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[1]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months without paydown */}
                        //             {resultFromPaymentCalc[1]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months without paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* New In Good Leap */}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[2]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {" "}
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months with paydown */}
                        //             {resultFromPaymentCalc[2]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months with paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //     </>
                      )}
                      {value.financial_institution === "enfin" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <Enfin />
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Loan Month</InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              required
                              disabled={true}
                              value={info?.term || " Loan Month"}
                            />
                          </FormControl> */}
                            <CalcSunLightData>
                              <span>{enfinData?.term || 0}</span>
                              <h5>Loan Term</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* finalMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalMonthlyPayment}

                          />
                        </Grid> */}
                          {/* finalEscalatedMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalEscalatedMonthlyPayment}

                          />
                        </Grid> */}
                          {/* monthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.monthlyPayment}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                monthlyPayment: calculator.monthlyPayment,
                              })
                            }
                          /> */}
                            <CalcSunLightData>
                              <span>
                                ${Math.ceil(enfinData?.monthlyPayment) || 0}
                              </span>
                              <h5>Monthly payment for 1-17</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.escalatedMonthlyPayment}
                            onChange={MonthChage}

                          /> */}
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.floor(
                                  enfinData.escalatedMonthlyPayment
                                ) || 0}
                              </span>
                              <h5>Monthly payment for 18+</h5>
                              <p style={{ fontSize: "10px" }}>
                                Assuming tax credit is NOT applied to Solar
                              </p>
                            </CalcSunLightData>
                          </Grid>
                        </>
                        //     <>
                        //       <Grid item xs={18}>
                        //         <ClacButton>
                        //           <Calc
                        //             servicId={value.service_type_id}
                        //             totalAmount={totalAmount}
                        //           ></Calc>
                        //         </ClacButton>
                        //       </Grid>
                        //       {/* loan_years*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>{TheOffer?.term || 0}</span>
                        //           <p style={{ fontSize: "14px" }}>Loan Term</p>
                        //           <p style={{ fontSize: "10px" }}>Term in Years</p>
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* monthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.ceil(
                        //               resultFromPaymentCalc[0]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated initial monthly payment for 18 months */}
                        //             {resultFromPaymentCalc[0]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* escalatedMonthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[1]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months without paydown */}
                        //             {resultFromPaymentCalc[1]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months without paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* New In Good Leap */}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[2]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {" "}
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months with paydown */}
                        //             {resultFromPaymentCalc[2]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months with paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //     </>
                      )}
                      {/* SunLight Screen */}
                      {value.financial_institution === "dividend" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <FakeCalc />
                              {/* <Calc
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Calc> */}
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Loan Month</InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              required
                              disabled={true}
                              value={info?.term || " Loan Month"}
                            />
                          </FormControl> */}
                            <CalcSunLightData>
                              <span>{info?.term || 0}</span>
                              <h5>Loan Term</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* finalMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalMonthlyPayment}

                          />
                        </Grid> */}
                          {/* finalEscalatedMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalEscalatedMonthlyPayment}

                          />
                        </Grid> */}
                          {/* monthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.monthlyPayment}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                monthlyPayment: calculator.monthlyPayment,
                              })
                            }
                          /> */}
                            <CalcSunLightData>
                              <span>${Math.ceil(MONTH_PAY) || 0}</span>
                              <h5>Monthly payment for 1-17</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.escalatedMonthlyPayment}
                            onChange={MonthChage}

                          /> */}
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.floor(
                                  calculator.escalatedMonthlyPayment
                                ) || 0}
                              </span>
                              <h5>Monthly payment for 18+</h5>
                              <p style={{ fontSize: "10px" }}>
                                Assuming tax credit is NOT applied to Solar
                              </p>
                            </CalcSunLightData>
                          </Grid>
                        </>
                      )}
                      {/* Good Leap Screen */}
                      {value.financial_institution === "goodleap" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <CalcGoodLeadp
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              />
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{TheOffer?.term || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.ceil(
                                  resultFromPaymentCalc[0]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {/* Estimated initial monthly payment for 18 months */}
                                {resultFromPaymentCalc[0]?.paymentDescription}
                              </p>
                              {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.floor(
                                  resultFromPaymentCalc[1]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {/* Estimated adjusted monthly payment after 18
                                months without paydown */}
                                {resultFromPaymentCalc[1]?.paymentDescription}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months without paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* New In Good Leap */}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.floor(
                                  resultFromPaymentCalc[2]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {" "}
                                {/* Estimated adjusted monthly payment after 18
                                months with paydown */}
                                {resultFromPaymentCalc[2]?.paymentDescription}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                        </>
                      )}
                      {/* Mosaic */}
                      {value.financial_institution === "mosaic" ? (
                        <>
                          {/* <Grid container item columns={18} spacing={2}> */}
                          <Grid item xs={18}>
                            <ClacButton>
                              <Mosiac
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Mosiac>
                            </ClacButton>
                          </Grid>
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{payments?.totalPeriods / 12 || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}

                          {payments?.prePaymentAmount > 0 ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {CommaFormatted(
                                      Math.ceil(payments?.prePaymentAmount)
                                    )}
                                  </span>
                                  <p style={{ fontSize: "14px" }}>
                                    Extra payment
                                  </p>
                                  <p style={{ fontSize: "14px" }}>
                                    Before month 18
                                  </p>
                                </CalcSunLightData>
                              </Grid>
                              {mosaicPaymentWithPrePayment?.map((e, i) => {
                                return (
                                  <Grid
                                    item
                                    md={4.5}
                                    sm={9}
                                    xs={18}
                                    mb={3}
                                    key={i}
                                  >
                                    <CalcSunLightData>
                                      <span>
                                        {allMosiacData?.mosaic_is_ach ===
                                        true ? (
                                          <>
                                            $
                                            {CommaFormatted(
                                              Math.ceil(e?.monthlyPayment) || 0
                                            ) || 0}
                                          </>
                                        ) : (
                                          <>
                                            $
                                            {CommaFormatted(
                                              Math.ceil(
                                                e?.monthlyPaymentWithoutAchDiscount
                                              ) || 0
                                            ) || 0}
                                          </>
                                        )}
                                      </span>
                                      <p style={{ fontSize: "14px" }}>
                                        {/* Estimated initial monthly payment for 18 months */}
                                        {i === 0 ? (
                                          <>Before month 18</>
                                        ) : (
                                          <>After month 18</>
                                        )}
                                        {/* {i=== payments?.monthlyPayments[payments?.monthlyPayments.length-1]? <>Last </>:<></>} */}

                                        {/* {payments?.monthlyPayments[payments?.monthlyPayments.length-1] ? <>Last </>:<></>}  */}
                                        {/* {payments?.monthlyPayments[0] ? <>First</>:<></>} */}
                                        {/* {payments?.monthlyPayments[0] ? <>First</>:<></>}      */}
                                      </p>
                                      {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                                    </CalcSunLightData>
                                  </Grid>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {payments?.monthlyPayments
                                ?.slice(1, -1)
                                ?.map((e, i) => {
                                  return (
                                    <Grid
                                      item
                                      md={4.5}
                                      sm={9}
                                      xs={18}
                                      mb={3}
                                      key={i}
                                    >
                                      <CalcSunLightData>
                                        <span>
                                          {allMosiacData?.mosaic_is_ach ===
                                          true ? (
                                            <>
                                              $
                                              {Math.ceil(
                                                e?.monthlyPayment || 0
                                              ) || 0}
                                            </>
                                          ) : (
                                            <>
                                              $
                                              {CommaFormatted(
                                                Math.ceil(
                                                  e?.monthlyPaymentWithoutAchDiscount
                                                ) || 0
                                              ) || 0}
                                            </>
                                          )}
                                        </span>
                                        <p style={{ fontSize: "14px" }}>
                                          {/* Estimated initial monthly payment for 18 months */}
                                          {i === 0 ? (
                                            <>Before month 18</>
                                          ) : (
                                            <>After month 18</>
                                          )}
                                          {/* {i=== payments?.monthlyPayments[payments?.monthlyPayments.length-1]? <>Last </>:<></>} */}

                                          {/* {payments?.monthlyPayments[payments?.monthlyPayments.length-1] ? <>Last </>:<></>}  */}
                                          {/* {payments?.monthlyPayments[0] ? <>First</>:<></>} */}
                                          {/* {payments?.monthlyPayments[0] ? <>First</>:<></>}      */}
                                        </p>
                                        {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                                      </CalcSunLightData>
                                    </Grid>
                                  );
                                })}
                            </>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                      {/* Concert */}
                      {value.financial_institution === "concert" ? (
                        <>
                          {/* <Grid container item columns={18} spacing={2}> */}
                          <Grid item xs={18}>
                            <ClacButton>
                              <Concert
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Concert>
                            </ClacButton>
                          </Grid>
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{concertPayments?.term || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              {concertPayments?.loanType === "Choice" ? (
                                <>
                                  <span>$ 0</span>
                                  <p style={{ fontSize: "10px" }}>
                                    First{" "}
                                    {concertPayments?.calculations?.introTerm}{" "}
                                    month
                                  </p>
                                </>
                              ) : (
                                <>
                                  <span>$ 0</span>
                                  <p style={{ fontSize: "10px" }}>
                                    First 12 months
                                  </p>
                                </>
                              )}

                              {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          {concertPayments?.loanType === "Choice" ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {Math.ceil(
                                      concertPayments?.calculations
                                        ?.averageMonthlyFinancingPaymentWithoutPrepaymentPreReAm
                                    ) || 0}
                                  </span>
                                  <p style={{ fontSize: "10px" }}>
                                    Months 3-
                                    {
                                      concertPayments?.calculations
                                        ?.reAmortizationMonth
                                    }
                                  </p>
                                </CalcSunLightData>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}

                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.round(
                                  concertPayments?.calculations
                                    ?.averageMonthlyFinancingPaymentWithoutPrepayment ||
                                    0
                                ) || 0}
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {" "}
                                <p> (Without Prepayment )</p>
                                {concertPayments?.loanType === "Choice" ? (
                                  <>
                                    Months 19 -{concertPayments?.term * 12 || 0}
                                  </>
                                ) : (
                                  <>
                                    Months 13-
                                    {concertPayments?.term * 12 +
                                      concertPayments?.calculations
                                        ?.deferralMonth}
                                  </>
                                )}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                          {concertPayments?.prePaymentPercent > 0 ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {concertPayments?.loanType === "Zero" ? (
                                      <>
                                        {Math.round(
                                          concertPayments?.calculations
                                            ?.averageMonthlyFinancingPaymentWithPrepayment ||
                                            0
                                        ) || 0}
                                      </>
                                    ) : (
                                      <>
                                        {" "}
                                        {Math.round(
                                          concertPayments?.calculations
                                            ?.averageMonthlyFinancingPaymentWithPrepaymentPreReAm ||
                                            0
                                        ) || 0}
                                      </>
                                    )}
                                  </span>
                                  <p style={{ fontSize: "10px" }}>
                                    {" "}
                                    {concertPayments?.loanType === "Choice" ? (
                                      <>
                                        (With Prepayment )
                                        <p>
                                          {" "}
                                          Months 19 -
                                          {concertPayments?.term * 12 || 0}{" "}
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <p>(Without Prepayment )</p>
                                        Months 13-
                                        {concertPayments?.term * 12 +
                                          concertPayments?.calculations
                                            ?.deferralMonth}
                                      </>
                                    )}
                                  </p>
                                  {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                                </CalcSunLightData>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  )}
                </Grid>
              )}
              <ButtonContainer>
                <Button type="submit" variant="contained">
                  Add Solution
                </Button>
              </ButtonContainer>
            </form>
          </FormConatiner>

          {isLoading && <LoadingSoultion />}
          {isSuccess && (
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <ModelConatiner>
                  <div className="icon">
                    <CheckCircle />
                  </div>
                  <p>Solution has been created successfully</p>
                  <div className="btn_sucess">
                    <Button
                      variant="contained"
                      className="go_lead"
                      onClick={handleGoToLeads}
                    >
                      Go to Lead Profile
                    </Button>
                    {/* <Button
                      variant="contained"
                      className="add_lead"
                      onClick={handleAddLead}
                    >
                      Add New Solution
                    </Button> */}
                  </div>
                </ModelConatiner>
              </Box>
            </Modal>
          )}
        </>
      )}

      {isSingleLeadLoading && isCalc && isUtility && isPanle && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      {/* Hvacs */}
      <Modal
        open={openHvac}
        onClose={handleCloseHvac}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            HVAC Form
            <hr></hr>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form onSubmit={AddHvac}>
              <Grid container columns={18} spacing={2}>
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
              <span>No</span>
              <Switch
                checked={value.is_hvac}
                onChange={(e) =>
                  setValue({
                    ...value,
                    is_hvac: e.target.checked,
                  })
                }
                inputProps={{ "aria-label": "controlled" }}
              />
              <span>Yes</span>
            </Grid> */}
                {/* {value.is_hvac && ( */}
                <>
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of HVACS"
                        value={value.number_of_hvacs}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_hvacs: Number(e.target.value),
                          })
                        }
                      />
                    </Grid> */}
                  {/* Existing Electrical Panel*/}

                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        HVAC Location
                      </InputLabel>
                      <Select
                        required={true}
                        id="demo-simple-select"
                        value={singleHvac?.hvac_location || ""}
                        label="HVAC Location"
                        onChange={(e) =>
                          setSignleHvac({
                            ...singleHvac,
                            hvac_location: e.target.value,
                          })
                        }
                      >
                        {hvacLocations?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {singleHvac?.hvac_location === "new_location_electrical" ||
                  singleHvac?.hvac_location === "new_location_plumbing" ? (
                    <>
                      <Grid item md={6} sm={9} xs={18} mb={3}>
                        <TextField
                          fullWidth
                          label="Number HVAC FT"
                          value={singleHvac?.number_hvac_ft}
                          onChange={(e) =>
                            setSignleHvac({
                              ...singleHvac,
                              number_hvac_ft: Number(e.target.value),
                            })
                          }
                        />
                      </Grid>
                    </>
                  ) : null}

                  {/* Existing Electrical Panel*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        HVAC Horse Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleHvac?.hvac_horse_power}
                        label="  HVAC Horse Power"
                        required
                        onChange={(e) =>
                          setSignleHvac({
                            ...singleHvac,
                            hvac_horse_power: e.target.value,
                          })
                        }
                      >
                        {hvacHorsePower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button type="submit" style={{ color: "#4acfac" }}>
                      Add Hvac
                    </Button>
                  </Grid>
                </>
                {/* )} */}
              </Grid>
            </form>
          </Typography>
        </Box>
      </Modal>
      {/* Batteries */}
      <Modal
        open={openBattery}
        onClose={handleCloseBattery}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            <Grid container columns={18}>
              <Grid item lg={18}>
                Add Battery
              </Grid>
            </Grid>
          </Typography>
          <form onSubmit={AddBattery}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Grid container columns={18} spacing={2}>
                <>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Battery Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleBattery?.battery_power}
                        label="battery_power"
                        required
                        onChange={(e) =>
                          setSignleBattery({
                            ...singleBattery,
                            battery_power: e.target.value,
                          })
                        }
                      >
                        {betteryPower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="number_of_batteries"
                      required
                      value={singleBattery?.number_of_batteries}
                      onChange={(e) =>
                        setSignleBattery({
                          ...singleBattery,
                          number_of_batteries: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button
                      style={{ color: "#4acfac" }}
                      type="submit"
                      // onClick={async () => {}
                    >
                      Add Battery
                    </Button>
                  </Grid>
                </>
                {/* )} */}
              </Grid>
            </Typography>
          </form>
        </Box>
      </Modal>
      {/* Generators */}
      <Modal
        open={openGenerator}
        onClose={handleCloseGenerator}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            <Grid container columns={18}>
              <Grid item lg={18}>
                Add Generator
              </Grid>
            </Grid>
          </Typography>
          <form onSubmit={AddGenerator}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Grid container columns={18} spacing={2}>
                <>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Generator Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleGenerator?.generator_power}
                        label="Generator Power"
                        required
                        onChange={(e) =>
                          setSignleGenerator({
                            ...singleGenerator,
                            generator_power: e.target.value,
                          })
                        }
                      >
                        {generatorPower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Generators"
                      required
                      value={singleGenerator?.number_of_generators}
                      onChange={(e) =>
                        setSignleGenerator({
                          ...singleGenerator,
                          number_of_generators: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button style={{ color: "#4acfac" }} type="submit">
                      Add Generator
                    </Button>
                  </Grid>
                </>
              </Grid>
            </Typography>
          </form>
        </Box>
      </Modal>
      <Calc open={openSunLight} setOpen={setOpenSunLight} />
    </>
  );
};

export default SolarFormProposals;
